import dayjs from 'dayjs';
export { default as mergeEnvironments } from 'deepmerge';
import { useMemo, useRef, useState, useLayoutEffect } from 'react';
import { initReactI18next } from 'react-i18next';
import { QueryClient } from 'react-query';
import { init, setTag } from '@sentry/react';
import { init as init$1 } from '@elastic/apm-rum';
import ResizeObserver from 'resize-observer-polyfill';

var getCookie = function getCookie(name) {
  var value = "; " + document.cookie;
  var _value$split = value.split("; " + name + "="),
    cookie = _value$split[1];
  if (cookie) return cookie.split(';')[0];
  return '';
};
var setCookie = function setCookie(name, value, expireDays) {
  if (expireDays === void 0) {
    expireDays = 5000;
  }
  var date = new Date();
  date.setTime(date.getTime() + expireDays * 24 * 60 * 60 * 1000);
  var expires = "expires=" + date.toUTCString();
  document.cookie = name + "=" + value + "; " + expires + "; path=/;";
};
var deleteCookie = function deleteCookie(name) {
  document.cookie = name + "=; path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;";
};

var formatAMPM = function formatAMPM(hour) {
  var globalTime = dayjs().format('YYYY-MM-DD');
  return dayjs(globalTime + hour).format('hh:mm a');
};

function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

var getEnvs = function getEnvs(envs, keyStarWiths) {
  return Object.entries(envs).reduce(function (result, _ref) {
    var key = _ref[0],
      value = _ref[1];
    if (keyStarWiths.some(function (keyStarWith) {
      return key.startsWith(keyStarWith);
    })) {
      var _extends2;
      return _extends({}, result, (_extends2 = {}, _extends2[key] = JSON.stringify(value), _extends2));
    }
    return result;
  }, {});
};

var regex = /[^\dkK]/g;
var validateChileanRut = function validateChileanRut(rut) {
  var unFormattedRut = rut.replace(regex, '');
  var body = unFormattedRut.slice(0, -1);
  if (body.length < 7 || body.length > 9) {
    return false;
  }
  var verifierDigit = unFormattedRut.slice(-1).toUpperCase();
  var sum = 0;
  var mul = 2;
  for (var i = 1; i <= body.length; i += 1) {
    var index = mul * parseInt(unFormattedRut.charAt(body.length - i), 10);
    sum += index;
    if (mul < 7) {
      mul += 1;
    } else {
      mul = 2;
    }
  }
  var expectedVerifierDigit = 11 - sum % 11;
  verifierDigit = verifierDigit === 'K' ? '10' : verifierDigit;
  verifierDigit = parseInt(verifierDigit, 10) === 0 ? '11' : verifierDigit;
  return expectedVerifierDigit === parseInt(verifierDigit, 10);
};

var environments = {
  NODE_ENV: process.env.NODE_ENV,
  ENV_TYPE: process.env.BUSINESS_ENV_TYPE,
  COOKIE_SESSION: process.env.BUSINESS_COOKIE_SESSION,
  URL: {
    DOMAIN: process.env.BUSINESS_DOMAIN_URL,
    API_V1: process.env.BUSINESS_API_URL,
    API_V2: process.env.BUSINESS_API_URL_V2,
    FRONTEND_MONOLITH: process.env.BUSINESS_FRONTEND_MONOLITH
  },
  COGNITO: {
    COOKIE_NAME_COGNITO: process.env.BUSINESS_COOKIE_NAME_COGNITO,
    USER_POOL_ID_COGNITO: process.env.BUSINESS_USER_POOL_ID_COGNITO,
    CLIENT_ID_COGNITO: process.env.BUSINESS_CLIENT_ID_COGNITO,
    FRONTEND_COOKIE: process.env.BUSINESS_FRONTEND_COOKIE
  },
  SENTRY: {
    KEY: process.env.BUSINESS_SENTRY_KEY,
    ORG: process.env.BUSINESS_SENTRY_INTERNAL_ORG,
    PROJECT: process.env.BUSINESS_SENTRY_INTERNAL_PROJECT
  },
  INTERCOM: {
    APP_ID: process.env.BASE_INTERCOM_APP_ID
  }
};

var regExp = /*#__PURE__*/new RegExp(/\B(?=(\d{3})+(?!\d))/g);
var defCurrency = {
  unit: '$',
  precision: 0,
  delimiter: '.',
  separator: ','
};
var formatNumber = function formatNumber(number, currency) {
  return number.split(currency.separator)[0].replace(regExp, currency.delimiter);
};
var formatPriceToNumber = function formatPriceToNumber(_ref) {
  var number = _ref.number,
    _ref$currency = _ref.currency,
    currency = _ref$currency === void 0 ? defCurrency : _ref$currency,
    _ref$showUnit = _ref.showUnit,
    showUnit = _ref$showUnit === void 0 ? true : _ref$showUnit;
  var formattedNumber = String(number).split(currency.delimiter).join('');
  var result = formattedNumber.replace(currency.separator, '.');
  if (Number.isNaN(Number(result.split('.')[1]))) {
    return showUnit ? Number(result.replace(currency.unit, '')).toFixed(1) : Number(result).toFixed(2);
  }
  return showUnit ? Number(result.replace(currency.unit, '')) : Number(result);
};
var useFormatPrice = function useFormatPrice(options) {
  var _ref2 = options || {},
    _ref2$currency = _ref2.currency,
    currency = _ref2$currency === void 0 ? defCurrency : _ref2$currency,
    _ref2$usePrecision = _ref2.usePrecision,
    usePrecision = _ref2$usePrecision === void 0 ? true : _ref2$usePrecision,
    _ref2$showUnit = _ref2.showUnit,
    showUnit = _ref2$showUnit === void 0 ? true : _ref2$showUnit;
  var formatPrice = useMemo(function () {
    return function (number) {
      var formattedNumber = String(number).replace('.', currency.separator);
      if (usePrecision) {
        formattedNumber = String(parseFloat(Math.abs(Number(number) || 0).toFixed(currency.precision))).replace('.', currency.separator);
      }
      var _formattedNumber$spli = formattedNumber.split(currency.separator),
        integerPart = _formattedNumber$spli[0],
        decimalPart = _formattedNumber$spli[1];
      var formattedInteger = formatNumber(integerPart, currency);
      if (decimalPart === undefined || Number(decimalPart) === 0) {
        return showUnit ? "" + currency.unit + formattedInteger : formattedInteger;
      } else {
        return showUnit ? "" + currency.unit + formattedInteger + currency.separator + decimalPart : "" + formattedInteger + currency.separator + decimalPart;
      }
    };
  }, [currency, usePrecision, showUnit]);
  return formatPrice;
};

var i18n = {
  init: function init(_ref) {
    var i18n = _ref.i18next,
      resources = _ref.resources;
    return i18n.use(initReactI18next).init({
      resources: resources,
      fallbackLng: 'es',
      nsSeparator: false,
      debug: environments.NODE_ENV !== 'production',
      interpolation: {
        escapeValue: false
      }
    });
  }
};

var queryClient = /*#__PURE__*/new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 2
    }
  }
});

var sentry = {
  init: function init$1(projectName, sentryOpts) {
    if (environments.NODE_ENV === 'production') {
      init(_extends({
        dsn: "https://" + environments.SENTRY.KEY + "@" + environments.SENTRY.ORG + ".ingest.sentry.io/" + environments.SENTRY.PROJECT,
        environment: environments.NODE_ENV
      }, sentryOpts != null ? sentryOpts : {}));
      setTag('app', projectName);
    }
  }
};

var apm = {
  init: function init(_ref) {
    var serviceName = _ref.serviceName,
      serverUrl = _ref.serverUrl,
      serviceVersion = _ref.serviceVersion;
    init$1({
      // Set required service name (allowed characters: a-z, A-Z, 0-9, -, _, and space)
      serviceName: serviceName,
      // Set custom APM Server URL (default: http://localhost:8200)
      serverUrl: serverUrl,
      // Set service version (required for sourcemap feature)
      serviceVersion: serviceVersion,
      apmRequest: function apmRequest(_ref2) {
        var xhr = _ref2.xhr;
        xhr.setRequestHeader('Authorization', '16C373SY1zem7d1VvyQZ0n7I');
        return true;
      }
    });
  }
};

var regExp$1 = /*#__PURE__*/new RegExp(/\B(?=(\d{3})+(?!\d))/g);
// eslint-disable-next-line no-useless-escape
var cleanDni = function cleanDni(dni) {
  return dni.replace(/[\.\-]/g, '');
};
var formatDni = function formatDni(dni, country) {
  var formatted = '';
  var dniString = dni.toString();
  var cleaned = cleanDni(dniString);
  if (country === 'cl' && cleaned.length >= 2) {
    formatted = cleaned.slice(0, -1).replace(regExp$1, '.') + "-" + cleaned.slice(-1);
  } else {
    formatted = "" + cleaned.replace(regExp$1, '.');
  }
  return formatted;
};

var useGetNavbarHeight = function useGetNavbarHeight() {
  var element = useRef(null);
  var _useState = useState(0),
    navbarHeight = _useState[0],
    setNavbarHeight = _useState[1];
  useLayoutEffect(function () {
    var elementInterval;
    var observer;
    var updateHeight = function updateHeight() {
      if (element.current) {
        observer = new ResizeObserver(function (entries) {
          if (entries && entries.length) {
            setNavbarHeight(entries[0].contentRect.height);
          }
        });
        observer.observe(element.current);
        return function () {
          observer.disconnect();
        };
      }
      return function () {};
    };
    element.current = document.getElementById('NavBar');
    if (!element.current) {
      elementInterval = setInterval(function () {
        element.current = document.getElementById('NavBar');
        if (element.current) {
          clearInterval(elementInterval);
          updateHeight();
        }
      }, 1000);
    } else {
      updateHeight();
    }
    return function () {
      clearInterval(elementInterval);
      if (element.current && observer) {
        observer.disconnect();
      }
    };
  }, []);
  return navbarHeight;
};

var mockedCompanySettings = {
  companySettings: {
    hasBookingsFromMarketplace: "one",
    id: 3,
    signature: null,
    email: false,
    sms: false,
    companyId: 3,
    createdAt: "2022-02-16T13:16:26.400Z",
    updatedAt: "2022-04-25T03:00:19.039Z",
    beforeBooking: 1,
    afterBooking: 6,
    beforeEditBooking: 3,
    activateSearch: true,
    activateWorkflow: true,
    clientExclusive: true,
    providerPreference: 0,
    calendarDuration: 15,
    extendedScheduleBool: false,
    extendedMinHour: "2000-01-01T09:00:00.000Z",
    extendedMaxHour: "2000-01-01T20:00:00.000Z",
    scheduleOvercapacity: true,
    providerOvercapacity: true,
    resourceOvercapacity: true,
    bookingConfirmationTime: 1,
    maxChanges: 2,
    bookingHistory: true,
    staffCode: false,
    monthlyMails: 0,
    dealActivate: false,
    dealName: "",
    dealOvercharge: true,
    dealExclusive: false,
    dealQuantity: 0,
    dealConstraintOption: 0,
    dealConstraintQuantity: 0,
    dealIdentificationNumber: false,
    allowsOnlinePayment: true,
    accountNumber: "",
    companyRut: "76.233.336-8",
    accountName: "",
    accountType: 3,
    bankId: null,
    dealRequired: false,
    onlinePaymentCapable: true,
    allowsOptimization: true,
    activateNotes: true,
    receiptRequired: true,
    onlinePaymentCommission: 3.332,
    promoCommission: 10.0,
    promoOffererCapable: false,
    canEdit: true,
    canCancel: true,
    useIdentificationNumber: false,
    presetNotes: null,
    paymentClientRequired: true,
    showCashes: true,
    editablePaymentPrices: false,
    mandatoryMockBookingInfo: false,
    strictBooking: false,
    mailsBaseCapacity: 25000,
    bookingLeap: 15,
    allowsOverlapHours: false,
    requireCashierCode: false,
    activateApiPost: false,
    activateSurvey: false,
    afterSurvey: null,
    lookupHourMethod: 0,
    colorNormal: null,
    activateCustomColor: false,
    colorLight: "fd6767",
    colorMedium: "fd9610",
    requireFileCode: false,
    bookingAbove: true,
    billing: true,
    pageSize: "Impresora Fiscal",
    productsHasSalesTaxes: false,
    setLocationBillingInfo: false,
    setLocationReceiptNumber: false,
    receiptClientName: true,
    receiptClientPhone: true,
    receiptClientEmail: true,
    receiptCashier: true,
    receiptActivity: true,
    receiptIdentificationNumberClient: true,
    coHealthEngine: false,
    followSalesCash: true,
    weeklySummaryNotification: true,
    chartRequired: false,
    birthdayText: null,
    birthdayMail: false,
    birthdayUrl: "https://negociodeteamarquitectura.agendaprodev.com/cl",
    chartPrintType: "complete",
    chartPrintSize: "letter",
    timezone: "America/Santiago",
    whatsappNotification: false,
    smsNotification: true,
    facebookCustomTracker: "",
    remindExpiringMembership: true,
    delimiter: ".",
    separator: ",",
    unit: "$",
    decimal: 0,
    googleCustomTracker: "",
    mockbookingCommission: true,
    assistForCommission: false,
    payedForCommission: true,
    monthlyMessages: 0,
    messagesBaseCapacity: 0,
    pagoFacilServiceId: "",
    pagoFacilPlanServiceId: "",
    providerPayment: "pagoFacil",
    providerSubscriptionMethod: "kushki",
    hasAgendaboostActivated: false,
    agendaboostId: null,
    availableInvoiceProvider: "",
    hasDecimals: false,
    afterBookingCallToAction: true,
    clientAutoincrement: true,
    clientLastRecordNumber: 1,
    whatsappMaxQuantity: 50,
    membershipOnlinePayment: false,
    activateVideocalls: true,
    videocallProvider: "twilio",
    validateEmail: false,
    validatePhone: true,
    clientByName: true,
    clientByPhone: true,
    clientByEmail: true,
    clientById: true,
    searchFrom: 3,
    publicKeyEpayco: "",
    clientInfo: false,
    giftcardsSaleActivated: true,
    giftcardsIvaActivated: false,
    activateCustomGiftcard: false,
    providerOnlinePayment: "pagoFacil",
    privateKeyEpayco: "",
    searchPreference: "services",
    policyTerm: null,
    policyTermActive: null,
    enableVideocalls: true,
    maxVideocallsMinutes: 2500,
    smsMaxQuantity: null,
    postPayment: false,
    paymentCardRetryAcount: 0,
    subscriptionFailed: false,
    preFactura: false,
    onlinePaymentReceiptType: 3,
    defaultPaymentReceiptType: 1,
    onlinePaymentFixedCommission: 0.0,
    onlinePaymentAutomaticDte: false,
    onlinePaymentThreeDsecure: true,
    providerPos: "",
    isSolo: false,
    salesDesktop: false,
    onlineCancelationPolicy: {
      id: 2191,
      cancelable: false,
      modifiable: true,
      createdAt: "2022-02-16T13:16:26.502Z",
      updatedAt: "2022-02-16T13:16:26.502Z",
      cancelMax: 24,
      modificationMax: 2,
      minHours: 1,
      modificationUnit: 1,
      cancelUnit: 1,
      companySettingId: 1742
    }
  },
  company: {
    id: 3,
    name: "Negocio de Team Arquitectura",
    webAddress: "negociodeteamarquitectura",
    logo: {
      url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png",
      email: {
        url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png"
      },
      thumb: {
        url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png"
      },
      page: {
        url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png"
      }
    },
    monthsActiveLeft: 0.0,
    planId: 3,
    paymentStatusId: 1,
    createdAt: "2022-02-16T13:16:26.379Z",
    updatedAt: "2022-04-07T03:27:37.315Z",
    description: "",
    cancellationPolicy: "",
    dueAmount: 0.0,
    dueDate: null,
    owned: true,
    showInHome: false,
    countryId: 1,
    activateI18n: false,
    salesUserId: null,
    trialMonthsLeft: 0,
    defaultPlanId: 9,
    secretKey: "42ya53mprlfzgva5u677rpc98rynwqwh6wgmwhni8hwa",
    endTrial: true,
    endDate: "2022-04-07",
    generateBilling: true,
    billingPlatformId: "",
    billingDay: 23,
    currentBillingDate: "2022-02-23",
    currentBillingValue: 0.0,
    currentBillingLocation: 1,
    employeeNumber: "6-15",
    initDate: "2022-02-16T13:16:35.021Z",
    creationDeviceType: "desktop"
  },
  railsProps: {
    isPublicPage: false,
    identificationTypes: [["NIT", "NIT"], ["CC", "CC"], ["CE", "CE"], ["PA", "PA"]],
    receiptType: [{
      id: 1,
      name: "Boleta",
      createdAt: "2015-06-30T21:42:53.702Z",
      updatedAt: "2015-06-30T21:42:53.702Z"
    }, {
      id: 38,
      name: "Boleta de servicios",
      createdAt: "2021-12-15T13:05:07.761Z",
      updatedAt: "2021-12-15T13:05:07.761Z"
    }, {
      id: 4,
      name: "Boleta de Servicios",
      createdAt: "2015-06-30T21:42:53.753Z",
      updatedAt: "2015-06-30T21:42:53.753Z"
    }, {
      id: 2,
      name: "Factura",
      createdAt: "2015-06-30T21:42:53.748Z",
      updatedAt: "2015-06-30T21:42:53.748Z"
    }, {
      id: 3,
      name: "Otro",
      createdAt: "2015-06-30T21:42:53.751Z",
      updatedAt: "2015-06-30T21:42:53.751Z"
    }],
    translationsLocale: {
      selectPlan: {
        authorization: "Autorización voluntaria de envío de DTEs por Email",
        sentAproved: "Acepto el envío electrónico de factura o boleta por mail a: ",
        viewPlans: null,
        ourPlans: "Nuestros Planes",
        pickPlan: "Elige el plan que mejor se acomode a tus necesidades o contáctanos si necesitas uno a tu medida."
      },
      plans: {
        taxName: "IVA"
      },
      number: {
        currency: {
          format: {
            delimiter: ".",
            format: "%u %n",
            precision: 0,
            separator: ",",
            significant: false,
            stripInsignificantZeros: false,
            unit: "$"
          }
        }
      },
      receiptGiftcard: "Comprobante ingreso Gift card",
      receiptTypePrint: {
        boleta: "Boleta",
        factura: "Factura",
        "boleta de servicios": "Boleta de servicios",
        otros: "Otros",
        otro: "Otro"
      },
      receiptsPrint: {
        clientName: "Nombre",
        quantity: "C",
        itemName: "NOMBRE",
        clientIdentificationNumber: "RUT",
        itemPrice: "PRECIO",
        totalItem: "TOTAL",
        baseImport: "IMPORTE BASE",
        totalToPay: "TOTAL A PAGAR",
        payedBy: "Pagado en",
        attendedBy: "Atendido por",
        "sin información": "Sin información"
      },
      longDays: ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"],
      shortDays: ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"],
      country: {
        name: "Chile",
        domain: ".com/cl"
      },
      district: "comuna",
      ditricts: "comunas",
      districtMessages: {
        created: "Comuna creada exitosamente",
        updated: "Comuna actualizada exitosamente",
        withResidence: "Comuna de residencia",
        "new": "Nueva comuna",
        select: "Selecciona tu comuna",
        serviceAddressExclusive: "Si el servicio no pertenece a una sucursal exclusivamente a domicilio, recomendamos ingresar las comunas que se atienden en la descripción."
      },
      city: "Ciudad",
      cities: "Ciudades",
      identificationTypes: ["NIT", "CC", "CE", "PA"],
      ci: "RUT",
      identificationNumber: "RUT",
      identificationNumberOnCharts: "RUT",
      indentificationNameBilling: "RUT",
      indentificationClientNameBilling: "Rut",
      providerCode: "Código de colegiatura",
      activityBilling: "Giro",
      currencyCode: "CLP",
      taxesPrint: "I.V.A.",
      taxes: true,
      taxName: "IVA",
      taxNameReceipt: "IVA",
      region: "Region",
      planExtraLocation: {
        personal: 19900,
        normal: 34900,
        premium: 59900,
        pro: 99900
      },
      phones: {
        sales: "+56 2 2585 6963",
        support: "+56 2 2585 6963"
      },
      deletePosPayment: "No puedes eliminar pagos realizados a través de AgendaPro",
      menu: {
        summary: "Resumen",
        calendar: "Calendario",
        sales: "Ventas",
        products: "Productos",
        clients: "Clientes",
        reports: "Reportes",
        administration: "Administración",
        invoicedSales: "Ventas Facturadas",
        payment: "Pagos",
        downPayments: "Abonos",
        budget: "Presupuestos",
        plans: "Planes",
        commissionReport: "Reporte de Comisiones",
        giftCards: "Gift Cards",
        saleBoxes: "Caja de Ventas",
        rips: "RIPS",
        onlinePayments: "Pagos en Línea",
        inventory: "Inventario",
        history: "Historial",
        clientsBase: "Base de Clientes",
        emailMarketing: "Reporte de Campañas",
        locations: "Locales",
        serviceProviders: "Prestadores de Servicios",
        services: "Servicios",
        commissions: "Comisiones",
        resources: "Recursos",
        survey: "Encuestas",
        customApp: "App Personalizada",
        shifts: "Turnos",
        consents: "Consentimientos",
        companyPanel: "Panel Empresa",
        editProfile: "Editar Perfil",
        academy: "Academia AgendaPro",
        goToBookingSite: "Ver Sitio",
        payMyPlan: "Pagar",
        logout: "Cerrar Sesión",
        configurations: "Configuraciones",
        users: "Usuarios",
        accountAndBilling: "Cuenta y Facturación",
        customization: "Personalización",
        profile: "Perfil",
        surveyAnswers: "Reporte de Encuestas",
        marketingBlacklist: "Lista de E-mails suprimidos",
        managementControl: "Control de Gestión",
        general: "General",
        roles: "Roles",
        paymentsStatus: "Estado de Pagos",
        bookingStatuses: "Estados de Reserva",
        plansManagement: "Gestión de Planes",
        numericParameters: "Parámetros Numéricos",
        transferencesOnline: "Transferencias (pago en línea)",
        transferencesPay: "Transferencias (pago plan)",
        banks: "Bancos",
        promotions: "Promociones",
        receipts: "Recibos de Pago",
        paymentMethods: "Medios de Pago",
        paymentMethodsTypes: "Tipos de Medio de Pago",
        places: "Lugares",
        countries: "Países",
        regions: "Regiones",
        cities: "Ciudades",
        districts: "Comunas",
        searchEngine: "Buscador",
        economicSector: "Sector Económico",
        marketplaceCategories: "Categorías Marketplace",
        tags: "Tags",
        myAgenda: "Mi Agenda",
        mobileReports: "Reporte de mensajería móvil",
        reservationReports: "Reporte de reservas",
        activateHere: "Activar aquí"
      },
      messages: {
        whatsapp: "WhatsApp",
        sentMessages: "MENSAJES ENVIADOS",
        confirmedMessages: "MENSAJES CONFIRMADOS",
        sent: "Enviados",
        confirmations: "Confirmaciones",
        inRespectOfPreviousPeriod: "Con respecto al periodo anterior",
        totalReservationsWithoutConfirmation: "Total de reservas sin confirmación",
        reservationsWithoutConfirmation: "Reservas sin confirmación",
        mobileConfirmedMessages: "Mensajes confirmados por mensajería móvil",
        history: {
          clientName: "Nombre Cliente",
          location: "Local",
          reservationDate: "Fecha de reserva",
          type: "Tipo",
          messageDate: "Fecha de Mensaje",
          messageStatus: "Estado de mensaje",
          noInfo: "Sin Info"
        }
      },
      servicePriceDefault: {
        price: 15000
      },
      timeZoneDefault: {
        timezone: "America/Santiago"
      },
      activerecord: {
        views: {
          selectPlan: {
            attributes: {
              phone: "Teléfono:",
              email: "E-Mail:",
              name: "Razón Social:",
              rut: "RUT:",
              rutEmpresa: "RUT Empresa:",
              rutPersonaNatural: "RUT:",
              sector: "Giro:",
              contact: "Nombre:",
              additionalInfo: "Información Adicional:",
              address: "Dirección:",
              district: "Comuna",
              city: "Ciudad"
            }
          }
        }
      }
    },
    translationDefault: {
      activerecord: {
        attributes: {
          "doorkeeper/application": {
            name: "Nombre",
            redirectUri: "URI de redirección",
            scopes: "Ámbitos"
          },
          client: {
            recordNumber: "N° de Cliente",
            onlineBooking: "Reservas en línea"
          },
          companySetting: {
            activateWorkflow: "Reservas en línea"
          },
          location: {
            active: "Activo",
            onlineBooking: "Reservas en línea"
          },
          locationResolution: {
            resolutionNumber: "Número de resolución",
            "initial number": "Rango inicial",
            "actual number": "Comprobante actual"
          },
          service: {
            active: "Activo",
            onlineBooking: "Reservas en línea"
          },
          serviceProvider: {
            active: "Activo",
            onlineBooking: "Reservas en línea"
          }
        },
        errors: {
          models: {
            "doorkeeper/application": {
              attributes: {
                redirectUri: {
                  fragmentPresent: "no puede contener un fragmento.",
                  invalidUri: "debe ser una URI válida.",
                  unspecifiedScheme: "debe especificar un esquema.",
                  relativeUri: "debe ser una URI absoluta.",
                  securedUri: "debe ser una URI HTTPS/SSL.",
                  forbiddenUri: "está prohibido por el servidor."
                },
                scopes: {
                  notMatchConfigured: "doesn't match configured on the server."
                }
              }
            },
            receipt: {
              onlyReceiptWithGiftcards: "Comprobante ingreso Gift Card no puede contener un item q no sea una gift card",
              atLeastOneItem: "La boleta debe tener al menos un item asignado"
            }
          },
          format: "%{attribute} %{message}",
          messages: {
            accepted: "debe ser aceptado",
            blank: "no puede estar en blanco",
            confirmation: "no coincide con la confirmación",
            empty: "no puede estar vacío",
            equalTo: "debe ser igual a %{count}",
            even: "debe ser par",
            exclusion: "está reservado",
            greaterThan: "debe ser mayor que %{count}",
            greaterThanOrEqualTo: "debe ser mayor que o igual a %{count}",
            inclusion: "no está incluido en la lista",
            invalid: "no es válido",
            lessThan: "debe ser menor que %{count}",
            lessThanOrEqualTo: "debe ser menor que o igual a %{count}",
            mustExists: "No existe el registro %{id} en %{model}",
            mustBeActive: "%{model} no tiene activo [%{property}] en el registro %{id}",
            mustBelongsTo: "El registro %{id} en %{model} no pertenece a %{foreignModel} con registro %{foreignValue}",
            mustHaveManyThrough: "El %{modelA} con id %{foreignAValue} y %{modelB} con id %{foreignBValue} no existe en %{model}",
            mustBetweenDate: "La fecha %{date} debe estar entre %{dateMin} y %{dateMax}",
            notANumber: "no es un número",
            notAnInteger: "debe ser un entero",
            odd: "debe ser impar",
            recordInvalid: "La validación falló: %{errors}",
            taken: "ya está en uso",
            tooLong: "es demasiado largo (%{count} caracteres máximo)",
            tooShort: "es demasiado corto (%{count} caracteres mínimo)",
            wrongLength: "no tiene la longitud correcta (%{count} caracteres exactos)",
            checkServicesError: "Servicios no puede estar vacío o con servicios desactivados",
            emailAlreadyUsed: "El email introducido le pertenece a otro cliente",
            phoneAlreadyUsed: "El teléfono introducido le pertenece a otro cliente",
            invalidPhone: "El teléfono introducido no es valido",
            cannotCreateCoHealtClient: "No se pudo crear la información extra del cliente",
            companyNotFound: "Compañía no encontrada",
            companyMustBeFromChile: "La compañía debe ser de Chile",
            companyMustBeFromChileOrColombia: "La compañía debe ser de Chile o Colombia",
            companyMustHaveStatusArray: "Arreglo de status es nulo. Debe ser válido",
            paymentAccountNotFound: "Transferencia no encontrada",
            datesNil: "Las fechas no pueden ser nulas",
            validateBookingEndsSameDay: "Solamente puedes realizar reservas que inicien y terminen el mismo día.",
            unauthorized: "No autorizado",
            validatePayedBookingPresent: "No puedes editar el precio de una reserva asignada para pago online.",
            validateClientRetrievePresent: "No puedes editar el precio de una reserva con un link de pago ya generado."
          },
          template: {
            body: "Se encontraron problemas con los siguientes campos:",
            header: {
              one: "No se pudo guardar este/a %{model} porque se encontró 1 error",
              other: "No se pudo guardar este/a %{model} porque se encontraron %{count} errores"
            }
          }
        },
        models: {
          company: "Compañia",
          companySetting: "Configuración de Compañia",
          service: "Servicio",
          location: "Local",
          serviceProvider: "Prestador De Servicio",
          serviceStaff: "Personal de servicio",
          planInfo: {
            attributes: {
              phone: "Teléfono",
              email: "E-Mail",
              name: "Razón Social",
              rut: "RUT",
              sector: "Sector",
              contact: "Nombre Responsable",
              additionalInfo: "Información Adicional"
            }
          }
        },
        views: {
          selectPlan: null
        }
      },
      doorkeeper: {
        applications: {
          confirmations: {
            destroy: "¿Estás seguro?"
          },
          buttons: {
            edit: "Editar",
            destroy: "Eliminar",
            submit: "Enviar",
            cancel: "Cancelar",
            authorize: "Autorizar"
          },
          form: {
            error: "Ups! Verifica tu formulario por posibles errores"
          },
          help: {
            confidential: "Application will be used where the client secret can be kept confidential. Native mobile apps and Single Page Apps are considered non-confidential.",
            redirectUri: "Usa una linea por URI",
            blankRedirectUri: "Leave it blank if you configured your provider to use Client Credentials, Resource Owner Password Credentials or any other grant type that doesn't require redirect URI.",
            nativeRedirectUri: "Usa %{nativeRedirectUri} para test locales",
            scopes: "Separa los ámbitos con espacios. Deja en blanco para usar los ámbitos predeterminados."
          },
          edit: {
            title: "Editar aplicación"
          },
          index: {
            title: "Tus aplicaciones",
            "new": "Nueva aplicación",
            name: "Nombre",
            callbackUrl: "Callback URL",
            actions: "Actions",
            confidential: "Confidential?",
            confidentiality: {
              yes: "Sí",
              no: "No"
            }
          },
          "new": {
            title: "Nueva aplicación"
          },
          show: {
            title: "Aplicación: %{name}",
            applicationId: "Identificador de aplicación",
            secret: "Secret",
            scopes: "Ámbitos",
            confidential: "Confidential",
            callbackUrls: "Callback urls",
            actions: "Acciones"
          }
        },
        authorizations: {
          buttons: {
            authorize: "Autorizar",
            deny: "Denegar"
          },
          error: {
            title: "Ha ocurrido un error"
          },
          "new": {
            title: "Autorización requerida",
            prompt: "¿Autorizas a %{clientName} para usar tu cuenta?",
            ableTo: "Está aplicación tendrá permisos para"
          },
          show: {
            title: "Código de autorización"
          }
        },
        authorizedApplications: {
          confirmations: {
            revoke: "¿Estás seguro?"
          },
          buttons: {
            revoke: "Revocar"
          },
          index: {
            title: "Tus aplicaciones autorizadas",
            application: "Aplicación",
            createdAt: "Creada el",
            dateFormat: "%d/%m/%Y %H:%M:%S"
          }
        },
        preAuthorization: {
          status: "Pre-authorization"
        },
        errors: {
          messages: {
            invalidRequest: "La petición no tiene un parámetro obligatorio, incluye un valor de parámetro incompatible, o tiene un formato incorrecto.",
            invalidRedirectUri: "La uri de redirección no es valida.",
            unauthorizedClient: "El cliente no tiene autorización para realizar esta petición utilizando este método.",
            accessDenied: "El propietario del recurso o el servidor de autorización han denegado la petición.",
            invalidScope: "El scope solicitado no es válido, es desconocido, o tiene un formato incorrecto.",
            invalidCodeChallengeMethod: "The code challenge method must be plain or S256.",
            serverError: "El servidor de autorización ha encontrado una condición inesperada que le ha impedido completar la petición.",
            temporarilyUnavailable: "El servidor de autorización no ha podido manejar la petición por una sobrecarga temporal o por mantenimiento del servidor.",
            credentialFlowNotConfigured: "El flujo de credenciales del propietario del recurso ha fallado porque Doorkeeper.configure.resourceOwnerFromCredentials no está configurado.",
            resourceOwnerAuthenticatorNotConfigured: "La búsqueda del propietario del recurso ha fallado porque Doorkeeper.configure.resourceOwnerAuthenticator no está configurado.",
            adminAuthenticatorNotConfigured: "Access to admin panel is forbidden due to Doorkeeper.configure.adminAuthenticator being unconfigured.",
            unsupportedResponseType: "El servidor de autorización no soporta este tipo de respuesta.",
            invalidClient: "La autenticación del cliente ha fallado por cliente desconocido, cliente no autenticado, o método de autenticación incompatible.",
            invalidGrant: "La autorización proporcionada no es válida, ha expirado, se ha revocado, no coincide con la URI de redirección utilizada en la petición de autorización, o ha sido solicitada por otro cliente.",
            unsupportedGrantType: "El tipo de autorización no está soportada por el servidor de autorización.",
            invalidToken: {
              revoked: "El token de acceso ha sido revocado",
              expired: "El token de acceso ha expirado",
              unknown: "El token de acceso es inválido"
            }
          }
        },
        flash: {
          applications: {
            create: {
              notice: "Aplicación creada."
            },
            destroy: {
              notice: "Aplicación eliminada."
            },
            update: {
              notice: "Aplicación actualizada."
            }
          },
          authorizedApplications: {
            destroy: {
              notice: "Aplicación revocada."
            }
          }
        },
        layouts: {
          admin: {
            title: "Doorkeeper",
            nav: {
              oauth2Provider: "Proveedor OAuth2",
              applications: "Aplicaciones",
              home: "Home"
            }
          },
          application: {
            title: "Autorización OAuth requerida"
          }
        }
      },
      ckeditor: {
        pageTitle: "Administrador de Archivos CKEditor",
        confirmDelete: "¿Borrar archivo?",
        buttons: {
          cancel: "Cancelar",
          upload: "Subir",
          "delete": "Borrar",
          next: "Next"
        }
      },
      devise: {
        confirmations: {
          confirmed: "Tu cuenta ha sido satisfactoriamente confirmada.",
          sendInstructions: "Vas a recibir un correo con instrucciones sobre cómo confirmar tu cuenta en unos pocos minutos.",
          sendParanoidInstructions: "Si tu correo existe en nuestra base de datos, vas a recibir un correo con instrucciones sobre cómo confirmar tu cuenta en unos pocos minutos."
        },
        invitations: {
          sendInstructions: "Un token de invitación ha sido enviado a %{email}.",
          invitationTokenInvalid: "El token de invitación ya no es válido.",
          updated: "Bienvenido, Tu contraseña esta actualizada.",
          updatedNotActive: "Tu contraseña fue ingresada con exito.",
          noInvitationsRemaining: "Sin invitaciones restantes",
          invitationRemoved: "Tu invitación fue borrada.",
          "new": {
            header: "Enviar invitación",
            submitButton: "Enviar invitación"
          },
          edit: {
            header: "Ingresa tu contraseña",
            submitButton: "Ingresar mi contraseña"
          }
        },
        failure: {
          alreadyAuthenticated: "Ya has iniciado una sesión.",
          inactive: "Tu cuenta aún no ha sido activada.",
          invalid: "Email o contraseña inválidos.",
          lastAttempt: null,
          locked: "Tu cuenta está bloqueada.",
          notFoundInDatabase: "Email o contraseña inválidos.",
          timeout: "Tu sesión expiró, por favor inicia sesión nuevamente para continuar.",
          unauthenticated: "Tienes que iniciar sesión o registrarte para poder continuar.",
          unconfirmed: "Tienes que confirmar tu cuenta para poder continuar.",
          user: {
            invited: "Ocurrió un error al intentar iniciar sesión"
          }
        },
        mailer: {
          confirmationInstructions: {
            subject: "Instrucciones de confirmación"
          },
          resetPasswordInstructions: {
            subject: "Instrucciones de recuperación de contraseña"
          },
          unlockInstructions: {
            subject: "Instrucciones para desbloquear"
          }
        },
        omniauthCallbacks: {
          failure: 'No has sido autorizado para ingresar con la cuenta de %{kind} porque "%{reason}".',
          success: "Sesión iniciada con tu cuenta de %{kind}."
        },
        passwords: {
          noToken: "No puedes acceder a esta página si no es a través de un un enlace para resetear tu contraseña. Si has llegado hasta aquí desde el email para resetear tu contraseña, por favor asegúrate de que la URL introducida está completa.",
          sendInstructions: "Vas a recibir un correo con instrucciones sobre cómo resetear tu contraseña en unos pocos minutos.",
          sendParanoidInstructions: "Si tu correo existe en nuestra base de datos, vas a recibir un correo con instrucciones sobre cómo resetear tu contraseña en tu bandeja de entrada.",
          updated: "Tu contraseña fue cambiada. Ya iniciaste sesión.",
          updatedNotActive: "Tu contraseña fue cambiada."
        },
        registrations: {
          destroyed: "Fue grato tenerte con nosotros. Tu cuenta fue cancelada.",
          signedUp: "Bienvenido. Tu cuenta fue creada.",
          signedUpButInactive: "Tu cuenta ha sido creada exitosamente. Sin embargo, no hemos podido iniciar la sesión porque tu cuenta aún no está activada.",
          signedUpButLocked: "Tu cuenta ha sido creada exitosamente. Sin embargo, no hemos podido iniciar la sesión porque que tu cuenta está bloqueada.",
          signedUpButUnconfirmed: "Se ha enviado un mensaje con un enlace de confirmación a tu correo electrónico. Abre el enlace para activar tu cuenta.",
          updateNeedsConfirmation: "Has actualizado tu cuenta exitosamente, pero es necesario confirmar tu nuevo correo electrónico. Por favor, comprueba tu correo y sigue el enlace de confirmación para finalizar la comprobación del nuevo correo eletrónico.",
          updated: "Tu cuenta fue actualizada."
        },
        sessions: {
          signedIn: "Sesión iniciada exitosamente.",
          signedOut: "Sesión finalizada exitosamente."
        },
        unlocks: {
          sendInstructions: "Vas a recibir instrucciones para desbloquear tu cuenta en unos pocos minutos.",
          sendParanoidInstructions: "Si tu cuenta existe, vas a recibir instrucciones para desbloquear tu cuenta en unos pocos minutos.",
          unlocked: "Tu cuenta fue desbloqueada. Tu cuenta fue desbloqueada. Ya puedes iniciar sesión."
        }
      },
      errors: {
        messages: {
          alreadyConfirmed: "ya fue confirmada, por favor intenta iniciar sesión",
          confirmationPeriodExpired: "necesita confirmarse dentro de %{period}, por favor solicita una nueva",
          expired: "ha expirado, por favor solicita una nueva",
          notFound: "no se encontró",
          notLocked: "no estaba bloqueada",
          notSaved: {
            one: "Un error ocurrió al tratar de guardar %{resource}:",
            other: "%{count} errores ocurrieron al tratar de guardar %{resource}:"
          },
          accepted: "debe ser aceptado",
          blank: "no puede estar en blanco",
          confirmation: "no coincide con la confirmación",
          empty: "no puede estar vacío",
          equalTo: "debe ser igual a %{count}",
          even: "debe ser par",
          exclusion: "está reservado",
          greaterThan: "debe ser mayor que %{count}",
          greaterThanOrEqualTo: "debe ser mayor que o igual a %{count}",
          inclusion: "no está incluido en la lista",
          invalid: "no es válido",
          lessThan: "debe ser menor que %{count}",
          lessThanOrEqualTo: "debe ser menor que o igual a %{count}",
          mustExists: "No existe el registro %{id} en %{model}",
          mustBeActive: "%{model} no tiene activo [%{property}] en el registro %{id}",
          mustBelongsTo: "El registro %{id} en %{model} no pertenece a %{foreignModel} con registro %{foreignValue}",
          mustHaveManyThrough: "El %{modelA} con id %{foreignAValue} y %{modelB} con id %{foreignBValue} no existe en %{model}",
          mustBetweenDate: "La fecha %{date} debe estar entre %{dateMin} y %{dateMax}",
          notANumber: "no es un número",
          notAnInteger: "debe ser un entero",
          odd: "debe ser impar",
          recordInvalid: "La validación falló: %{errors}",
          taken: "ya está en uso",
          tooLong: "es demasiado largo (%{count} caracteres máximo)",
          tooShort: "es demasiado corto (%{count} caracteres mínimo)",
          wrongLength: "no tiene la longitud correcta (%{count} caracteres exactos)",
          checkServicesError: "Servicios no puede estar vacío o con servicios desactivados",
          emailAlreadyUsed: "El email introducido le pertenece a otro cliente",
          phoneAlreadyUsed: "El teléfono introducido le pertenece a otro cliente",
          invalidPhone: "El teléfono introducido no es valido",
          cannotCreateCoHealtClient: "No se pudo crear la información extra del cliente",
          companyNotFound: "Compañía no encontrada",
          companyMustBeFromChile: "La compañía debe ser de Chile",
          companyMustBeFromChileOrColombia: "La compañía debe ser de Chile o Colombia",
          companyMustHaveStatusArray: "Arreglo de status es nulo. Debe ser válido",
          paymentAccountNotFound: "Transferencia no encontrada",
          datesNil: "Las fechas no pueden ser nulas",
          validateBookingEndsSameDay: "Solamente puedes realizar reservas que inicien y terminen el mismo día.",
          unauthorized: "No autorizado",
          validatePayedBookingPresent: "No puedes editar el precio de una reserva asignada para pago online.",
          validateClientRetrievePresent: "No puedes editar el precio de una reserva con un link de pago ya generado."
        },
        format: "%{attribute} %{message}",
        template: {
          body: "Se encontraron problemas con los siguientes campos:",
          header: {
            one: "No se pudo guardar este/a %{model} porque se encontró 1 error",
            other: "No se pudo guardar este/a %{model} porque se encontraron %{count} errores"
          }
        }
      },
      nationality: "Nacionalidad",
      indentificationNumber: "C.I.",
      identificationNumberOnCharts: "C.I",
      providerCode: "Código de profesional",
      deleteCategoryError: "No es posible eliminar la categoría Otros",
      updateCategoryError: "No es posible actualizar la categoría Sin Categoría",
      timeResource: "El recurso con horario",
      provider: "Prestador",
      serviceOnBlockTimeUnavailable: "no permite servicios en este horario",
      agendaproAddress: "Paseo Apoquindo 4499, Piso 14, Las Condes",
      thanks: "Gracias",
      receiptGiftcard: "Comprobante ingreso Gift card",
      receiptGiftcardTypePrint: "ingreso Gift card",
      receiptTypePrint: {
        boleta: "Boleta",
        factura: "Factura",
        "boleta de servicios": "Boleta de servicios",
        "factura exenta": "Factura exenta",
        otros: "Otros",
        otro: "Otro"
      },
      receiptsPrint: {
        clientName: "Nombre",
        quantity: "C",
        itemName: "NOMBRE",
        clientIdentificationNumber: "RUT",
        itemPrice: "PRECIO",
        totalItem: "TOTAL",
        baseImport: "IMPORTE BASE",
        totalToPay: "TOTAL A PAGAR",
        payedBy: "Pagado en",
        attendedBy: "Atendido por",
        "sin información": "Sin información"
      },
      serviceNotFound: "No se puede encontrar un servicio sin id",
      createChartSucessfull: "Ficha creada exitosamente",
      createChartError: "Error al crear la ficha",
      updateChartSucessfull: "Ficha actualizada exitosamente",
      updateChartError: "Error al actualizar la ficha",
      resumeChart: "Resumen de ficha",
      chartSignedBy: "Ficha firmada por:",
      includeSignOfProfesional: "Incluir firma del profesional",
      errorWhenSigning: "Error al firmar la ficha.",
      wrongPinCode: "Codigo pin incorrecto.",
      deleteFolderSucessfull: "Carpeta eliminada exitosamente",
      unprocessabk0leFileSize: "Tamaño de archivo no permitido",
      saveFileSucessfull: "Archivo guardado exitosamente",
      saveFileError: "No se pudo guardar el archivo",
      movedFileSucessfull: "Archivo movido exitosamente",
      movedFileError: "Error al mover el archivo",
      editFileSucessfull: "Archivo editado exitosamente",
      editFileError: "Error al mover el archivo",
      membershipNotFound: "El plan no existe, por favor revisa el documento de identidad del cliente",
      errorCommon: "Ocurrió un error",
      errorTryAgainCommon: "Ocurrió un error, por favor reintente en unos momentos.",
      statusError: "No especificaste el estatus a cambiar",
      commissionOptionOrValueEmpty: "Opción de comisión o valor de comisión vacios",
      membershipIdNil: "No se puede encontrar un resultado sin un id de plan",
      companyIdNil: "No se puede encontrar un resultado sin un id de compañía",
      uniqueRut: "El documento de identidad ingresado pertenece a otro cliente y no puede repetirse",
      existingRut: "El documento de identidad ingresado pertenece a otro cliente y no puede repetirse",
      productNotFound: "El producto no existe en esta compañía",
      errorTypeCommission: "El tipo de comisión es incorrecto",
      accountStatus: {
        title: "Estado de cuenta",
        currentSummary: "Resumen actual",
        currentPlan: "Plan Actual",
        monthlyTotalPlanPrice: "Precio mensual (descuento incluído)",
        excessPayments: "Saldo a favor",
        status: "Estado de cuenta:",
        paymentStatus: "Estado de pago:",
        lastPaymentWas: "Tu ultimo pago fue realizado el día",
        byAmount: "por un monto de",
        deleteCard: "¿Estás seguro de eliminar tu tarjeta?",
        changeCard: "Cambiar tarjeta",
        areYouSure: "¿Estás seguro?",
        deleteCardWarning: "Si eliminas tu tarjeta, no podremos cobrar tu próximo mes de forma automática y tu cuenta podría ser inactivada si no recuerdas pagar a tiempo.",
        suscribeTitle: "Texto de tienes una suscripcion activa",
        suscribeSubTitle: "Tienes una suscripción activa",
        suscribeDescription: ", tu plan fue pagado y asociado a la tarjeta:",
        suscribeDescriptionNoCard: ", tu plan fue pagado correctamente.",
        suscribeAlert: "No es posible modificar tu medio de pago dado que tu plan es anual. Para cambios o dudas, escribe a cuentas@agendapro.com",
        processingSubTitle: "Tu pago esta siendo procesado",
        processingDescription: "Estamos esperando la respuesta del procesador de pago. Cuando la recibamos, actualizaremos la cuenta inmediatamente.",
        payPlan: "Pagar plan",
        months1: "Mes",
        months12: "Meses",
        selectPaymentMethod: "Selecciona tu forma de pago",
        important: "Importante",
        areContraring: "estás contratando tu plan",
        willBeCharged: "Se te cobrará",
        momentoToApprove: "al momento de aprobar la transacción y tu cuenta quedará activa hasta el",
        "next paymentWillBe": "Tu próximo cobro será el",
        andAllMonths: "y todos los meses automáticamente se te cobrará",
        yourCreditCard: "a tu tarjeta de crédito",
        suscriptionAnual: "La suscripción anual no podrá ser cancelada por los siguientes 12 meses, es decir, hasta el ",
        currencyFluctuations: "Las fluctuaciones monetarias, impuestos específicos y comisiones bancarias pueden afectar el monto total que se cobra en tu tarjeta.",
        preAreContraring: "estás pagando tu plan",
        preCurrencyFluctuations: "Las fluctuaciones monetarias, impuestos específicos y comisiones bancarias pueden afectar el monto total que se cobra en la plataforma de tu elección.",
        preNotBeReverse: "El pre-pago no podrá ser reversado en caso de arrepentimiento de compra.",
        transfer: "Transferencia",
        transferStep1: "Realiza la transferencia en el sitio web de tu banco por el valor de",
        transferStep2: "Luego de haber realizado la transferencia, selecciona el botón pagar",
        transferStep3: "Completa el formulario para notificarnos de la transferencia",
        transferDateTitle: "Datos para transferir",
        transferDateName: "Nombre: Gunei Investment SpA",
        transferDateRut: "Rut: 76.233.336-8",
        transferDateBank: "Banco: BICE",
        transferDateAccount: "Cuenta corriente: 21709174",
        transferDateEmail: "Email: cuentas@agendapro.com",
        accept: "Acepto",
        termConditions: "términos y condiciones",
        estimatePrice: "*Precio estimado",
        agenda: "agendas",
        unsuscribeCard: "Tu tarjeta ha sido eliminada correctamente. Recuerda agregar una nueva antes del próximo vencimiento.",
        updateCard: "Tu tarjeta ha sido actualizada correctamnte",
        checkYourPlan: "Elige tu plan",
        goPlans: "Ir a planes",
        someDays: "un par de",
        trialDays: "dias de prueba",
        youHave: "Te quedan",
        payBefore: "y realiza tu pago antes para evitar cortes en tu cuenta.",
        changeAnnual: "Cambiar a PLAN ANUAL",
        changeAnnualDiscount: "10% de descuento",
        annualModalTitle: "Actualizar a plan anual",
        annualModalSectionTitle: "Plan Anual",
        annualModalSectionDesc: "Al continuar aceptas convertir tu suscripción mensual a una suscripción anual. Automáticamente accederás al 10% de descuento por contrato anual, pero no podrás darte de baja hasta el",
        annualModalAcceptChanges: "los cambios anteriores",
        addCreditCard: "Agregar Tarjeta de Crédito",
        contactUsTo: "Si tienes dudas escríbenos a",
        processingMsg: "Estamos esperando la respuesta de tu pago. Esta puede demorar hasta 48 horas."
      },
      selectPlanTitle: "Planes y facturación",
      selectPlanDescription: "Acá puedes cambiar el plan seleccionado, configurar la facturación y pagar tu plan. En caso de existir diferencias, se cobrarán o abonarán inmediatamente.",
      openBillingInfoDiv: "Datos de facturación",
      openInvoiceDiv: "Historial completo",
      accountState: "Estado de cuenta",
      pay: "Pagar",
      collectionNotes: "Notas de cobro",
      billingData: "Datos de facturación",
      planChange: "Cambio de plan",
      last6CollectionNotes: "Últimos 6 Invoice",
      collectionNote: "Invoice",
      noCollectionNotesHaveBeenGenerated: "No se han generado invoice",
      completeHistory: "Historial completo",
      billingContact: "Contacto de Facturación",
      identificationTypes: ["NIT", "CC", "CE", "PA"],
      name: "Nombre",
      email: "Email",
      phoneSearch: "Teléfono 10 dígitos",
      phone: "Teléfono",
      dateString: "Fecha",
      transferDate: "Fecha de transferencia",
      currentPlan: "Plan actual",
      activeBefore: "Activo hasta",
      lastPayment: "Último pago",
      youAreInATrialPeriod: "Te encuentras en periodo de prueba.",
      currentDebt: "Deuda actual",
      positiveBalance: "Saldo a favor",
      payNow: "Pagar ahora",
      actives: "Activos",
      inactives: "Inactivos",
      paymentStatusInfoButton: "Ver Estado de cuenta en PDF",
      yourTrialPeriodExpires: "Tu periodo de prueba expira el",
      youWantToMakeAPayment: "Si deseas realizar un pago, haz clic en:",
      makeAPayment: "Realizar un Pago",
      reactivateMyAccount: "Reactivar mi cuenta",
      reactivateMyAccountTerm: "Para reactivar tu cuenta, debes cancelar la deuda acumulada al momento de desactivación, más el valor proporcional del plan que tenías para lo que resta del mes presente.",
      theDebtYouAccumulatedReaches: "La deuda que acumulaste alcanza a ",
      beforeDeactivatingYourPlanWas: "Antes de la desactivación tu plan era el Plan",
      planValue: "El valor de este plan para lo que resta del mes es",
      totalAmountToReactivation: "El valor total a cancelar de reactivación asciende a",
      ivaIncluded: "IVA incluido",
      selectPaymentMethod: "Selecciona tu método de pago",
      transferDataMessage: 'Si vas a pagar con transferencia, primero haz la transferencia por el valor total y luego selecciona "Pagar". Se abrirá un formulario que deberás llenar para darnos aviso de la transferencia.',
      transferDataInfo: "Los datos para transferir son los siguientes:\n  Empresa: Gunei Investment SpA\n  RUT: 76.233.336-8\n  Banco: Banco BICE\n  Cuenta: Cuenta Corriente 21709174\n  Email: cuentas@agendapro.com\n",
      requestInvoice: "Solicitar factura",
      btnSave: "Guardar",
      authorization: "Autorización voluntaria de envío de DTEs por email",
      sentAproved: "Acepto el envío electrónico de factura o boleta por email a: ",
      planDetail: "Detalle del plan",
      plan: "Plan",
      monthlyValue: "Valor mensual",
      locals: "Locales",
      providersServices: "Prestadores de servicios",
      localEs: "local(es)",
      providers: "Prestadores",
      onlyEmailBooking: "Solo emails de reservas",
      includesEverythingPreviousPlan: "Incluye todo lo que tiene el plan anterior",
      changePlan: "Cambiar a plan",
      backOriginal: "Volver al original",
      confirmServices: "Confirmar todos los servicios",
      cancelServices: "Cancelar todos los servicios",
      btnConfirm: "Confirmar",
      btnModify: "Modificar",
      btnCancel: "Cancelar",
      copyright: "Todos los derechos reservados",
      loading: "Cargando...",
      permitted: "Permitido",
      denied: "Denegado",
      requiredText: "Campo requerido",
      formatErrorText: "Formato incorrecto",
      goTo: "Ir a",
      yes: "Si",
      no: "No",
      others: "Otros",
      of: "de",
      mailingSection: {
        todayAgenda: "Agenda de hoy",
        lastAgendaAndModify: "Últimas reservas agendadas y/o modificadas",
        client: "Cliente",
        service: "Servicio",
        serviceProvider: "Profesional",
        when: "¿Cuándo?",
        where: "¿Dónde?",
        state: "Estado"
      },
      date: {
        abbrDayNames: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
        abbrMonthNames: ["", "ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
        dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
        formats: {
          "default": "%d/%m/%Y",
          "long": "%A %d de %B de %Y",
          longNoDay: "%d de %B del %Y",
          "short": "%d de %b",
          day: "%A %d de %B",
          dayShort: "%a %d de %B",
          defaultDay: "%a %d/%m/%Y",
          dayName: "%A",
          abbrDayName: "%a",
          yearMonthDay: "%Y-%m-%d",
          monthName: "%B"
        },
        monthNames: ["", "enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
        order: ["day", "month", "year"]
      },
      datetime: {
        distanceInWords: {
          aboutXHours: {
            one: "alrededor de 1 hora",
            other: "alrededor de %{count} horas"
          },
          aboutXMonths: {
            one: "alrededor de 1 mes",
            other: "alrededor de %{count} meses"
          },
          aboutXYears: {
            one: "alrededor de 1 año",
            other: "alrededor de %{count} años"
          },
          almostXYears: {
            one: "casi 1 año",
            other: "casi %{count} años"
          },
          halfAMinute: "medio minuto",
          lessThanXMinutes: {
            one: "menos de 1 minuto",
            other: "menos de %{count} minutos"
          },
          lessThanXSeconds: {
            one: "menos de 1 segundo",
            other: "menos de %{count} segundos"
          },
          overXYears: {
            one: "más de 1 año",
            other: "más de %{count} años"
          },
          xDays: {
            one: "1 día",
            other: "%{count} días"
          },
          xMinutes: {
            one: "1 minuto",
            other: "%{count} minutos"
          },
          xMonths: {
            one: "1 mes",
            other: "%{count} meses"
          },
          xSeconds: {
            one: "1 segundo",
            other: "%{count} segundos"
          }
        },
        prompts: {
          day: "Día",
          hour: "Hora",
          minute: "Minutos",
          week: "Semana",
          month: "Mes",
          second: "Segundos",
          year: "Año",
          duringMembershipDuration: "Vigencia del plan"
        }
      },
      helpers: {
        select: {
          prompt: "Por favor seleccione",
          shortPrompt: "Seleccione..."
        },
        submit: {
          create: "Crear %{model}",
          submit: "Guardar %{model}",
          update: "Actualizar %{model}"
        }
      },
      number: {
        currency: {
          format: {
            delimiter: ".",
            format: "%u %n",
            precision: 0,
            separator: ",",
            significant: false,
            stripInsignificantZeros: false,
            unit: "$"
          }
        },
        format: {
          delimiter: ".",
          precision: 2,
          separator: ",",
          significant: false,
          stripInsignificantZeros: false
        },
        human: {
          decimalUnits: {
            format: "%n %u",
            units: {
              billion: "mil millones",
              million: "millón",
              quadrillion: "mil billones",
              thousand: "mil",
              trillion: "billón",
              unit: ""
            }
          },
          format: {
            delimiter: "",
            precision: 1,
            significant: true,
            stripInsignificantZeros: true
          },
          storageUnits: {
            format: "%n %u",
            units: {
              "byte": {
                one: "Byte",
                other: "Bytes"
              },
              gb: "GB",
              kb: "KB",
              mb: "MB",
              tb: "TB"
            }
          }
        },
        percentage: {
          format: {
            delimiter: ""
          }
        },
        precision: {
          format: {
            delimiter: ""
          }
        }
      },
      support: {
        array: {
          lastWordConnector: ", y ",
          twoWordsConnector: " y ",
          wordsConnector: ", "
        }
      },
      time: {
        am: "am",
        formats: {
          "default": "%A, %d de %B de %Y a las %H:%M horas",
          "long": "%A %d de %B de %Y %H:%M",
          "short": "%d de %b %H:%M",
          hour: "%H:%M",
          shortDateFromDatetime: "%d de %b",
          longDateFromDatetime: "%-d de %",
          monthName: "%B",
          dayName: "%A",
          abbrDayName: "%a",
          todayWithTime: "hoy a las %H:%M",
          otherWithTime: "el %A %d/%m/%Y a las %H:%M"
        },
        pm: "pm",
        abbrDayNames: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
        abbrMonthNames: [null, "ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
        dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
        monthNames: [null, "enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
        order: ["day", "month", "year"]
      },
      activemodel: {
        errors: {
          format: "%{attribute} %{message}",
          messages: {
            accepted: "debe ser aceptado",
            blank: "no puede estar en blanco",
            confirmation: "no coincide con la confirmación",
            empty: "no puede estar vacío",
            equalTo: "debe ser igual a %{count}",
            even: "debe ser par",
            exclusion: "está reservado",
            greaterThan: "debe ser mayor que %{count}",
            greaterThanOrEqualTo: "debe ser mayor que o igual a %{count}",
            inclusion: "no está incluido en la lista",
            invalid: "no es válido",
            lessThan: "debe ser menor que %{count}",
            lessThanOrEqualTo: "debe ser menor que o igual a %{count}",
            mustExists: "No existe el registro %{id} en %{model}",
            mustBeActive: "%{model} no tiene activo [%{property}] en el registro %{id}",
            mustBelongsTo: "El registro %{id} en %{model} no pertenece a %{foreignModel} con registro %{foreignValue}",
            mustHaveManyThrough: "El %{modelA} con id %{foreignAValue} y %{modelB} con id %{foreignBValue} no existe en %{model}",
            mustBetweenDate: "La fecha %{date} debe estar entre %{dateMin} y %{dateMax}",
            notANumber: "no es un número",
            notAnInteger: "debe ser un entero",
            odd: "debe ser impar",
            recordInvalid: "La validación falló: %{errors}",
            taken: "ya está en uso",
            tooLong: "es demasiado largo (%{count} caracteres máximo)",
            tooShort: "es demasiado corto (%{count} caracteres mínimo)",
            wrongLength: "no tiene la longitud correcta (%{count} caracteres exactos)",
            checkServicesError: "Servicios no puede estar vacío o con servicios desactivados",
            emailAlreadyUsed: "El email introducido le pertenece a otro cliente",
            phoneAlreadyUsed: "El teléfono introducido le pertenece a otro cliente",
            invalidPhone: "El teléfono introducido no es valido",
            cannotCreateCoHealtClient: "No se pudo crear la información extra del cliente",
            companyNotFound: "Compañía no encontrada",
            companyMustBeFromChile: "La compañía debe ser de Chile",
            companyMustBeFromChileOrColombia: "La compañía debe ser de Chile o Colombia",
            companyMustHaveStatusArray: "Arreglo de status es nulo. Debe ser válido",
            paymentAccountNotFound: "Transferencia no encontrada",
            datesNil: "Las fechas no pueden ser nulas",
            validateBookingEndsSameDay: "Solamente puedes realizar reservas que inicien y terminen el mismo día.",
            unauthorized: "No autorizado",
            validatePayedBookingPresent: "No puedes editar el precio de una reserva asignada para pago online.",
            validateClientRetrievePresent: "No puedes editar el precio de una reserva con un link de pago ya generado."
          },
          template: {
            body: "Se encontraron problemas con los siguientes campos:",
            header: {
              one: "No se pudo guardar este/a %{model} porque se encontró 1 error",
              other: "No se pudo guardar este/a %{model} porque se encontraron %{count} errores"
            }
          }
        }
      },
      willPaginate: {
        previousLabel: "&#8592;",
        nextLabel: "&#8594;",
        pageGap: "&hellip;"
      },
      country: {
        name: "Latinoamérica",
        domain: ".co"
      },
      district: "comuna",
      ditricts: "comunas",
      withoutResults: "No hay resultados disponibles",
      searchFromCalendar: "La búsqueda inicia a partir de %{char} caracteres",
      ci: "cédula",
      currencyCode: "USD",
      taxes: false,
      plans: {
        personal: 19900,
        pro: {
          price: 99900,
          motivational: "¡Posiciona tu marca con una App propia y plataforma personalizadas!",
          name: "Pro",
          professionalQuantity: "15 agendas",
          tooltip: "Número de agendas máximas del plan"
        },
        premium: {
          price: 59900,
          motivational: "¡Aumenta la recurrencia de clientes con herramientas de marketing y fidelización!",
          name: "Premium",
          professionalQuantity: "10 agendas",
          tooltip: "Número de agendas máximas del plan"
        },
        basic: {
          price: 34900,
          motivational: "¡Gestiona todo tu negocio con múltiples agendas, sistema POS, y mucho más!",
          name: "Básico",
          professionalQuantity: "5 agendas",
          tooltip: "Número de agendas máximas del plan"
        },
        titles: {
          titlePage: "Nuestros planes",
          subtitlePage: "Elige el plan que mejor se acomode a tus necesidades o contáctanos si necesitas uno a tu medida.",
          buyerGuideTitle: "Descarga nuestra guía y descubre los mejores consejos para tu negocio.",
          beforeAllBenefits: "Todos los planes de AgendaPro incluyen una App para tus clientes, donde pueden agendar sus citas contigo. Explora en detalle las funcionalidades que AgendaPro tiene para tu negocio."
        },
        benefits: ["Agendamiento Online de Citas y Clases", "Gestión de Clientes y CRM", "Paquetes o Planes", "Caja y Pago de Comisiones", "Inventarios", "Recordatorios Automáticos", "Email Marketing", "Reportes", "Encuestas de Satisfacción", "Fichas Personalizables", "Personalización de Diseño", "App Personalizada", "Acceso a API"],
        benefitsDescription: ["Web, Facebook, Instagram y App Buscador AgendaPro", "Conoce el perfil de tus clientes y su historial", "Gestiona paquetes y contratos de clientes", "Controla los ingresos, el flujo de caja y pago de comisiones", "Gestiona la venta y stock de productos con alarmas automáticas", "Disminuye las inasistencias por medio de recordatorios de citas", "Realiza campañas de email marketing para promocionar tus servicios. Notificaciones automáticas (cumpleaños, vencimientos y más)", "Múltiples reportes de citas, ventas, marketing, comisiones, encuestas, etc", "Evalúa la calidad de los servicios ofrecidos y el desempeño de tus profesionales", "Ingresa las fichas clínicas, exámenes y evoluciones de tus clientes/pacientes", "Personaliza la plataforma con los colores de tu marca", "App de agendamiento con tu diseño y marca para App Store y Google Play", "Integra tus sistemas actuales con AgendaPro"],
        benefitsMarks: {
          pro: [true, true, true, true, true, true, true, true, true, true, true, true, true],
          premium: [true, true, true, true, true, true, true, true, true, true, true, false, false],
          basic: [true, true, true, true, true, true, true, true, false, false, false, false, false]
        },
        typePayment: ["Anual", "Mensual"],
        scheduling: {
          name: "Agendamiento",
          benefits: ["Mini-Sitio Web de Agendamiento", "Integración con Facebook", "Notificaciones Automáticas de Citas", "Agendamiento de Clases Grupales", "Agendamiento de Salas y Equipos", "Opciones Avanzadas de Agendamiento Online"],
          benefitsMarks: {
            pro: [true, true, true, true, true, true],
            premium: [true, true, true, true, true, true],
            basic: [true, true, true, true, true, true]
          },
          benefitsDescription: ["Dirección personalizada y vinculación con página web", "Agendamiento desde tu fanpage de Facebook", "Notificación vía email de nueva reserva y recordatorio de citas. Envío de resumen diario de la agenda a tu equipo", "Define capacidad máxima de asistentes, horarios y profesores", "Visualización de tus salas y equipos", "Políticas de agendamiento y cancelación (reservar con menos de 3 horas de la cita y más)"]
        },
        marketing: {
          name: "Marketing",
          benefits: ["App Personalizada", "Plataforma de Email Marketing", "App Buscador AgendaPro", "Reportes de Campañas de Marketing", "Email Automático para Cumpleaños"],
          benefitsMarks: {
            pro: [true, true, true, true, true],
            premium: [false, true, true, true, true],
            basic: [false, true, true, true, true]
          },
          benefitsDescription: ["App de agendamiento con tu diseño y tu marca para App Store y Google Play", "Realiza campañas de email marketing para promocionar tus servicios", "App en donde se listan empresas y sus clientes pueden agendar citas", "Conoce el detalle y el resultado de tus campañas", "Saluda a tus clientes con un mensaje personalizado para su cumpleaños"]
        },
        customerManagement: {
          name: "Gestión de clientes",
          benefits: ["Perfil de cada Cliente", "Sistema de Planes", "Control de Asistencias", "Notificaciones y Alertas Diarias", "Fichas y Campos Personalizables", "Encuestas de Satisfacción"],
          benefitsMarks: {
            pro: [true, true, true, true, true, true],
            premium: [true, true, true, true, true, true],
            basic: [true, true, true, true, false, false]
          },
          benefitsDescription: ["Conoce en detalle el historial de tus clientes y sus preferencias", "Control de paquetes, sesiones y contratos de tus clientes", "Controla la asistencia e inasistencia de tus clientes", "Notificaciones automatizadas de confirmación, modificación y cancelación de citas", "Crea fichas, carga imágenes y exámenes, y visualiza evoluciones de tus clientes/pacientes", "Envío automatizado de encuestas personalizadas a tus clientes/pacientes"]
        },
        professionalManagement: {
          name: "Gestión de profesionales",
          benefits: ["Perfiles de Usuarios", "Niveles de Acceso y Permisos", "Gestión de Horarios, Bloqueos y Servicios", "Control de Ocupación y Ventas", "App Administrativa", "Acceso a Tutoriales de Capacitación"],
          benefitsMarks: {
            pro: [true, true, true, true, true, true],
            premium: [true, true, true, true, true, true],
            basic: [true, true, true, true, true, true]
          },
          benefitsDescription: ["Asigna a tu equipo el perfil que mejor se adapte a su cargo", "Defiene el permiso y acceso detallado de tus usuarios", false, "Visualiza el desempeño de tu equipo", "App para tu equipo. Gestiona citas y clientes", false]
        },
        billingSystem: {
          name: "Sistema de caja y facturación",
          benefits: ["Reportes Automáticos Semanales", "Pagos Online", "Control de Ingresos y Egresos", "Cierre de Caja ", "Control de Inventarios", "Reportes de Caja e Inventarios", "Alertas de Stock de Productos"],
          benefitsMarks: {
            pro: [true, true, true, true, true, true, true],
            premium: [true, true, true, true, true, true, true],
            basic: [true, true, true, true, true, true, true]
          },
          benefitsDescription: ["Reporte automático de ventas, nuevos clientes, asistencias y ocupación", "Integración de venta de servicios online (disponible en Chile)", false, false, false, "Reportes de ventas de productos, movimientos de stock y rotaciones de productos", "Sistema de alarmas y notificaciones de reposición de inventario"]
        },
        questions: "¿Estás listo para comenzar con AgendaPro?",
        textBelowQuestion: "Contáctanos al %{phones} para ayudarte y tener una demo personalizada",
        terms: "* Para negocios con más de una sucursal o con un alto volumen de reservas, por favor contáctate con nuestro equipo comercial y obtén descuentos especiales.",
        discovery: {
          main: "Descubre el plan que más se adecúe a tus metas",
          alternative: "¿Necesitas más agendas?",
          contact: "¡Contáctanos!",
          priceNot: ""
        },
        recommended: "Recomendado",
        faqs: {
          title: "Preguntas frecuentes",
          question1: {
            title: "¿Los datos de mis clientes están seguros?",
            response: "Si, tus datos están seguros, ya que seguimos estándares internacionales de seguridad. AgendaPro está alojado en Amazon Web Services, sin permisos de conexión pública, y además forzamos todas las transacciones para que sean a través de un protocolo seguro (TLS)."
          },
          question2: {
            title: "¿Cómo funciona el soporte técnico?",
            response: "Nuestros ejecutivos atendrán todas tus dudas en horario hábil, a través de un chat online, disponible en la misma plataforma. En el caso de necesitar mayor ayuda, puedes ingresar a academia.capacitacionagendapro.com"
          },
          question3: {
            title: "¿Cuáles son las modalidades de pago?",
            response: "Puedes pagar  anual o mensual con diversos medios de pago. Al pagar el año obtienes un 20% de descuento adicional."
          },
          question4: {
            title: "¿Qué pasa si quiero dar de baja mi plan?",
            response: "Te puedes dar de baja cuando tú quieras, solo tienes que notificar a tu ejecutivo con 30 días de anticipación."
          }
        },
        discount: 0.8,
        textDiscount: "Anual -20%",
        textMonth: "Mensual",
        resume: "Resumen actual",
        title: "Planes y facturación",
        description: "Acá puedes cambiar el plan seleccionado, configurar y pagar tu plan. En caso de existir diferencias, se cobrarán inmediatamente.",
        actualPlan: "Plan actual",
        statusTrial: "Período de prueba",
        statusProcessing: "En proceso",
        statusActive: "Tu cuenta está al día",
        statusEmitted: "Tu cuenta está pendiente de pago",
        statusExpired: "Tu cuenta está con morosidad",
        statusSubscribed: "Tienes una suscripción activa",
        statusAgreement: "Tienes un convenio activo",
        statusInactive: "Tu cuenta está inactiva, comunícate para re-activarla",
        planList: "Opciones de planes",
        tax: "IVA por mes",
        clTaxName: "IVA",
        youAreChangingPlan: "Estás cambiando tu cuenta AgendaPro a un nuevo plan mensual.",
        youMustPay: "Deberás pagar",
        andADueOf: "Además de una deuda actual de",
        changeTo: "Cambiar a ",
        switchPlanTitle: "¿Deseas cambiar tu plan?",
        switchPlanText: "Seleccion Aceptar si deseas continuar con el proceso",
        accountState: "Estado de cuenta",
        planNotFound: "No hay plan activo",
        locals: "Locales",
        emails: "Emails",
        providers: "Prestadores",
        monthlyPrice: "Precio mensual",
        positiveBalance: "Saldo a favor",
        monthPerLocal: "local por mes",
        activeMonths: "Meses activos restantes",
        activeEnd: "Activo hasta",
        paymethod: "Método de pago actual",
        procesingPay: "Procesando el pago",
        procesingPayDesc: "Nos encontramos procesando el pago realizado con la siguiente tarjeta de crédito:",
        warning: "El proceso de confirmacion puede tardar entre 24 y 48 horas, una vez confirmada la transacción, el estado de tu cuenta se actualizará automáticamente",
        changePlanCta: "Cambiar plan",
        changePlanTrial: "Elige tu plan",
        withDate: "con fecha de",
        planPayed: "de tu plan fue pagado ",
        planConfirmation: "confirmación de pago",
        detailsTitle: "Importante",
        detPt1: "estas pagando el",
        detPt2: "con",
        detPt3: "Hoy se te cobrará",
        detPt4: "y tu cuenta quedará activa hasta",
        detPt5: "Tu próximo cobro será el ",
        detPt6: "y todos los meses automáticamente se te cobrará ",
        detPt7: "a tu tarjeta de crédito, activando tu cuenta por un mes.",
        noteSuscription: "al suscribir tu tarjeta de crédito, el primer cargo a tu tarjeta corresponderá a los días proporcionales transcurridos del mes en curso (#) más un segundo cargo por el valor del plan mensual (#). El día en que te suscribes será tu nuevo día de pago y mensualmente se hará el cargo en tu tarjeta este día (#)",
        trnsfrDet1: "Realiza la transferencia en el sitio web de tu banco por el valor de ",
        trnsfrDet2: "Luego de haber realizado la transferencia, selecciona el botón pagar ",
        trnsfrDet3: "Completa el formulario para notificarnos de la transferencia ",
        transferInfo: "Datos para transferir",
        noDebt: "No posees deuda",
        negativeBalance: "Saldo en contra",
        haveSubscription: "Tienes una suscripción activa",
        cardInfo: "y asociado con la tarjeta: ",
        goBilling: "Ir a datos de facturación",
        goBillingTitle: "Debe rellenar los datos de facturacion",
        notePt1: "Al suscribir tu tarjeta de crédito, el primer cargo a tu tarjeta corresponderá a los días proporcionales transcurridos del mes en curso",
        noteOnlinePt1: "El costo a pagar al pagar con tu tarjeta tu tarjeta de crédito considera los días proporcionales del mes en curso",
        notePt2: "más un segundo cargo por el valor del plan mensual",
        notePt3: "El día en que te suscribes, será tu fecha de pago y mensualmente se hará el cargo en tu tarjeta este día (los",
        notePt4: "de cada mes)",
        subsAlertPt1: "Confirmo que deseo a partir de hoy",
        subsAlertPt2: "Suscribir mi tarjeta de crédito por un periodo de",
        subsAlertPt3: "a partir de hoy",
        subscribeCard: "Suscribir tarjeta",
        subscription: "Modo de suscripción",
        monthlySubscription: "mensual",
        yearlySubscription: "anual",
        online: "Modo de pago en línea",
        transfer: "Transferencia electronica",
        noRecentPay: "No tenemos pagos recientes registrados",
        payState: "Estado de pago",
        lastPayRegistered: "Tu ultimo pago fue realizado el día",
        amount: "por un monto de:",
        deleteCard: "Eliminar tarjeta",
        unsuscribeCardTitle: "¿Desea eliminar la tarjeta?",
        unsuscribeCardText: "La tarjeta sera eliminada",
        basic2018: 10,
        premium2018: 20,
        pro2018: 40
      },
      planExtraLocation: {
        personal: 35,
        normal: 55,
        premium: 100,
        pro: 160,
        basic2018: 10,
        premium2018: 20,
        pro2018: 40
      },
      phones: {
        sales: "+56 2 2585 6963",
        support: "+56 2 2585 6963"
      },
      indentificationNameBilling: "RUT",
      indentificationClientNameBilling: "Rut",
      activityBilling: "Giro",
      meta: {
        title: {
          home: "Software de gestión | AgendaPro",
          funcionalidades: "Funcionalidades | AgendaPro",
          planes: "Planes | AgendaPro",
          contacto: "Contacto | AgendaPro",
          nosotros: "Sobre Nosotros | AgendaPro",
          tutoriales: "Tutoriales | AgendaPro",
          buscador: "Buscador | AgendaPro"
        },
        description: {
          home: "Simplifica tu vida y haz crecer tu negocio con el software de gestión para negocios de Salud, Belleza y Deporte. Da click acá y pide tu demo gratis.",
          funcionalidades: "Tu día a día simplificado con un solo clic con las funcionalidades del software de gestión de AgendaPro. Da click acá y pide tu demo gratis.",
          planes: "Revisa los planes y elige el que más se ajuste a tu negocio.",
          contacto: "¿Tienes preguntas? Contáctanos ahora para resolverlas.",
          nosotros: "Conoce el equipo que está detrás de AgendaPro.",
          tutoriales: "Revisa los tutoriales para conocer las principales funcionalidades del AgendaPro",
          buscador: "Encuentra negocios y servicios locales para reservar online."
        }
      },
      content: {
        adminMenu: {
          localesSolo: "Perfil",
          locales: "Locales",
          serviceProviders: "Prestadores de Servicios",
          services: "Servicios",
          comissions: "Comisiones",
          resources: "Recursos",
          surveys: "Encuestas",
          customApp: "App Personalizada",
          shifts: "Turnos",
          consents: "Consentimientos"
        },
        configMenu: {
          company: "Empresa",
          companySolo: "Mi Negocio",
          reservation: "Reservas",
          calendar: "Calendario",
          email: "E-mails",
          integrations: "Integraciones",
          integrationsSolo: "Mis Redes Sociales",
          onlinePayment: "Pagos En Línea",
          cashSystem: "Sistema de Caja",
          notifications: "Notificaciones",
          clients: "Clientes",
          charts: "Fichas",
          surveys: "Encuestas",
          authorizationCodes: "Códigos de autorización"
        },
        home: {
          features: {
            onlineBooking: {
              meta: {
                title: "Agenda Online: Simplifica tu día y organízate con AgendaPro",
                description: "Tus clientes podrán tomar horas desde tu página web, Facebook o app con la Agenda Online de AgendaPro. Da click acá y pide tu demo gratis.",
                keyword: "agenda online"
              },
              menuName: "Agenda Online",
              body: {
                title: "Agenda Online: Simplifica tu día y organízate",
                subtitle: "¡Revisa tu agenda desde cualquier lugar!",
                maximizeYourTime: {
                  title: "Maximiza tu tiempo con una agenda web",
                  subtitle: "Maneja tu agenda",
                  dontLoseClients: "Evita perder clientes con un control potente de movimientos de citas.",
                  blocksSchedulesFromOurMobileApp: "Bloquea horarios desde nuestra App Móvil.",
                  markTheAttendance: "Marca la asistencia de tus clientes con un sólo click."
                },
                virtualAppointmentCalendar: {
                  title: "Aumenta tus clientes e ingresos con tu agenda virtual de citas",
                  subtitle: "Citas online 24/7 para clientes",
                  bookingsFromFacebookOrWebsite: "Citas con sólo un click desde tu fanpage de Facebook o sitio web.",
                  automaticReminders: "Recordatorios de citas automáticos para tus clientes.",
                  ownApp: "Obtén tu propia app en AppStore o Google Play."
                }
              }
            },
            medicalAgenda: {
              meta: {
                title: "Agenda Médica: Historial, recordatorios, citas, y más con AgendaPro",
                description: "Simplifica tu vida y disfruta tu trabajo con la Agenda Médica para controlar a tus pacientes de AgendaPro. Da click acá y pide tu demo gratis.",
                keyword: "agenda medica"
              },
              menuName: "Agenda Médica",
              body: {
                title: "Agenda Médica: Historial, recordatorios, citas, y más",
                subtitle: "¡Consulta tu agenda médica desde cualquier lugar!",
                avoidLosingInformation: {
                  title: "Evita perder información de tus citas con pacientes y utiliza tu agenda médica profesional",
                  subtitle: "Controla tu agenda médica",
                  medicalAutomaticReminders: "Recordatorios automáticos a tus pacientes sobre sus citas.",
                  patientsConfirmOnline: "Tus pacientes confirman vía online sus citas.",
                  agendaMovilApp: "Maneja tu agenda desde nuestra App Móvil."
                },
                medicSaveTime: {
                  title: "Controla la asistencia y ahorra tiempo con tu software médico",
                  subtitle: "Reservas online 24/7 para pacientes",
                  oneClickWeb: "Reservas con sólo un click desde tu sitio web.",
                  patientsAutomaticReminders: "Recordatorios de citas automáticos para tus pacientes.",
                  patientsApp: "Permite que tus pacientes reserven desde tu App personalizada."
                }
              }
            },
            medicalHistory: {
              meta: {
                title: "Historia Clínica: Personalizada, evolución de pacientes, exámenes, más",
                description: "Controla y accede a toda la información de tus pacientes a través de la historia clínica de AgendaPro. Da click acá y pide tu demo gratis.",
                keyword: "historia clinica"
              },
              menuName: "Historia Clínica",
              body: {
                title: "Historia Clínica: Personalizable, manejo de exámenes, y más",
                subtitle: "¡Con el formato que siempre quisiste!",
                onlinePatientFile: {
                  title: "No más historias clínicas en papel, lleva el control de evolución de pacientes y visualízalo de forma segura",
                  subtitle: "Historia Clínica Online",
                  patientRecord: "Registra online los antecedentes médicos.",
                  viewPatientHistory: "Visualiza la historia clínica del paciente cuando quieras.",
                  customFormat: "Formato de historia clínica 100% personalizable."
                },
                examFolders: {
                  title: "¡Olvídate de crear carpetas en tu dispositivo para conservar exámenes!",
                  subtitle: "Documentos y Exámenes a salvo",
                  uploadFiles: "Sube archivos fácilmente al perfil del paciente.",
                  viewFiles: "Consulta los archivos cuando quieras.",
                  viewRecords: "Visualizalos directamente en tu ficha clínica electrónica."
                }
              }
            },
            medicalRecord: {
              meta: {
                title: "Ficha Clínica: Personalizable, manejo de exámenes, y más con AgendaPro",
                description: "Controla y accede a toda la información de tus pacientes a través de la ficha clínica de AgendaPro. Da click acá y pide tu demo gratis.",
                keyword: "ficha clinica"
              },
              menuName: "Ficha Clínica",
              body: {
                title: "Ficha Clínica: Personalizable, manejo de exámenes, y más",
                subtitle: "¡Con el formato que siempre quisiste!",
                onlinePatientFile: {
                  title: "No más fichas en papel, lleva el control de evolución de pacientes y visualízalo de forma segura",
                  subtitle: "Fichas clínicas online",
                  medicalBackground: "Registra online los antecedentes médicos.",
                  clinicHistory: "Visualiza la historia clínica del paciente cuando quieras.",
                  personalizableRecord: "Formato de ficha clínica 100% personalizable."
                },
                onlinePatientRecord: {
                  title: "¡Olvídate de crear carpetas en tu dispositivo para conservar exámenes!",
                  subtitle: "Documentos y Exámenes a salvo",
                  uploadFiles: "Sube archivos fácilmente al perfil del paciente.",
                  viewFiles: "Consulta los archivos cuando quieras.",
                  viewRecords: "Visualizalos directamente en tu ficha clínica electrónica."
                }
              }
            },
            customerLoyalty: {
              meta: {
                title: "Fidelización de Clientes: Encuestas, historial, y perfil de AgendaPro",
                description: "Logra un 100% de fidelización de clientes utilizando el software de gestión de AgendaPro y su ficha de clientes. Da click acá y pide tu demo gratis.",
                keyword: "fidelizacion de clientes"
              },
              menuName: "Fidelización de Clientes",
              body: {
                title: "Fidelización de Clientes: Encuestas, historial, y perfil de clientes",
                subtitle: "¡Mantén a tus clientes felices y contigo!",
                customerInformation: {
                  title: "Visualiza toda la información que tienes que saber de tus clientes en un solo lugar",
                  subtitle: "Un perfil del cliente completo para tu negocio",
                  attendanceProfile: "Perfil de asistencia e historial de citas.",
                  clientFile: "Ficha de clientes personalizable.",
                  contactData: "Administración de datos de contacto y actualización en tiempo real."
                },
                satisfactionSurvey: {
                  title: "¿Qué opinan tus clientes de tí?, Entérate y garantiza la mejor atención.",
                  subtitle: "Encuestas de satisfacción",
                  sendSurvey: "Envío automático de encuestas.",
                  surveyReports: "Reportes que permiten comparar la asistencia en base a la calidad de atención y servicio, precios, agendamiento y mucho más."
                }
              }
            },
            paymentControl: {
              meta: {
                title: "Control de Pagos: Ventas, comisiones, historial, y más con AgendaPro",
                description: "Mantén el control de pagos, recaudaciones y comisiones en forma diaria y en tiempo real con AgendaPro. Da click acá y pide tu demo gratis.",
                keyword: "control de pagos"
              },
              menuName: "Control de Pagos",
              body: {
                title: "Control de Pagos: Ventas, comisiones, historial, y más",
                subtitle: "¡Tus ingresos son vitales para rentabilizar tu negocio!",
                paymentOrder: {
                  title: "¡Lleva el control de tus recaudaciones en tiempo real!",
                  subtitle: "Software de venta online para tener todo bajo control",
                  incomeReview: "Ingresos y pagos por día, semana o mes.",
                  incomeType: "Revisa tus recaudaciones por medio y forma de pago.",
                  downPayment: "Ingresa abonos, traspasos, aplica descuentos y promociones a tus servicios y/o productos.",
                  expenseDetail: "Obtén detalle de los gastos que realizan día a día."
                },
                commissionsReports: {
                  title: "Ahorra tiempo y evita errores con nuestro software de punto de venta",
                  subtitle: "Cálculo y asignación de comisiones",
                  incomeReports: "Lleva los ingresos en tu sistema de caja y obtén las comisiones de una vez.",
                  commissionsSearch: "Consulta el periodo de tiempo que quieras, obteniendo la información rápidamente y siempre respaldada para tu seguridad.",
                  commissionsPercentage: "Cambia los porcentajes asignados de forma segura y rápida."
                }
              }
            },
            cashSystem: {
              meta: {
                title: "Sistema de Caja: Comisiones, Caja diaria, y recaudación con AgendaPro",
                description: "Mantén el control con el sistema de caja y accede a las recaudaciones y comisiones en tiempo real con AgendaPro. Da click acá y pide tu demo gratis.",
                keyword: "sistema de caja"
              },
              menuName: "Sistema de Caja",
              body: {
                title: "Sistema de Caja: Comisiones, Caja diaria, recaudación y más",
                subtitle: "¡Tus ingresos son vitales para rentabilizar tu negocio!",
                paymentOrder: {
                  title: "¡Lleva el control de tus recaudaciones y evita errores!",
                  subtitle: "Sistema de venta online para llevar todo en orden",
                  incomeReview: "Ingresos y pagos por día, semana o mes.",
                  incomeType: "Revisa tus recaudaciones por medio y forma de pago.",
                  downPayment: "Ingresa abonos, traspasos, aplica descuentos y promociones a tus servicios y/o productos.",
                  expenseDetail: "Obtén detalle de los gastos que realizan día a día."
                },
                commissionsReports: {
                  title: "Ahorra tiempo obteniendo los reportes de trabajo de tu equipo con nuestro software de punto de venta",
                  subtitle: "Reportes de comisiones",
                  incomeReports: "Lleva los ingresos en tu sistema de caja y obtén las comisiones de una vez.",
                  commissionsSearch: "Consulta el periodo de tiempo que quieras, obteniendo la información rápidamente y siempre respaldada para tu seguridad.",
                  commissionsPercentage: "Cambia los porcentajes asignados de forma segura y rápida."
                }
              }
            },
            inventoryControl: {
              meta: {
                title: "Control de Inventarios: Stock, registro, historia y más con AgendaPro",
                description: "Controla y Gestiona tus productos en todo momento con la funcionalidad de Control de Inventarios de AgendaPro. Da click acá y pide tu demo gratis.",
                keyword: "control de inventarios"
              },
              menuName: "Control de Inventarios",
              body: {
                title: "Control de Inventarios: Stock, registro, historia, y más",
                subtitle: "Alarmas inteligentes: ¡Te avisamos cuando quedan pocas unidades!",
                onlineInventory: {
                  title: "Ordena tus productos de forma simple y rápida con nuestro software de inventario",
                  subtitle: "Lleva tu Inventario online",
                  automaticControl: "Control de stock automatizado, ¡las unidades vendidas se descuentan en tiempo real!",
                  stockAlerts: "Alarmas de stock crítico personalizadas con notificación a tu e-mail."
                },
                stockReports: {
                  title: "Simplifica la gestión de inventarios de tu negocio con nuestros reportes",
                  subtitle: "Historial de productos",
                  productsHistory: "Consulta el historial de movimiento de inventario diario.",
                  productsReports: "Analiza y mejora con los reportes de comportamiento de productos."
                }
              }
            },
            marketing: {
              meta: {
                title: "Marketing Integrado: Email, encuestas, segmentación y más con AgendaPro",
                description: "Atrae nuevos clientes con las herramientas de marketing de AgendaPro, lo que te permitirá aumentar tus ventas. Da click acá y pide tu demo gratis.",
                keyword: "marketing"
              },
              menuName: "Marketing",
              body: {
                title: "Marketing Integrado: Email, encuestas, segmentación y más",
                subtitle: "¡Rentén y fideliza a tus clientes!",
                emailsCampaings: {
                  title: "Campañas de e-mail marketing con métricas útiles y fáciles de usar",
                  subtitle: "Marketing para tus clientes",
                  masiveMails: "Difunde tus promociones con envío de mail masivos.",
                  mailsReports: "Reporte de campañas de marketing.",
                  clientSegmentation: "Segmenta tu base de clientes según tu objetivo comercial. "
                },
                betterComunication: {
                  title: "Mejora la comunicación con tus clientes",
                  subtitle: "Encuestas para clientes",
                  automaticSurveys: "Envío automático de encuestas de satisfacción de usuarios.",
                  clientFeedback: "Obtén el feeback de tus clientes en tiempo real."
                }
              }
            },
            inventorySystem: {
              meta: {
                title: "Sistema de Inventario: Alertas, Stock, Registro, y más con AgendaPro",
                description: "Controla y Gestiona tus productos en todo momento con la funcionalidad de Sistema de Inventario de AgendaPro. Da click acá y pide tu demo gratis.",
                keyword: "sistema de inventario"
              },
              menuName: "Sistema de Inventario",
              body: {
                title: "Sistema de Inventario: Alertas, stock, registro, y más",
                subtitle: "Alarmas inteligentes: ¡Te avisamos cuando quedan pocas unidades!",
                onlineInventory: {
                  title: "Ordena tus productos de forma simple y efectiva con nuestro software de inventario",
                  subtitle: "Inventario online",
                  automaticControl: "Control de stock automatizado, ¡Se descuentan las unidades mientras vendes!",
                  stockAlerts: "Alarmas de stock crítico personalizadas con notificación a tu e-mail."
                },
                stockReports: {
                  title: "Complementa la gestión de inventarios de tu negocio, descargando reportes especiales",
                  subtitle: "Historial de productos",
                  productsHistory: "Consulta el historial de movimiento de inventario a diario.",
                  productsReports: "Descarga tu reporte de ventas de productos."
                }
              }
            },
            managementReports: {
              meta: {
                title: "Reportes de Gestión: Ventas, marketing, reservas, y más con AgendaPro",
                description: "Controla tu negocio y aumenta tu rentabilidad con los reportes de gestión automáticos de AgendaPro. Da click acá y pide tu demo gratis.",
                keyword: "reportes de gestion"
              },
              menuName: "Reportes de Gestión",
              body: {
                title: "Reportes de Gestión: Ventas, marketing, reservas, y más",
                subtitle: "¡Todas las tendencias de tu negocio en un solo lugar!",
                intelligentDecisions: {
                  title: "Toma las decisiones de negocio más asertivas e inteligentes para poder crecer más rápido.",
                  subtitle: "Reportes de gestión",
                  knowledge: "Conocimiento acabado de tus operaciones en relación a la demanda y ocupación.",
                  intelligentReporting: "¡Reporting de inteligencia de negocios completo y adaptado a tu realidad!"
                },
                attendanceReports: {
                  title: "¿Sabes cuál es el porcentaje de público y verdaderamente asiste a tu negocio?",
                  subtitle: "Reportes de asistencia",
                  graphs: "Obtén gráficos con asistencia por servicio o prestación",
                  nonAttendanceRate: "Tasa de inasistencia de clientes e Historial de citas descargable."
                }
              }
            },
            cloudStorage: {
              meta: {
                title: "Almacenamiento en la nube: velocidad y seguridad con AgendaPro",
                description: "Accede a tu agenda, reportes, caja y pagos desde cualquier lugar con el almacenamiento en la nube de AgendaPro. Da click acá y pide tu demo gratis.",
                keyword: "almacenamiento en la nube"
              },
              menuName: "Almacenamiento en la Nube",
              body: {
                title: "Almacenamiento en la nube: Usuriaos, roles, datos y más",
                subtitle: "¡Conéctate desde cualquier dispositivo de forma segura!",
                backups: {
                  title: "Obtén el respaldo y la accesibilidad que necesitas",
                  subtitle: "Guardar archivos en la nube",
                  backupsFiles: "Cada dato guardado en la plataforma queda respaldado, por lo que no debes preocuparte.",
                  fileRepository: "Puedes acudir a la opción de repositorio de archivos para guardar documentos y exámenes."
                }
              }
            },
            movilApp: {
              meta: {
                title: "Aplicación móvil: Personalizada, fidelización, y más con AgendaPro",
                description: "Deslumbra a tus clientes con la aplicación móvil personalizada de AgendaPro, y aumenta tus ingresos. Da click acá y pide tu demo gratis.",
                keyword: "aplicacion movil"
              },
              menuName: "Aplicación Móvil",
              body: {
                title: "Aplicación móvil: Personalizada, fidelización, y más",
                subtitle: "¡Obtén la App de tu negocio!",
                movilCustomApp: {
                  title: "La vía más exclusiva para que tus clientes agenden sus citas",
                  subtitle: "Aplicación de tu negocio",
                  bookingHistory: "Historial de citas para tu cliente.",
                  promotions: "¡Envía promociones y comunicados a tu público fácilmente!"
                },
                clientLoyalty: {
                  title: "Mantén una estrecha comunicación con tus clientes",
                  subtitle: "Fideliza a tus clientes",
                  diferentiate: "¡Diferencia y posiciona tu marca con tu App personalizada!"
                }
              }
            },
            rips: {
              meta: {
                title: "Reportes RIPS: Genere archivos RIPS automáticamente con AgendaPro",
                description: "Genera todos los archivos fácilmente para cumplir con la normativa. RIPS automáticos con AgendaPro. Da click acá y pide tu demo gratis.",
                keyword: "RIPS"
              },
              menuName: "RIPS",
              body: {
                title: "Reportes RIPS: Genere todos los archivos RIPS automáticamente",
                subtitle: "Archivos RIPS",
                ripsDetails: {
                  title: "Genere todos los archivos RIPS automáticamente",
                  subtitle: "Archivos RIPS",
                  ripsHistory: "Consulte todo el historial de remisiones de RIPS de su empresa.",
                  fastRips: "Diligencie los RIPS fácil y oportunamente ante la secretaria de salud."
                }
              }
            },
            satisfactionSurvey: {
              meta: {
                title: "Encuesta de Satisfacción: Percepción, medición de calidad, y más",
                description: "Controla tu negocio y evalúa tu satisfacción con las encuestas personalizables de AgendaPro. Da click acá y pide tu demo gratis.",
                keywords: "encuesta de satisfaccion"
              },
              body: {
                title: "Encuesta de Satisfacción: Visualice en tiempo real la calidad percibida de sus servicios",
                subtitle: "Encuestas de satisfacción",
                realtimeQuality: {
                  title: "Visualice en tiempo real la calidad percibida de sus servicios",
                  subtitle: "Encuestas de satisfacción",
                  levelOfCare: "Evalúe el nivel de atención de cada profesional y de sus servicios.",
                  sendSatisfactionSurvey: "¡Envíe encuestas de satisfacción personalizadas automáticamente!"
                }
              }
            }
          },
          economicSectors: {
            barbershop: {
              meta: {
                title: "Software para Barberías: Descubre los beneficios de AgendaPro",
                description: "Aumenta tus ingresos y Ahorra tiempo de tu Barbería con el Software para Barberías todo en uno de AgendaPro. Da click acá y pide tu demo gratis.",
                keyword: "software para barberias"
              },
              body: {
                title: "Software para Barberías:",
                subtitle: "Simplifica tu vida y haz crecer tu Barbería",
                mainMessage: "falta",
                bullets: {
                  saveTime: {
                    title: "Ahorra tiempo"
                  },
                  controlBarbershop: {
                    title: "Controla tu Barbería"
                  },
                  moreRevenue: {
                    title: "Aumenta tus ingresos"
                  }
                },
                detail: {
                  saveTime: {
                    title: "Ahorra tiempo",
                    bookingsWhenClosed: "¿Sabías que el 42% de las reservas se agendan cuándo tu Barbería está cerrada?",
                    moreOnlineBookings: "¿Te gustaría que tus clientes reserven online desde tu Fanpage de Facebook o sitio web sincronizado en tiempo real con tu agenda?",
                    timeWithAP: "¡No pierdas más tiempo, la respuesta es AgendaPro!",
                    linkToOnlineBooking: "Agenda Online"
                  },
                  controlBarbershop: {
                    title: "Controla tu Barbería",
                    moreControl: "¿Te interesa tener un control total de tu Barbería?",
                    APForBarbers: "Esto es lo que AgendaPro puede hacer por ti: Sistema de caja intuitivo, cálculo automático de comisiones para tus profesionales, Control de Inventario de productos automatizado, y mucho más",
                    linkToPayControl: "Control de pagos",
                    linkToStockControl: "Control de Inventarios"
                  },
                  moreRevenue: {
                    title: "Aumenta tus ingresos",
                    How: "¿Cómo?",
                    answserBarbersMarketing: "La respuesta es simple: Crea promociones para fidelizar a tus clientes, Obtén indicadores de tu gestión de envío de e-mail masivos, y deja que AgendaPro segmente a  tus clientes para enviar la promoción correcta. ",
                    answerBarbersProductivity: "Automotizando y optimizando tu gestión, podrás duplicar tus ventas y mejorar tu negocio.",
                    linkToMarketing: "Marketing a Clientes"
                  }
                },
                appBanner: {
                  title: "Solicita tu app personalizada sólo para tu Barbería",
                  subtitle: "La vía más exclusiva para que tus clientes agenden sus citas"
                }
              }
            },
            medicCenter: {
              meta: {
                title: "Software para Centro Médico: Descubre los beneficios de AgendaPro",
                description: "Controla tu Centro Médico con la Ficha Clínica y Agenda Médica del software para Centro Médico de AgendaPro. Da click acá y pide tu demo gratis.",
                keyword: "software para centro medico"
              },
              body: {
                title: "Software para Centro Médico:",
                subtitle: "Simplifica tu vida y haz crecer tu Centro Médico",
                mainMessage: "falta",
                bullets: {
                  saveTime: {
                    title: "Ahorra tiempo"
                  },
                  controlMedicCenter: {
                    title: "Controla tu Centro Médico"
                  },
                  patientsLoyalty: {
                    title: "Fideliza a tus Pacientes"
                  }
                },
                detail: {
                  saveTime: {
                    title: "Ahorra tiempo",
                    consolidatedRegister: "¿No tienes un registro consolidado de la información de tus pacientes?",
                    updateAgenda: "¿Te gustaría poder tener tu agenda actualizada en todo momento sin mayor esfuerzo?",
                    checkFeatures: "Revisa las siguientes funcionalidades que permitirán enfocarte en lo que importa, ¡tus pacientes!",
                    linkToMedicalHistory: "Historia Clínica Personalizada",
                    linkToMedicalRecords: "Ficha Clínica Personalizada",
                    linkToMedicalAgenda: "Agenda Médica Online"
                  },
                  controlMedicCenter: {
                    title: "Controla tu Centro Médico",
                    knowledgeMedicCenter: "¿Sabes lo que pasa en tu centro médico en todo momento?",
                    realtimeAnytime: "¿Te gustaría poder acceder a estado de pagos en tiempo real, y desde cualquier lugar?",
                    findBenefits: "Descubre cómo te ayudará el sistema de pago y cuentas de pacientes, y almacenamiento en la nube.",
                    linkToPayments: "Control de Pagos",
                    linkToCloudStorage: "Almacenamiento en la Nube"
                  },
                  patientsLoyalty: {
                    title: "Fideliza a tus pacientes",
                    knowYourPatients: "¿Sabes quiénes son tus pacientes más leales? o",
                    patientsControl: "¿Cuándo deben volver a control?",
                    marketingTools: "Deja que las herramientas de marketing de AgendaPro lo hagan por ti. Revisa las siguientes herramientas:",
                    linkToMarketing: "Marketing a pacientes"
                  }
                },
                appBanner: {
                  title: "Solicita tu app personalizada sólo para tu Centro Médico",
                  subtitle: "La vía más exclusiva para que tus clientes agenden sus citas"
                }
              }
            },
            aestheticCenter: {
              meta: {
                title: "Software para Centros de Estética: Descubre los beneficios de AgendaPro",
                description: "Ahorra tiempo y aumenta los ingresos de tu Centro con el Software para Centros de Estética de AgendaPro. Da click acá y pide tu demo gratis.",
                keyword: "software para centro de estetica"
              },
              body: {
                title: "Software para Centros de Estética:",
                subtitle: "Simplifica tu vida y haz crecer tu Centro de Estética",
                mainMessage: "falta",
                bullets: {
                  saveTime: {
                    title: "Ahorra tiempo"
                  },
                  controlAestheticCenter: {
                    title: "Controla tu Centro de Estética"
                  },
                  moreRevenue: {
                    title: "Aumenta tus ingresos"
                  }
                },
                detail: {
                  saveTime: {
                    title: "Ahorra tiempo",
                    consolidatedRegister: "¿No tienes un registro consolidado de la información de tus pacientes?",
                    updateAgenda: "¿Te gustaría poder tener tu agenda actualizada en todo momento sin mayor esfuerzo?",
                    checkFeatures: "Revisa las siguientes funcionalidades que permitirán enfocarte en lo que importa, ¡tus pacientes!",
                    linkToMedicalHistory: "Historia Clínica Personalizada",
                    linkToMedicalRecords: "Ficha Clínica Personalizada",
                    linkToMedicalAgenda: "Agenda Médica Online"
                  },
                  controlAestheticCenter: {
                    title: "Controla tu Centro de Estética",
                    knowIncomeExpenses: "¿Sabes los ingresos y egresos de tu Centro de Estética en todo momento?",
                    cashSystemRealtime: "¿Te gustaría poder acceder a estado de pagos en tiempo real, y desde cualquier lugar?",
                    checkFeatures: "Descubre cómo te ayudará el sistema de pago y cuentas de pacientes:",
                    linkToPayments: "Control de Pagos",
                    linkToCloudStorage: "Almacenamiento en la Nube"
                  },
                  moreRevenue: {
                    title: "Aumenta tus ingresos",
                    knowYourPatients: "¿Sabes quiénes son tus pacientes más leales, o los más rentables?",
                    returnTreatment: "¿Cuándo deben volver a un tratamiento?",
                    marketingTools: "Deja que las herramientas de marketing de AgendaPro lo hagan por ti con sus promociones inteligentes:",
                    linkToMarketing: "Marketing a pacientes"
                  }
                },
                appBanner: {
                  title: "Solicita tu app personalizada sólo para tu Centro de Estética",
                  subtitle: "La vía más exclusiva para que tus clientes agenden sus citas"
                }
              }
            },
            clinic: {
              meta: {
                title: "Software para Clínica: Descubre los beneficios de AgendaPro",
                description: "Controla tu Clínica con la Ficha Clínica, Agenda Médica y más del software para Clínica de AgendaPro. Da click acá y pide tu demo gratis.",
                keyword: "software para clinica"
              },
              body: {
                title: " Software para Clínica:",
                subtitle: "Simplifica tu vida y haz crecer tu Clínica",
                mainMessage: "falta",
                bullets: {
                  saveTime: {
                    title: "Ahorra tiempo"
                  },
                  controlClinic: {
                    title: "Controla tu Clínica"
                  },
                  patientsLoyalty: {
                    title: "Fideliza a tus pacientes"
                  }
                },
                detail: {
                  saveTime: {
                    title: "Ahorra tiempo",
                    consolidatedRegister: "¿Tienes un registro consolidado de la información e historia de tus pacientes? ",
                    realtimeAnywhere: "¿Te gustaría poder tener tu agenda actualizada en todo momento con un clic?",
                    checkFeatures: "Revisa las siguientes funcionalidades que permitirán enfocarte en lo que importa, ¡tus pacientes!",
                    linkToMedicalHistory: "Historia Clínica Personalizada",
                    linkToMedicalRecords: "Ficha Clínica Personalizada",
                    linkToMedicalAgenda: "Agenda Médica Online"
                  },
                  controlClinic: {
                    title: "Controla tu Clínica",
                    knowClinic: "¿Tienes el control de tu Clínica en tiempo real?",
                    cashSystemRealtime: "¿Te gustaría poder acceder al desempeño diario desde cualquier lugar?",
                    checkFeatures: "Descubre cómo te ayudará el sistema de pago, cuentas de pacientes y almacenamiento en la nube:",
                    linkToPayments: "Control de Pagos",
                    linkToCloudStorage: "Almacenamiento en la Nube"
                  },
                  patientsLoyalty: {
                    title: "Fideliza a tus pacientes",
                    knowYourPatients: "¿Sabes quiénes son tus mejores pacientes? o",
                    returnTreatment: "¿Cuándo deben volver a control nuevamente?",
                    checkFeatures: "Deja que las herramientas de marketing de AgendaPro lo hagan por ti. Revisa las siguientes herramientas:",
                    linkToMarketing: "Marketing a pacientes"
                  }
                },
                appBanner: {
                  title: "Solicita tu app personalizada sólo para tu Clínica",
                  subtitle: "La vía más exclusiva para que tus clientes agenden sus citas"
                }
              }
            },
            gym: {
              meta: {
                title: "Software para Gimnasio: Descubre los beneficios de AgendaPro",
                description: "Fideliza a tus clientes y aumenta los ingresos de tu Centro con el software para Gimnasio de AgendaPro. Da click acá y pide tu demo gratis.",
                keyword: "software para gimnasio"
              },
              body: {
                title: "Software para Gimnasio:",
                subtitle: "Simplifica tu vida y haz crecer tu Gimnasio",
                mainMessage: "",
                bullets: {
                  saveTime: {
                    title: "Ahorra tiempo"
                  },
                  controlGym: {
                    title: "Controla tu Gimnasio"
                  },
                  moreRevenue: {
                    title: "Aumenta tus ingresos"
                  }
                },
                detail: {
                  saveTime: {
                    title: "Ahorra tiempo",
                    bookingsWhenClosed: "¿Sabías que el 42% de las reservas se agendan cuándo tu Gimnasio está cerrada?",
                    onlineBooking: "¿Te gustaría que tus clientes reserven online desde tu Fanpage de Facebook o sitio web sincronizado en tiempo real con tu agenda?",
                    dontLoseTime: "No pierdas más tiempo, ¡la respuesta es AgendaPro!"
                  },
                  controlGym: {
                    title: "Controla tu Gimnasio",
                    totalControl: "¿Te interesa tener un control total de tu Gimnasio?",
                    featuresForGym: "Esto es lo que AgendaPro puede hacer por ti: Sistema de Caja Intuitivo, cálculo automático de Comisiones para tus profesionales, Control de Inventario de productos automatizado, y mucho más"
                  },
                  moreRevenue: {
                    title: "Aumenta tus ingresos",
                    howRevenueGym: "¿Cómo? La respuesta es simple: Crea promociones para fidelizar a tus clientes",
                    indicatorsGym: "Obtén indicadores de tu gestión con envío de e-mail masivos y deja que AgendaPro segmente a  tus clientes para enviar la promoción correcta.",
                    knowForGrowth: "Identifica de forma simple el comportamiento de tus clientes y planifica tu crecimiento con los datos correctos."
                  }
                },
                appBanner: {
                  title: "Solicita tu app personalizada sólo para tu Gimnasio",
                  subtitle: "La vía más exclusiva para que tus clientes agenden sus citas"
                }
              }
            },
            alternativeMedicine: {
              meta: {
                title: "Software para centro de Medicina Alternativa de AgendaPro",
                description: "Mantén el control con la Ficha Clínica, y Agenda del software para centro de Medicina Alternativa de AgendaPro. Da click acá y pide tu demo gratis.",
                keyword: "software para centro de medicina alternativa"
              },
              body: {
                title: "Software para Centro de Medicina Alternativa:",
                subtitle: "Simplifica tu vida y haz crecer tu centro de Medicina Alternativa",
                mainMessage: "",
                bullets: {
                  saveTime: {
                    title: "Ahorra tiempo"
                  },
                  controlAlternativeMedicine: {
                    title: "Controla tu centro de Medicina Alternativa"
                  },
                  moreRevenue: {
                    title: "Fideliza a tus pacientes"
                  }
                },
                detail: {
                  saveTime: {
                    title: "Ahorra tiempo",
                    bookingsWhenClosed: "¿No tienes un registro consolidado de la información de tus pacientes?",
                    onlineBooking: "¿Te gustaría poder tener tu agenda actualizada en todo momento sin mayor esfuerzo?",
                    dontLoseTime: "Revisa las siguientes funcionalidades que permitirán enfocarte en lo que importa, tus pacientes!",
                    linkToMedicalHistory: "Historia Clínica Personalizada",
                    linkToMedicalRecords: "Ficha Clínica Personalizada",
                    linkToMedicalAgenda: "Agenda médica online"
                  },
                  controlAlternativeMedicine: {
                    title: "Controla tu centro de Medicina Alternativa",
                    totalControl: "¿Te interesa tener un control total de tu Negocio?",
                    featuresForAlternativeMedicine: "Esto es lo que AgendaPro puede hacer por ti: Sistema de pagos intuitivo, cálculo automático de comisiones para tus profesionales, Control de Inventario de productos automatizado y mucho más.",
                    linkToPayControl: "Control de pagos",
                    linkToCloudStorage: "Almacenamiento en la nube"
                  },
                  moreRevenue: {
                    title: "Fideliza a tus pacientes",
                    howRevenueAlternativeMedicine: "¿Cómo? La respuesta es simple: Crea promociones para fidelizar a tus clientes",
                    indicatorsAlternativeMedicine: "Obtén indicadores de tu gestión de envío de e-mail masivos, y deja que AgendaPro segmente a tus clientes para enviar la promoción correcta.",
                    linkToMarketing: "Marketing a clientes"
                  }
                },
                appBanner: {
                  title: "Solicita tu app personalizada sólo para tu Centro",
                  subtitle: "La vía más exclusiva para que tus clientes agenden sus citas"
                }
              }
            },
            business: {
              meta: {
                title: "Software para Negocios: Descubre los beneficios de AgendaPro",
                description: "Controla tu negocio, mejora tu gestión y aumenta los ingresos con el software para negocios de AgendaPro. Da click acá y pide tu demo gratis.",
                keyword: "software para negocios"
              },
              body: {
                title: "Software para Negocios:",
                subtitle: "Simplifica tu vida y haz crecer tu Negocio",
                mainMessage: "",
                bullets: {
                  saveTime: {
                    title: "Ahorra tiempo"
                  },
                  controlBusiness: {
                    title: "Controla tu Negocio"
                  },
                  moreRevenue: {
                    title: "Aumenta tus ingresos"
                  }
                },
                detail: {
                  saveTime: {
                    title: "Ahorra tiempo",
                    bookingsWhenClosed: "¿Sabías que el 42% de las reservas se agendan cuándo tu Negocio está cerrado?",
                    onlineBooking: "¿Te gustaría que tus clientes reserven online desde tu Fanpage de Facebook o sitio web sincronizado en tiempo real con tu agenda?",
                    dontLoseTime: "No pierdas más tiempo, ¡la respuesta es AgendaPro!",
                    linkToOnlineBooking: "Agenda online"
                  },
                  controlBusiness: {
                    title: "Controla tu Negocio",
                    totalControl: "¿Te interesa tener un control total de tu Negocio?",
                    featuresForBusiness: "Esto es lo que AgendaPro puede hacer por ti: Sistema de pagos intuitivo, cálculo automático de comisiones para tus profesionales, Control de Inventario de productos automatizado y mucho más.",
                    linkToPayControl: "Control de pagos",
                    linkToStockControl: "Control de inventarios"
                  },
                  moreRevenue: {
                    title: "Aumenta tus ingresos",
                    howRevenueHairSalon: "¿Cómo? La respuesta es simple: Crea promociones para fidelizar a tus clientes",
                    indicatorsHairSalon: "Obtén indicadores de tu gestión de envío de e-mail masivos, y deja que AgendaPro segmente a tus clientes para enviar la promoción correcta.",
                    linkToMarketing: "Marketing a clientes"
                  }
                },
                appBanner: {
                  title: "Solicita tu app personalizada sólo para tu negocio",
                  subtitle: "La vía más exclusiva para que tus clientes agenden sus citas"
                }
              }
            },
            hairSalon: {
              meta: {
                title: "Software para Peluquerías: Descubre los beneficios de AgendaPro",
                description: "Aumenta tus ingresos y Ahorra tiempo de tu Peluquería con el Software para Peluquerías todo en uno de AgendaPro. Da click acá y pide tu demo gratis.",
                keyword: "software para peluquerias"
              },
              body: {
                title: "Software para Peluquerías:",
                subtitle: "Simplifica tu vida y haz crecer tu Peluquería",
                mainMessage: "",
                bullets: {
                  saveTime: {
                    title: "Ahorra tiempo"
                  },
                  controlHairSalon: {
                    title: "Controla tu Peluquería"
                  },
                  moreRevenue: {
                    title: "Aumenta tus ingresos"
                  }
                },
                detail: {
                  saveTime: {
                    title: "Ahorra tiempo",
                    bookingsWhenClosed: "¿Sabías que el 42% de las reservas se agendan cuándo tu Peluquería está cerrada?",
                    onlineBooking: "¿Te gustaría que tus clientes reserven online desde tu Fanpage de Facebook o sitio web sincronizado en tiempo real con tu agenda?",
                    dontLoseTime: "No pierdas más tiempo, ¡la respuesta es AgendaPro!",
                    linkToOnlineBooking: "Agenda Online"
                  },
                  controlHairSalon: {
                    title: "Controla tu Peluquería",
                    totalControl: "¿Te interesa tener un control total de tu Peluquería?",
                    featuresForHairSalon: "Esto es lo que AgendaPro puede hacer por ti: Sistema de pagos intuitivo, cálculo automático de comisiones para tus profesionales, Control de Inventario de productos automatizado y mucho más.",
                    linkToPayControl: "Control de pagos",
                    linkToStockControl: "Control de Inventarios"
                  },
                  moreRevenue: {
                    title: "Aumenta tus ingresos",
                    howRevenueHairSalon: "¿Cómo? La respuesta es simple: Crea promociones para fidelizar a tus clientes",
                    indicatorsHairSalon: "Obtén indicadores de tu gestión de envío de e-mail masivos, y deja que AgendaPro segmente a tus clientes para enviar la promoción correcta.",
                    linkToMarketing: "Marketing a Clientes"
                  }
                },
                appBanner: {
                  title: "Solicita tu app personalizada sólo para tu Peluquería",
                  subtitle: "La vía más exclusiva para que tus clientes agenden sus citas"
                }
              }
            },
            beautySalon: {
              meta: {
                title: "Software para Salón de Belleza: Descubre los beneficios de AgendaPro",
                description: "Aumenta tus ingresos y Ahorra tiempo de tu Salón de Belleza con el Software para Salón de Belleza todo en uno de AgendaPro. Da click acá y pide tu demo gratis.",
                keyword: "software para salon de belleza"
              },
              body: {
                title: "Software para Salón de Belleza:",
                subtitle: "Simplifica tu vida y haz crecer tu Salón de Belleza",
                mainMessage: "",
                bullets: {
                  saveTime: {
                    title: "Ahorra tiempo"
                  },
                  controlBeautySalon: {
                    title: "Controla tu Salón de Belleza"
                  },
                  moreRevenue: {
                    title: "Aumenta tus ingresos"
                  }
                },
                detail: {
                  saveTime: {
                    title: "Ahorra tiempo",
                    bookingsWhenClosed: "¿Sabías que el 42% de las reservas se agendan cuándo tu Salón está cerrado?",
                    moreOnlineBookings: "¿Te gustaría que tus clientes reserven online desde tu fanpage de facebook o sitio web sincronizado en tiempo real con tu agenda?",
                    dontLoseTime: "No pierdas más tiempo, la respuesta es Agendapro!",
                    linkToOnlineBooking: "Agenda Online"
                  },
                  controlBeautySalon: {
                    title: "Controla tu Salón de Belleza",
                    moreControl: "¿Te interesa tener un control total de tu Salón?",
                    APForBeautySalon: "Esto es lo que AgendaPro puede hacer por ti: Sistema de pagos intuitivo, cálculo automático de comisiones para tus profesionales, Control de Inventario de productos automatizado, y mucho más",
                    linkToPayControl: "Control de pagos",
                    linkToStockControl: "Control de Inventarios"
                  },
                  moreRevenue: {
                    title: "Aumenta tus ingresos",
                    howRevenueBeautySalon: "¿Cómo? La respuesta es simple:",
                    indicatorsBeautySalon: "Crea promociones para fidelizar a tus clientes, obtén indicadores de tu gestión de envío de e-mail masivos, y deja que AgendaPro segmente a tus clientes para enviar la promoción correcta.",
                    linkToMarketing: "Marketing a Clientes"
                  }
                },
                appBanner: {
                  title: "Solicita tu app personalizada sólo para tu Salón",
                  subtitle: "La vía más exclusiva para que tus clientes agenden sus citas"
                }
              }
            },
            spa: {
              meta: {
                title: "Software para Spa: Descubre los beneficios de AgendaPro",
                description: "Fideliza a tus clientes, aumenta tus ingresos y mejora la gestión con el software para Spa de AgendaPro. Da click acá y pide tu demo gratis.",
                keyword: "software para spa"
              },
              body: {
                title: "Software para Spa:",
                subtitle: "Simplifica tu vida, y haz crecer tu Spa",
                mainMessage: "",
                bullets: {
                  saveTime: {
                    title: "Ahorra tiempo"
                  },
                  controlSpa: {
                    title: "Controla tu Spa"
                  },
                  moreRevenue: {
                    title: "Aumenta tus ingresos"
                  }
                },
                detail: {
                  saveTime: {
                    title: "Ahorra tiempo",
                    bookingsWhenClosed: "¿Sabías que el 42% de las reservas se agendan cuándo tu Spa está cerrada?",
                    moreOnlineBookings: "¿Te gustaría que tus clientes reserven online desde tu Fanpage de Facebook o sitio web sincronizado en tiempo real con tu agenda?",
                    dontLoseTime: "No pierdas más tiempo, ¡la respuesta es AgendaPro!",
                    linkToOnlineAgenda: "Agenda Online",
                    linkToClientLoyalty: "Fidelización de Clientes"
                  },
                  controlSpa: {
                    title: "Controla tu Spa",
                    moreControl: "¿Te interesa tener un control total de tu Spa?",
                    APForSpa: "Esto es lo que AgendaPro puede hacer por ti: Sistema de caja intuitivo, cálculo automático de comisiones para tus profesionales, Control de Inventario de productos automatizado, y mucho más.",
                    linkToPayControl: "Control de Pagos",
                    linkToStockControl: "Control de Inventarios"
                  },
                  moreRevenue: {
                    title: "Aumenta tus ingresos",
                    howRevenueSpa: "¿Cómo? La respuesta es simple:",
                    indicatorsSpa: "Crea promociones para fidelizar a tus clientes, obtén indicadores de tu gestión de envío de e-mail masivos, y deja que AgendaPro segmente a tus clientes para enviar la promoción correcta.",
                    linkToMarketing: "Marketing a Clientes"
                  }
                },
                appBanner: {
                  title: "Solicita tu app personalizada sólo para tu Spa",
                  subtitle: "La vía más exclusiva para que tus clientes agenden sus citas"
                }
              }
            }
          }
        }
      },
      callToAction: {
        buttonStyle1: "Solicita tu Demo",
        buttonStyle2: "¡Solicitalo Ahora!",
        buttonStyle3: "Crear Cuenta",
        buttonStyle4: "Prueba Gratis",
        view: "Ver",
        viewPlan: "Ver",
        actions: "Acciones",
        dte: "Generar DTE"
      },
      hi: "Hola",
      save: "guardar",
      cancel: "cancelar",
      "new": "nuevo",
      service: "Servicio",
      booking: "Reserva",
      bookings: "Reservas",
      product: "producto",
      products: {
        abreviate: "Inv.",
        stock: "stock",
        activate: "Activar",
        deactivate: "Desactivar",
        inventory: "Inventario",
        h4MassiveLoad1: "Planilla para cargar o modificar masivamente el Inventario de Productos.",
        h4MassiveLoad2: "Consejos para una carga o modificación exitosa:",
        downloadButtonText: "Descargar inventario",
        saveButtonTextSubmodal: "Agregar",
        deleteButtonText: "Eliminar",
        modalTitleAddCategory: "Nueva categoría",
        modalTitleAddUnit: "Nueva unidad",
        modalTitleAddBrand: "Nueva marca",
        titlePanelOneModalProduct: "datos del producto",
        titlePanelStockHistory: "Historial del stock",
        nameProductPlaceholder: "Nombre del producto",
        nameProductLabel: "Nombre del producto",
        skuProductPlaceholder: "SKU / Código de barras",
        skuProductLabel: "SKU / Código de barras",
        brandProductLabel: "Marca",
        newBrandLabel: "+ Nueva marca",
        newBrandModalLabel: "Nueva marca",
        newBrandModalPlaceholder: "nombre de nueva marca",
        quickAddButtonSave: "Agregar",
        categoryProductLabel: "Categoría",
        newCategoryLabel: "+ Nueva categoría",
        newCategoryModalLabel: "Nueva categoría",
        newCategoryModalPlaceholder: "nombre de nueva categoría",
        unitProductLabel: "Formato",
        unitProductPlaceholder: "Formato",
        newUnitProductLabel: "+ Nuevo formato",
        newUnitModalLabel: "Nuevo formato",
        newUnitModalPlaceholder: "nombre de nuevo formato",
        tableDateLabel: "Fecha",
        tableLocationLabel: "Local",
        tableStaffLabel: "Staff",
        tableChangeLabel: "Ajuste",
        tableCauseLabel: "Motivo",
        tableNotesLabel: "Comentario",
        tableProductLabel: "Producto",
        tableClientLabel: "Cliente",
        tableStockQuantity: "Cantidad en stock",
        locationsLabel: "Locales",
        buyCostLabel: "Costo de compra",
        externalPriceLabel: "Precio de venta externa",
        internalPriceLabel: "Precio de venta interna",
        saleCommission: "Comisión de venta",
        descriptionLabel: "Descripción",
        descriptionPlaceholder: "Aquí puedes ingresar una breve descripción del producto.",
        massiveUpload: "Carga Masiva",
        quicksearch: "Búsqueda por nombre, SKU",
        product: "Producto",
        category: "Categoría",
        brand: "Marca",
        options: "opciones",
        locations: "Locales",
        locationSelected: "Local seleccionado",
        locationsSelected: "Locales seleccionados",
        allLocationsSelected: "Todos los Locales",
        newProduct: "Nuevo producto",
        stockInLocations: "Stock en locales",
        stockInLocationsDescription: "Aquí puedes ingresar el stock del producto en locales.",
        causePlaceHolder: "Aquí puedes ingresar un breve motivo del cambio de stock.",
        commisionTooltip: "Si la persona que vende este producto percibe una comisión al realizarlo, puedes definir esto acá y después ver en la sección 'Reportes' el detalle de estas comisiones. Se pueden definir tanto como un porcentaje del precio del servicio o un valor fijo.",
        internalSaleTooltip: "Si vendes productos a tus prestadores, éste será el precio sugerido de venta, calculado como el costo del producto más IVA. De todas formas, al agregar vender productos podrás cambiar el precio de venta si lo deseas.",
        externalSaleTooltip: "Si vendes productos a terceros, éste será el precio sugerido de venta. De todas formas, vender productos podrás cambiar el precio de venta si lo deseas.",
        buyCostTooltip: "El costo al cual adquieres el producto desde tus proveedores.",
        advices: ["No modifiques o cambies Nombre y ordern de las columnas.", "Evita modificar valores de los productos ya creados sin considerar su stock actual.", "Al modificar un producto, los registros Categoría, Marca, Formato debes respetar las mayúsculas/minúsculas. De lo contario, se considera un nuevo registro.", "Permite archivos Excel 2003 hacia adelante y OpenOffice.", "Las extensiones de archivo admitidas son “.xls” o “.xlsx”.", "El identificador único de cada producto se denomina SKU: Si hay 2 o más productos con un mismo SKU, se mantendrá el último y los otros se descartarán. Si el SKU no existe, se considerará como nuevo producto."],
        locationAlarms: "Alarmas de local",
        unit: "Formato",
        alarms: "Alarmas",
        nameRequired: "Nombre del producto no puede estar en blanco.",
        categoryRequired: "Categoría no puede estar en blanco.",
        brandRequired: "Marca no puede estar en blanco.",
        displayRequired: "Formato no puede estar en blanco.",
        costRequired: "Costo de compra no puede estar en blanco.",
        internalPriceRequired: "Precio de venta Interna no puede estar en blanco.",
        deactivateTitle: "¿Estás seguro de desactivar el producto?",
        deactivateDescription: "Al desactivar el producto no estará habilitada su venta",
        activateTitle: "¿Estás seguro de reactivar el producto?",
        activateDescription: "Al activar el producto se habilitará su venta",
        activatedSuccess: "Producto activado con exito",
        deactivatedSuccess: "Producto desactivado con exito",
        stockUp: "Aumentar stock",
        "stockUp-desc": "Aquí podrás aumentar el stock existente del producto por cada local.",
        stockDown: "Disminuir stock",
        comments: "comentarios",
        commentPlaceholder: "Puedes agregar una nota por el aumento de stock.",
        reduceCommentPlaceholder: "Puedes agregar una nota por la reducción de stock.",
        "stockDown-desc": "Ingresa aquí la cantidad de stock a disminuir al ya existente por cada local.",
        important: "Importante",
        "stockDown-subdesc": "Si ingresas un número mayor a la cantidad actual, ésta quedará en 0.",
        unselectFile: "No se seleccionó archivo.",
        wrongFormatFile: "La extensión del archivo no es correcta. Sólo se pueden importar archivos xls y xlsx.",
        notificationsEmail: "Email para notificaciones",
        "notificationsEmail-desc": "Ingresa los correos que recibirán los avisos, ingresar varios correos separados por coma: ejemplo1@agendapro.com, ejemplo2@agendapro.com",
        productAlarm: "Alarma de producto",
        "productAlarm-desc": "Aquí podrás configurar las notificaciones de stock del producto",
        locationAlarm: "Alertas de locales",
        "locationAlarm-desc": "Aquí podrás configurar las notificaciones de stock del local",
        "email-desc": " Registra los correos a los que se enviarán las notificaciones. Puedes ingresa varios correos separados por coma: ejemplo1@agendapro.com, ejemplo2@agendapro.com.",
        activateInstantAlert: "Activar avisos inmediatos",
        "activateInstantAlert-desc": " Activa esta opción para recibir un email cada vez que un producto baje de su límite de stock.",
        activateGeneralStockLimit: "Activar stock límite general",
        "activateGeneralStockLimit-desc": "Activa esta opción para establecer un límite de stock general de todos los productos.",
        stockLimit: "Stock límite",
        "stockLimit-desc": "Establece el límite (número) de stock general. La alarma se activará si el stock está bajo este límite.",
        activatePeriodicNotification: "Activar avisos periódicos",
        "activatePeriodicNotification-desc": " Establece el límite (número) de stock general. La alarma se activará si el stock está bajo este límite.",
        frecuency: "Frecuencia",
        dayOfTheWeek: "Día de la semana",
        dayOfTheMonth: "Día del mes",
        transfer: "Traspasar",
        transferStock: "Traspasar stock",
        "transferStock-desc": "Aquí podrás mover el stock de un producto en un local a otro.",
        locationOrigin: "Local de origen",
        "locationOrigin-desc": "Stock disponible en el local de origen:",
        destinationLocation: "Local de destino",
        "destinationLocation-desc": "Stock actual en el local de destino:",
        transferAmount: "Stock a traspasar al local de destino:",
        download: "Descargar inventario",
        "comments-placeholder": "Puedes agregar una nota por el traspaso de stock entre locales.",
        noStockAvailable: "Stock no disponible.",
        notExist: "No existe el producto en este local",
        remains: "quedan",
        inStock: "en stock",
        logs: {
          create: "Creación manual de producto.",
          initialStock: "Stock inicial %{stock}.",
          increaseOf: "Incremento de %{old} a %{new}.",
          decreaseOf: "Decremento de %{old} a %{new}.",
          manualEdit: "Edición manual de producto.",
          stockChangedByAdmin: "Cambio de stock desde administrador.",
          notEnoughStock: "El stock del producto no es suficiente para el traspaso.",
          stockTransferedByAdmin: "Traspaso de stock desde administrador.",
          importOfProducts: "Importación de productos.",
          createdByImport: "Creación de producto con stock de %{stock}.",
          internalSaleModified: "Modificación de venta interna. Fecha: %{date}",
          internalSale: "Venta interna. Fecha: %{date}",
          internalSaleDeleted: "Eliminación de venta interna. Fecha: %{date}",
          saleAtClient: "Venta a cliente. Fecha: %{paymentDate}",
          deletedSaleAtClient: "Eliminación de venta a cliente. Fecha: %{paymentDate}",
          modifiedSaleAtClient: "Modificación de venta a cliente. Fecha: %{paymentDate}"
        },
        sellerType: {
          type0: "Prestador",
          type1: "Usuario",
          type2: "Cajero"
        },
        report: {
          products: "Productos",
          inactives: "Inactivos",
          sku: "SKU",
          category: "Categoría",
          brand: "Marca",
          name: "Nombre",
          unit: "Formato",
          buyCost: "Costo",
          internalSellingPrice: "Precio venta externa",
          externalSellingPrice: "Precio venta interna",
          commission: "Comisión",
          commissionType: "Tipo de comisión",
          description: "Descripción",
          state: "Estado",
          includesTaxes: "Precio contiene IVA",
          taxRate: "% IVA (vacio por defecto)",
          stock: "Stock"
        }
      },
      payment: {
        onlinePay: "pago en línea",
        payPlan: "Pagar ahora",
        payYourAccount: "paga tu cuenta",
        payYourAccountDesc: "aquí puedes realizar el pago de tu plan de AgendaPro. El detalle lo puedes revisar a continuación.",
        noBillingToPay: "Por favor antes de proceder, completa los siguientes datos:",
        methodSelect: "Selecciona tu método de pago",
        processing: "Estamos procesando tu pago",
        processingDesc: "Tu pago será validado en las próximas 24 horas. Si tienes dudas o necesitas validarlo de inmediato, escríbenos a cuentas@agendapro.com",
        failure: "No fue posible validar tu pago",
        helloUser: "Hola: ",
        yourPlan: "tu plan es"
      },
      price: "Precio",
      salesman: "Vendedor",
      editing: "Editando",
      downpayAction: "Abonar",
      category: "Categoría",
      id: "Id",
      code: "código",
      discount: "Descuento",
      amount: "Monto",
      add: "Agregar",
      sessions: "Sesiones",
      sucursal: "Sucursal",
      width: "Ancho",
      totalsDefault: "Total",
      session: "Sesión",
      generate: "Generar",
      quantity: "Cantidad",
      client: "Cliente",
      clients: {
        activity: "Actividad",
        bookings: "Reservas",
        history: "Historial",
        summary: "Resumen",
        servicesRecord: "Registro de servicios",
        files: "Archivos",
        comments: "Comentarios",
        payments: "Pagos",
        comunication: "Comunicaciones",
        messages: "Mensajería",
        survey: "Encuestas",
        consents: "Consentimientos",
        charts: "Fichas",
        deleted: "Cliente eliminado",
        actions: {
          mergeClients: "Combinar clientes",
          success: {
            mergeSuccess: "Clientes combinados exitosamente."
          },
          errors: {
            mergeFailed: "Error al combinar clientes."
          },
          importClients: {
            success: "Archivo analizado correctamente. Se encontraron los campos %{attributesPresent}, para %{nRows} filas. Se procesará y cargara la información del archivo durante los próximos minutos.",
            errors: {
              unselectFile: "No se seleccionó archivo.",
              wrongFileExtension: "La extensión del archivo no es correcta. Sólo se pueden importar archivos excel (xls, xlsx).",
              emptyList: "Error en el archivo de importación o lista vacía."
            },
            headers: {
              email: "Email",
              emailExplain: "Email del cliente. Debe ser único",
              firstName: "Nombres",
              lastName: "Apellidos",
              name: "Nombre",
              nameExplain: "Nombres y apellidos del cliente",
              firstNameExplain: "Nombres del cliente",
              lastNameExplain: "Apellidos del cliente",
              identificationNumberExplain: "Numero de identidad del cliente. Debe ser único",
              recordNumber: "Número de cliente",
              recordNumberExplain: "Puede ser un número o una palabra seguida de un número",
              phone: "Teléfono",
              phoneExplain: "Teléfono principal del cliente",
              secondPhone: "Teléfono secundario del cliente",
              secondPhoneExplain: "(teléfono oficina, casa, etc.)",
              address: "Dirección",
              addressExplain: "Dirección del cliente",
              city: "Ciudad",
              cityExplain: "Ciudad de residencia.",
              age: "Edad",
              ageExplain: "Edad del cliente",
              gender: "Género. 1 = Femenino, 2 = Masculino",
              genderExplain: "Género del cliente. 1 si es mujer, 2 es hombre",
              birthDay: "Día del nacimiento",
              birthDayExplain: "Número del 1 al 31.",
              birthMonth: "Mes del nacimiento",
              birthMonthExplain: "Número del 1 al 12.",
              birthYear: "Año de nacimiento.",
              createdAt: "Fecha de creación."
            }
          },
          sendSurvey: {
            errors: {
              notActivated: "Primero debes activar el env\xEDo de encuestas desde Configuraciones -> Encuestas"
            }
          }
        },
        modal: {
          bookingsInfo: "Este cliente tiene %{bookingAmount} reserva(s) futuras que serán canceladas."
        },
        infoError: "Información del cliente no válida."
      },
      sessionNumber: "Número de sesiones",
      local: "Local",
      currency: "$",
      search: "Buscar",
      dueDate: "Fecha de vencimiento",
      paydate: "Fecha de pago",
      internalSales: "Ventas internas",
      prev: "Previa",
      next: "Siguiente",
      perPage: " por página",
      dateRange: "Desde / Hasta",
      note: "Nota: ",
      fileType: "Tipo de archivo",
      billNumber: "N° de comprobante",
      dateDefault: "Fecha",
      type: "Tipo",
      brand: "Marca",
      seller: "Vendedor",
      incomes: "Ingresos",
      unity: "unidad",
      unityMeasure: "Formato",
      codePlaceholder: "Ingresa tu código de seguridad",
      paymethod: "Método de pago",
      notes: "Notas",
      searchFor: "Buscar por ",
      searchByType: "Buscar por tipo",
      cashierCode: "Código de autorización requerido",
      cashierCodeDesc: "Debes ingresar el código de caja para poder realizar esta acción",
      noResults: "No hay resultados para mostrar",
      months: "Meses",
      days: "Días",
      hours: "Horas",
      today: "Hoy",
      times: "veces",
      minutes: "Minutos",
      view: "Ver",
      role: "Rol",
      edit: "Editar",
      generateBill: "Generar boleta con alegra",
      month: "Mes",
      payTotal: "Total a pagar",
      download: "Descargar",
      discountMinified: "dcto",
      show: "Ver",
      create: "Crear",
      update: "Actualizar",
      cardNumber: "N de tarjeta",
      transactionDate: "fecha de transaccion",
      providerBreak: "Descansos",
      paymentReport: "Reportes de pagos",
      comissionReport: "Reportes de comisiones",
      notSavedChanges: "Tienes cambios sin guardar. Haz clic en Guardar para mantener estos cambios.",
      company: "compañia",
      transfer: "transferencia",
      subscription: "suscripción",
      emails: "correos",
      description: "Descripción",
      deleteDelay: "El campo fue desactivado y será eliminado en los próximos minutos",
      deleteModal: "¿Estás seguro de querer eliminar este elemento?",
      required: "requerido",
      sayYes: "si",
      sayNo: "no",
      notConfirmed: "falta confirmacion",
      status: "Estado",
      startDate: "fecha de inicio",
      endDate: "fecha de culminacion",
      firstName: "Nombre",
      lastName: "Apellido",
      services: {
        name: "Servicios",
        tabone: "Servicios",
        headlineNew: "Nuevo servicio",
        tabtwo: "Clases",
        tabthree: "Paquetes",
        tabfour: "Categoría de servicios",
        newServButton: "+ Nuevo servicio",
        sessionsAmountError: {
          lessThan: "El número de sesiones debe ser mayor o igual a 2.",
          moreThan: "El número de sesiones debe ser menor o igual a 500."
        },
        minOnlineDownPaymentAmountLessThan: "El valor prepagado debe ser mayor o igual a",
        maxOnlineDownPaymentAmountGreatThan: "El valor prepagado no puede ser mayor al precio del servicio.",
        outcall: "A domicilio"
      },
      serviceProvider: "Prestador",
      serviceProviders: {
        tabone: "Prestadores de servicios",
        tabtwo: "Grupos personalizados"
      },
      classes: "Clases",
      viewDetails: "Ver detalles",
      reserved: "Reservado",
      confirmed: "Confirmado",
      completed: "Asiste",
      cancelled: "Cancelado",
      noshow: "No asiste",
      onhold: "En espera",
      pending: "Pendiente",
      test: "Prueba",
      dropFile: "Arrastrar o seleccionar documento",
      deleted: "Eliminado con exito",
      saved: "Guardado con exito",
      unit: "Símbolo de moneda",
      deletedStatus: "Eliminado",
      monday: "Lunes",
      tuesday: "Martes",
      wednesday: "Miercoles",
      thursday: "Jueves",
      friday: "Viernes",
      saturday: "Sabado",
      sunday: "Domingo",
      totals: "Totales",
      notAttend: "no asistio",
      waiting: "en espera",
      attending: "confirmados",
      modify: "Modificar",
      viewFor: "Ver por",
      seeMore: "ver más",
      seeLess: "ver menos",
      user: "Usuario",
      filter: "filtrar",
      urlPlaceholder: "http://tusitio.com",
      urlTooltip: "Debes ingresar una URL valida con el foramto http://tusitio.com",
      saveSuccess: "Guardado con éxito",
      deletedFromCalendar: "Eliminado por calendario.",
      cantDeleteTreatment: "No se pudo borrar el tratamiento.",
      cashier: "Cajero",
      notEditable: "No editable",
      brands: "marca",
      longDays: ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"],
      shortDays: ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"],
      validUrl: "Este campo debe llevar una URL valida",
      monthly: "Mensual",
      weekly: " Semanal",
      generateDocument: {
        bill: "Generar factura",
        ticket: "Generar boleta",
        serviceTicket: "Generar boleta de servicios",
        billExempt: "Generar factura exenta",
        receiptType: "Tipo de Comprobante",
        paymentNumber: "N de pago",
        detail: "Detalle",
        status: "Estado",
        options: "Opciones"
      },
      multiSelect: {
        selectAll: "Seleccionar todos",
        allSelected: "Seleccionaste todos",
        selectAnOption: "Selecciona una opción",
        quickSearch: "Búsqueda rápida"
      },
      fieldType: {
        integer: "Numérico",
        "float": "Decimal",
        text: "Texto",
        textarea: "Área de texto",
        "boolean": "Binario (Si/no)",
        date: "Fecha",
        datetime: "Fecha y hora",
        categoric: "Categórico",
        file: "Archivo",
        multiple: "Selección Múltiple"
      },
      fullnamePlaceholder: "Juan Perez",
      emailPlaceholder: "micompañía@correo.com",
      phonePlaceholder: "xxx xxx xxx",
      generals: null,
      identificationName: "RUT",
      saveAction: "Guardar",
      cancelAction: "Cancelar",
      deleteAction: " Borrar",
      modalEditFeedTitle: "Editando ",
      modalEditTitle: "Editando ",
      accountNumber: "Número de cuenta",
      accountType: "tipo de cuenta",
      bank: "Institución bancaria",
      editButton: "Editar",
      defEditButton: "Editar por defecto",
      deleteButton: "Eliminar",
      opendayButton: "Abrir día",
      viewButton: "Ver",
      timeMeasure: "minutos",
      close: "Cerrar",
      viewGroup: "Ver grupo",
      personsMeasure: "personas",
      selectPlaceholder: "Selecciona una opción",
      selectdatePlaceholder: "Selecciona una fecha",
      noOptions: "No hay ninguna opción",
      bankName: "Banco",
      bankAccount: "Cuenta corriente",
      duration: "Duración",
      location: "Local",
      capacity: "Capacidad",
      active: "Activo",
      inactive: "Inactivo",
      all: "Todos",
      frecuency: "Frecuencia",
      action: "Acción",
      each: "cada",
      viewAll: "Ver todos",
      noLocals: "No hay locales para selecionar",
      clientId: "RUT",
      headService: "Servicio",
      headPrice: "Precio",
      headAction: "Acción",
      searchBar: {
        active: "Activo",
        inactive: "Inactivo",
        provider: "Ver las comisiones por prestador",
        service: "Ver las comisiones por servicio",
        local: "Local",
        localDefault: "Selecciona un local",
        viewFor: "Ver por",
        all: "Todos",
        viewAll: "Ver todos los resultados",
        noResults: "No hay elementos para seleccionar",
        quickSearch: "Búsqueda rápida",
        categoryDefault: "Selecciona una categoría",
        searchClients: "Buscar clientes"
      },
      sweetAlert: {
        hourMissmatch: "La hora de fin debe ser mayor a la de inicio",
        accept: "Aceptar",
        cancel: "Cancelar",
        error: "Error",
        errorCodeDescription: "Código inválido, verifica que tengas los permisos necesarios o que el código exista",
        codeTitle: "Código de cajero",
        codeDescription: "Debes ingresar un código de cajero válido para realizar esta acción",
        codePlaceholder: "Código",
        deleteTile: "¿Estás seguro de realizar está acción?",
        blockTile: "Bloquear Gift card",
        unblockTile: "Desbloquear Gift card",
        deleteDescription: "Debes escribir la palabra 'ELIMINAR' para continuar",
        blockDescription: "Al bloquear la tarjeta no podrá ser canjeada, si necesitas volver a habilitarla debes hacerlo antes de su vencimiento. El vencimiento no es pausable.",
        unblockDescription: "Al desbloquear la tarjeta podrá ser canjeada o redimida por el tiempo restante antes de su vencimiento.",
        deletePlaceholder: "ELIMINAR",
        blockPlaceholder: "BLOQUEAR",
        unblockPlaceholder: "DESBLOQUEAR",
        acceptPlaceholder: "ACEPTAR",
        economicSector: "Tu empresa debe tener al menos uno o más sectores económicos seleccionados",
        onlinePaymentValidation: "La información de datos bancarios no puede estar vacía"
      },
      emailsAlert: {
        desc1: "al siguiente correo electrónico,",
        desc2: "Puedes editar el correo o agregar otro separados por coma (user@agendapro.com, user2@agendapro.com), en caso de no existir uno por defecto, agréguelo."
      },
      schedulepop: {
        error: "No hay días asignados",
        apperture: "Apertura",
        close: "Cierre"
      },
      valError: {
        nullInput: "Este campo es obligatorio"
      },
      appFeedsComp: {
        title: "App personalizada",
        newAppButton: "+ Nuevo aviso para App"
      },
      modalFeeds: {
        newTitle: "Nuevo aviso para App",
        title: "Editando ",
        subtitle: "Subtítulo",
        messaje: "Mensaje",
        link: "Enlace externo",
        image: "Arrastrar o seleccionar imagen",
        imageError: "Tipo de archivo no soportado",
        tooltipOne: "Aquí va un tip acerca de",
        imgInstructions: "La imagen debe tener un tamaño de 900x800 pixeles y pesar no más de 5 MB"
      },
      locationNotFound: "Local no encontrado",
      locationsComp: {
        title: "Locales",
        titleSoloplan: "Perfil",
        newLocation: "+ Nuevo local"
      },
      modalLocations: {
        "new": "Nuevo Local",
        name: "Nombre del local",
        address: "Dirección",
        additionalAddress: "Dirección adicional",
        administrativeEntityName: "Entidad regulatoria",
        administrativeEntityCode: "Código de entidad regulatoria",
        administrativeEntityNamePlaceholder: "Entidad regulatoria",
        administrativeEntityCodePlaceholder: "Código de entidad regulatoria",
        phone: "Teléfono",
        email: "Email",
        docType: "tipo de documento",
        onlineReserve: " Este local acepta reservas en línea",
        onlineReserveSoloplan: "Acepto reservas en línea",
        socialReason: "Razón social",
        socialReasonPlaceholder: "AgendaPro LLC",
        orderBilling: "Servicios de Tecnología",
        addressBilling: "Avenida Luis Thayer Ojeda 1000, Providencia, Chile",
        locationDescription: "Esta es una descripción para tu local",
        locationDescriptionSoloplan: "Esta es una descripción adicional que puedes entregarle a tus clientes",
        locationDescriptionLabel: "Descripción del local",
        locationDescriptionLabelSoloplan: "Descripción adicional",
        onlineBilling: "Facturación electrónica",
        resolutionNumber: "Número de resolución",
        prefix: "Prefijo",
        initalRange: "Rango inicial",
        currentVoucher: "Comprobante actual",
        rangeTo: "Rango hasta",
        initialDateVigency: "Fecha inicial vigencia",
        endDateVigency: "Fecha final vigencia"
      },
      locationResolutions: {
        email: {
          title: {
            soonToExpire: "Tu resolución № %{resolutionNumber} esta por caducar",
            closeMaxNumber: "Alcanzaste el 90% utilizado de las facturas de la resolución № %{resolutionNumber}"
          }
        },
        message: {
          warning: {
            soonToExpire: "Tienes hasta el %{expireDate} para utilizar tus facturas de la resolución %{resolutionNumber} en tu local.",
            closeMaxNumber: "Alcanzaste el 90% de facturas emitidas de la resolución %{resolutionNumber} en tu local."
          }
        }
      },
      modalServOptions: {
        order: "Giro",
        creatingService: "Nuevo servicio",
        newService: "Nuevo servicio",
        newClass: "Nueva clase",
        newBundle: "Nuevo paquete",
        title: "Opciones avanzadas",
        resourcesHour: "Recursos con horario",
        sessionsTitle: "Servicios con sesiones",
        resourcesTitle: "Recursos",
        specialHoursTitle: "Horario especial",
        categoryTitle: "Categoría de servicio",
        onlinePay: "Pago en línea",
        multiselectTitle: "Prestadores de servicio",
        onlineDiscount: "Descuento para pago en línea",
        minisiteToggle: "Mostrar el precio en tu mini-sitio AgendaPro",
        groupToggle: "Servicio grupal",
        deliveryService: "Servicio a domicilio",
        onlineReserve: "Este servicio puede hacer reservas en línea",
        hourlyResources: "Este servicio usa Recursos con horario",
        taxes: "Precio incluye IVA en el comprobante de caja",
        simulPackages: "Paquete de servicios simúltaneos",
        specialHours: "Horario especial",
        horLocal: "Horario local",
        horLocalSoloplan: "Horario de atención",
        socialReason: "Razón social",
        id: "RUT",
        fullAddress: "Dirección completa",
        aditionalInfo: "Información adicional",
        billing: "Facturación",
        vouchers: "Comprobantes",
        ticket: "Boleta",
        bill: "Factura",
        servicesTicket: "Boleta de servicios",
        billExempt: "Factura exenta",
        others: "Otros",
        rips: "RIPS",
        docTitle: "titulo del documento",
        docType: "Tipo de documento",
        docNumber: "Número de documento",
        provCode: "Código del prestador",
        groupServ: "Servicio grupal",
        error: "No tienes Recursos con horario creados a\xFAn, haz click <a href="
      },
      modalServices: {
        serviceLabel: "Servicios",
        serviceDescription: "Crea un nuevo servicio.",
        bundlesLabel: "Paquetes",
        bundlesDescription: "Crea un nuevo paquete (grupo de servicios). Pueden ser reservados en paralelo o secuencial.",
        classLabel: "Clases",
        classDescription: "Crea una nueva clase, con su horario y profesor específico.",
        sessionLabel: "Sesiones",
        sessionDescription: "Crea servicios con una cantidad de sesiones determinada."
      },
      modalService: {
        "new": "Nuevo servicio",
        descriptionService: "Descripción del servicio",
        nameServiceLabel: "Nombre del servicio*",
        namePlaceholder: "Nombre",
        selectCategory: "Seleccione una categoría",
        commissionLabel: "Comisiones",
        priceService: "Precio*",
        durationService: "Duración*",
        category: "Categoría*",
        multiselectTitle: "Profesionales que prestan el servicio*"
      },
      modalClass: {
        "new": "Nueva clase",
        namePlaceholder: "Nombre",
        selectCategory: "Seleccione una categoría",
        selectLocal: "Seleccione un local"
      },
      modalSession: {
        "new": "Nuevo servicio con sesiones",
        namePlaceholder: "Nombre",
        selectCategory: "Seleccione una categoría"
      },
      modalBundle: {
        "new": "Nuevo paquete de servicios",
        title: "Paquete",
        namePlaceholder: "Nombre",
        selectCategory: "Seleccione una categoría"
      },
      modalCategory: {
        "new": "Nueva categoría"
      },
      modalServTabone: {
        title: "Servicio"
      },
      modalServTabthree: {
        title: "Recursos"
      },
      modalClassone: {
        title: "Servicio",
        multiselectTitle: "Prestadores de servicio"
      },
      modalClasstwo: {
        title: "Opciones avanzadas"
      },
      modalClassthree: {
        title: "Horario especial"
      },
      tabCategories: {
        newCategory: "Nueva categoría de servicios",
        categoryName: "Nombre de la categoría"
      },
      commissionsComp: {
        title: "Comisiones",
        defaultCommission: "Comisión por defecto: "
      },
      tabComOne: {
        title: "Servicios"
      },
      tabComTwo: {
        title: "Planes"
      },
      tabComThree: {
        title: "Productos"
      },
      modalCom: {
        defaultCom: "Comisión por defecto",
        defaultTitle: "Editando comisión por defecto",
        comEditTitle: "Editando comisiones para ",
        defaultComText: "Al guardar se modificarán las comisiones generales o especificas de tus productos, servicios o planes."
      },
      activationError: "Tu plan actual es el %{plan} y permite tener hasta %{quantity} agendas de servicios activos. Para activar más agendas de servicios, es necesario que mejores tu plan.",
      modalOpenday: {
        title: "Abrir el horario en la siguiente fecha y horario:",
        openDayFor: "Abrir día para ",
        tableDate: "Fecha",
        tableOpen: "Apertura",
        tableClose: "Cierre",
        tableOptions: "Opciones",
        openDays: "Días abiertos"
      },
      modalProviders: {
        title: "Creando un nuevo prestador de servicios",
        "new": "+ Nuevo prestador",
        subTitle: "Datos del prestador",
        name: "Nombre público",
        location: "Local",
        itineraryBlock: "Bloque itinerario",
        onlineReserves: "Este prestador acepta reservas en línea",
        assignService: "Asignar un servicio",
        selectOption: "Selecciona una opción",
        providerSchedule: "Horario del prestador",
        tableDay: "Día",
        tableState: "Estado",
        tableOpen: "Apertura",
        tableClose: "Cierre",
        tableOptions: "Opciones",
        errorServices: "Debes seleccionar al menos un servicio"
      },
      modalGroup: {
        title: "Nuevo grupo",
        "new": "+ Nuevo grupo",
        name: "Nombre del grupo",
        location: "Local",
        placeholder: "Nombre del grupo",
        providersTitle: "Prestadores"
      },
      resourcesComp: {
        title: "recursos",
        hourResources: "recursos con horario",
        newResource: "+ nuevo recurso",
        newHourResource: "+ nuevo recurso con horario",
        "new": "Nuevo recurso",
        hourResourceAlertTitle: "¿Estás seguro de realizar está acción?",
        hourResourceAlertText: "Al desactivar este recurso con horario, se desvincularán %{services} servicio(s) y se podrán seguir agendado normalmente. ¿Deseas continuar?"
      },
      modalResources: {
        name: "Nombre",
        category: "Categoría",
        servTitle: "Servicios",
        location: "Local",
        quantity: "Cantidad",
        newCategory: "Nueva categoría",
        aviableIn: "Recurso disponible en: "
      },
      modalTimeResource: {
        "new": "Nuevo recurso con horario",
        aviableIn: "Horario del recurso: ",
        providerData: "Datos del recurso",
        publicName: "Nombre del recurso",
        location: "Local",
        itineraryBlock: "Bloque itinerario",
        assignService: "Asigna un servicio",
        selectPlaceholder: "Selecciona un servicio",
        onlineResource: "Este recurso acepta reservas en línea",
        errorServices: "Debes seleccionar al menos un servicio"
      },
      memberships: {
        duringMembershipDuration: "Durante duración del plan",
        "new": "Nuevo plan",
        isActive: {
          "true": "Activo",
          "false": "Inactivo"
        },
        nonStarted: "No iniciado",
        membershipTypes: {
          fixed: "Fijas",
          mixed: "Mixtas",
          traditional: "Estándar",
          freeChoice: "Libre Elección"
        },
        membershipGroupTypes: {
          unlimitedType: "Ilimitado",
          fixedRecurrence: "Fijas"
        },
        recurrenceWords: {
          day: "Día",
          week: "Semana",
          month: "Mes",
          year: "Año",
          duringMembershipDuration: "Durante la duración del plan"
        },
        title: "Planes",
        types: {
          traditional: "Estándar",
          freeChoice: "Libre Elección"
        },
        undefined: "Indefinido",
        unlimited: "Ilimitado",
        noInfo: "Sin información",
        noApply: "No aplica",
        pdfTemplates: {
          aTotalOf: "Se ha utilizado un total de",
          by: "por",
          condition: "Condición",
          dateOfPurchase: "Fecha de Compra",
          expirationDate: "Caduca el",
          generalSummary: "Resumen General",
          initialDate: "Fecha de inicio",
          lastUsedServiceBy: "El último servicio utilizado por",
          membershipDetail: "Detalle del Plan",
          membershipExpiration: "Vigencia del Plan",
          membershipFeatures: "Características del Plan",
          membershipName: "Nombre del Plan",
          membershipPrice: "Precio del Plan",
          membershipType: "Tipo de Plan",
          noCondition: "Sin condición",
          ofThePlan: "del plan",
          payedAmount: "Monto Pagado",
          planNotUsed: "Este plan aún no ha sido utilizado",
          remaining: {
            one: "1 restante",
            other: "%{count} restantes"
          },
          services: "Servicios",
          servicesCount: {
            one: "1 servicio",
            other: "%{count} servicios"
          },
          specificDetail: "Detalle Específico",
          specificDetailText: "A continuación se presenta el detalle de utilización específico por cada servicio incluído en el plan.",
          state: "Estado",
          totalSessions: {
            one: "1 sesión total",
            other: "%{count} sesiones totales"
          },
          unlimitedSessions: "Sesiones Ilimitadas",
          until: "hasta el",
          used: "Utilizadas",
          was: "fue",
          withDate: "con fecha"
        },
        emailTemplates: {
          infoRequest: "Has recibido este correo porque solicitaste información del plan en",
          infoMultiRequest: "Has recibido este correo porque solicitaste información de los planes en",
          hello: "Hola",
          pdfAttachedText: "dicha información se encuentra adjunto en un archivo .pdf.",
          responsabilityText: "El envío de este mensaje y los datos entregados son de exclusiva responsabilidad de esta."
        },
        excelTemplates: {
          genericGroup: "Grupo genérico",
          particularForEachService: "Particular por cada Servicio",
          headers: {
            client: "cliente",
            clientEmail: "Email cliente",
            clientName: "Nombre cliente",
            clientPhone: "Teléfono cliente",
            endDate: "Fecha de vencimiento",
            group: "Grupo",
            initDate: "Fecha de inicio",
            paymentDate: "Fecha de pago",
            paymentReceipt: "Comprobante de pago",
            paymentReceiptNumber: "Nro comprobante",
            plan: "Plan",
            planId: "ID Plan",
            planType: "Tipo plan",
            recurrence: "Frecuencia",
            sessionsType: "Tipo de sesiones",
            state: "Estado",
            summary: "Resumen",
            totalPlanGroups: "Cantidad Grupos Plan",
            totalSessions: "Total de sesiones",
            totalServices: "Total de servicios",
            used: "Utilizadas",
            userLastModification: "Usuario Última modificación",
            duration: "Duración",
            freeChoice: "Planes libre elección",
            standard: "Planes estandar"
          }
        }
      },
      modalMemberships: {
        newTitle: "Nuevo Plan",
        name: "Nombre",
        namePlaceholder: "Nombre del plan",
        price: "Precio",
        saleCommission: "Comisión de venta",
        tax: "Precio incluye IVA en comprobante de caja",
        tableServ: "Servicio",
        tableCant: "Cantidad",
        tableFrec: "Frecuencia",
        tableAcc: "Acción",
        expService: "Servicio sin vencimiento",
        generalService: "Vencimiento general",
        noExpTime: "Este plan no tiene fecha de expiración",
        recurrency: "Recurrencia",
        currency: "$",
        currencyName: "Pesos",
        taxLabel: "Incluye IVA",
        errorMemmberships: "Debes asignar al menos un servicio"
      },
      newMembership: {
        configuration: "Configuración",
        configurationText: "Selecciona el tipo de Plan que necesitas configurar, ya sea estándar o libre elección, luego se desplegarán el resto de las opciones de configuración.",
        fixedSessionsLabel: "Servicios de sesiones Fijas",
        fixedSessionsText: "Configura aquí grupos de servicios que tienen una cantidad de sesiones fijas durante el vencimiento del plan.",
        unlimitedSessionsLabel: "Servicios de sesiones Ilimitadas",
        unlimitedSessionsText: "Configura aquí un único grupo de servicios que no tiene restricción de sesiones durante el vencimiento del plan.",
        traditionalServicesLabel: "Establecer Servicios",
        serviceName: "Servicios del grupo",
        serviceQuantity: "Cantidad",
        serviceRecurrency: "Frecuencia",
        serviceConditions: "Condiciones",
        maxSessions: "sesiones max. por",
        addService: "Servicio",
        addGroup: "Agregar grupo",
        expirationTitle: "Vencimiento del Plan",
        expirationSubtitle: "Establece la duración general del Plan",
        expirationSelectLimited: "Con Vencimiento",
        expirationSelectUnlimited: "Sin Vencimiento",
        groupQuantityLabel: "Son",
        groupRecurrencyLabel: "Sesiones totales por"
      },
      newMembershipErrors: {
        required: "Campo requerido",
        frecuency: "Verifique la Frecuencia del servicio o la Vigencia del Plan"
      },
      indexMembershipsSessionType: {
        fixed: "Fijas",
        unlimited: "Ilimitadas",
        both: "Mixtas"
      },
      indexMembershipsTable: {
        membership: "Plan",
        type: "Tipo",
        sessions: "Sesiones",
        start: "Fecha Inicio",
        end: "Vencimiento",
        id: "ID",
        receipt: "Nº Doc.",
        price: "Precio del Plan",
        payed: "Monto Pagado",
        client: "Nombre",
        clientId: "ID Cliente",
        options: "Opciones",
        fromDownPayment: "Parte de un abono",
        unlimited: "Sin Vencimiento"
      },
      indexMembershipsView: {
        titleModal: "Detalles del plan",
        sectionClientTitle: "Cliente",
        sectionClientName: "Nombre",
        sectionClientId: "Documento de identidad",
        sectionPropertiesTitle: "Características del plan",
        sectionPropertiesName: "Nombre del plan",
        sectionPropertiesType: "Tipo de plan",
        sectionPropertiesSessions: "Tipo de sesiones",
        sectionPropertiesExpiry: "Vigencia del Plan",
        sectionPropertiesStatus: "Estado",
        sectionPropertiesPaymentDate: "Fecha de compra",
        sectionPropertiesStart: "Fecha de inicio",
        sectionPropertiesEnd: "Caduca el",
        sectionPropertiesPrice: "Precio del plan",
        sectionPropertiesPayed: "Monto pagado",
        sectionPropertiesCommission: "Comisión de venta",
        sectionPropertiesSeller: "Vendido por",
        sectionSummaryTitle: "Resumen General",
        sectionSummary1: "El último Servicio utilizado fue",
        sectionSummary2: "con fecha",
        sectionSummary3: "Cantidad total de sesiones",
        sectionSummary4: "del plan hasta el",
        sectionSummaryBold1: "utilizadas",
        sectionSummaryBold2: "restantes",
        sectionSummaryNotUsed: "El plan no ha sido utilizado.",
        sectionDetailsTitle: "Detalle Específico",
        sectionDetailsSubtitle: "Aquí puedes revisar el detalle de utilización específico por cada servicio del plan.",
        sectionDetailsTraditional: "Estándar",
        sectionDetailsFreechoice: "Elección Libre",
        sectionDetailsTableServices: "Servicios",
        sectionDetailsTableUsed: "Utilizadas",
        sectionDetailsTableCondition: "Condición",
        sectionDetailsUnlimited: "Sesiones Ilimitadas",
        sectionDetailsUndefined: "No definido",
        sectionDetailsDay: "Día",
        sectionDetailsWeek: "Semana",
        sectionDetailsMonth: "Mes",
        sectionDetailsYear: "Año",
        sectionDetailsDays: "Días",
        sectionDetailsWeeks: "Semanas",
        sectionDetailsMonths: "Meses",
        sectionDetailsYears: "Años",
        sectionDetailsMembershipExpiration: "Vigencia del plan",
        sectionDetailsEach: "por",
        sectionDetailsNoConditions: "Sin condición"
      },
      surveys: {
        title: "Encuestas",
        newSurvey: "+ Nueva encuesta",
        answers: {
          newAnswerTitle: "¡Muchas gracias por contestar la encuesta!",
          newAnswerSubtitle: "Puedes seguir reservando con",
          alreadyAnsweredTitle: "¡Esta encuesta ya fue respondida!",
          alreadyAnsweredSubtitle: "Ya recibimos la respuesta a esta encuesta"
        }
      },
      modalSurvey: {
        name: "Nombre de la encuesta",
        "new": "Nueva pregunta",
        edit: "Editando ",
        question: "Pregunta",
        description: "Descripción",
        selectServices: "Seleccione los servicios",
        selectOption: "Selecciona una opción",
        selectQuestions: "Seleccione las preguntas",
        placeholderDescription: "Ej: Te escribimos para que nos ayudes a mejorar nuestra atención. Nos interesa conocer tu opinión y saber cómo estuvo tu visita. Si tienes cualquier duda o comentario, por favor no dudes en contactarnos."
      },
      currencies: ["$", "S/"],
      payments: {
        title: "Ventas Facturadas",
        addPay: "+ Agregar pago",
        billPlaceholder: "N° de comprobante",
        internalSales: "ventas internas",
        dateRange: "Desde / Hasta",
        locals: "Locales",
        payMethods: "Métodos de pago",
        billType: "Tipo de comprobante",
        salesTotal: "Ventas facturadas toales",
        paymentMethod: "Medios de pago",
        type: "Tipo",
        amount: "Monto",
        viewPaysOf: "viendo pagos de",
        downloadSales: "Descargar ventas internas",
        downloadPayments: "Descargar pagos",
        tabTitlePays: "Pagos",
        tabTitleSales: "Ventas internas",
        deleting: "¿Estas seguro de querer eliminar este pago?",
        deletingDesc: "Esta acción es irreversible",
        noInfo: "Sin información",
        status: {
          active: "Activo",
          expired: "Vencido",
          issued: "Emitido",
          inactive: "Inactivo",
          trial: "Trial",
          admin: "Admin",
          subscribed: "Suscrito",
          blocked: "Bloqueado"
        },
        associatedRecordNil: "No existe asociación entre %{modelBase} y %{associatedModel} en %{className}",
        couldNotBeStarted: "No se pudo iniciar el proceso de pago.",
        httpGenericError: "La solicitud al servidor no es correcta. Esto es un problema interno.",
        recordNotFound: "No existe registro en el modelo %{model} en %{className}",
        rejectedBlocked: "Su banco bloqueó la transacción o la tarjeta, comuníquese con su banco.",
        rejectedDefault: "Su banco rechazó la transacción, comuníquese con su banco.",
        rejectedDisabled: "Tarjeta expirada o deshabilitada.",
        rejectedDuplicated: "Su banco rechazó la transacción por cargo duplicado.",
        rejectedExists: "Ya existe un pago previamente aprobado.",
        rejectedGeneric: "Error, por favor reintente en unos minutos.",
        rejectedInsufficientBalance: "Saldo insuficiente en su tarjeta.",
        rejectedInvalid: "Número de tarjeta o código de seguridad inválido.",
        rejectedMax: "Máximo de intentos superado.",
        rejectedRequestingThreeDs: "Error, por favor reintente en unos minutos.",
        undefinedEnvironmentVariable: "La variable de entorno %{env} aún no ha sido definida.",
        withoutReferenceRecords: "No existen registros asociados a la referencia en el modelo %{model} en %{className}"
      },
      methodTableRows: {
        services: "Servicios",
        memberships: "Planes",
        products: "Productos",
        giftcards: "Giftcards"
      },
      modalViewPayment: {
        title: "Comprobante de pago ID: ",
        sumaryTitle: "Resumen de pago",
        date: "Fecha",
        casheer: "Cajero",
        clientName: "Nombre del cliente",
        totalAmount: "Monto total",
        payedAmount: "Monto cancelado",
        turned: "Vuelto",
        payMethodTitle: "Medio de pago",
        method: "Medio",
        amount: "Monto",
        clientNumber: "Nº Comprobante",
        billTitle: "Boleta Nº ",
        comments: "Comentarios: ",
        products: "Productos",
        reserves: "Reservas",
        reserveDate: "Fecha de reserva",
        service: "Servicio",
        brand: "Marca",
        product: "Producto",
        quantity: "Cantidad/Unidad",
        price: "Precio",
        salesman: "Vendedor",
        reservesTitle: "Reservas",
        provider: "Prestador",
        sendPayment: "Enviar pago",
        printPayment: "Imprimir pago",
        bookings: "Reservas",
        memberships: "Planes",
        services: "Servicios",
        mockBookings: "Reservas",
        payResume: "Resumen de pago",
        pendingAmount: "Monto pendiente",
        paymethodTitle: "Métodos de pago"
      },
      modalInternalSales: {
        title: "Venta interna",
        name: "Mombre",
        location: "Locales",
        date: "Fecha",
        authCode: "Código de autorización",
        buyer: "Comprador",
        category: "Categoría",
        brand: "Marca",
        product: "Producto",
        quantity: "Cantidad",
        unitPrice: "Precio unitario",
        discount: "Descuento",
        total: "Total",
        comments: "Comentarios",
        currency: "$",
        comisionType: "%",
        authCodeTxt: "Es necesario el código para poder guardar los cambios"
      },
      modalNewPay: {
        add: "Agregar",
        title: "Ingresar venta",
        date: "Fecha y hora",
        local: "Local",
        client: "Cliente",
        addUser: "Agregar usuario",
        name: "Nombre",
        lastname: "Apellido",
        forgein: "Extranjero",
        ci: "C.I.",
        email: "Email",
        phone: "Teléfono",
        amount: "Monto",
        paymentMethod: "Método de pago",
        cash: "Efectivo",
        addPay: "Agregar pago",
        billNumber: "Número de comprobante",
        type: "Tipo",
        billId: "Id",
        dues: "Cuotas",
        viewDetail: "Ver detalles",
        newServiceTab: "Servicio",
        newProductTab: "Producto",
        newMembershipTab: "Plan",
        newGiftcardTab: "Gift card",
        validServiceTab: "Servicios vigentes",
        saveDownPayment: "Guardar abono",
        saveFinalPayment: "Guardar pago",
        payments: "Abonos",
        noClientError: "Por favor ingresa un cliente valido",
        dpaymentGiftcardError: "Una gift card no puede ser parte de un abono",
        noEnoughtStock: "No hay stock suficiente del producto para continuar con la venta",
        dtemiteTaxLevelTitle: "Obligación",
        dtemiteTaxResponsible: "No responsable de IVA",
        dtemiteTaxNotResponsible: "Responsable de IVA",
        category: "Categoría",
        brand: "Marca",
        service: "Servicio",
        product: "Producto",
        quantity: "Cantidad",
        listPrice: "Precio unitario",
        price: "Precio",
        discount: "Descuento",
        salesman: "Vendedor",
        membership: "Plan",
        total: "Total",
        id: "Documento Identidad",
        savePayment: "Guardar como abono",
        generateBill: "Generar comprobante de pago",
        saveBill: "Generar boleta",
        back: "< atr\xE1s",
        detail: "Detalles",
        payVoucher: "Comprobante de pago",
        billDate: "Fecha de comprobante",
        comments: "Comentario",
        toPay: "Por pagar",
        "return": "Vuelto",
        noAddons: "sin adicionales",
        validQuantity: "Agrega una cantidad válida",
        noSales: "No hay ventas agregadas",
        nnoDownpayments: "No hay pagos por completar",
        noBills: "No hay boletas generadas",
        noServices: "No hay servicios vigentes",
        noItems: "No hay items para procesar",
        noCp: "Agrega un comprobante para contiuar",
        errorAddBill: "Agrega un recibo para continuar",
        noDownpayments: "No hay abonos pendientes",
        selectAnService: "Por favor selecciona un servicio",
        selectAnSalesman: "Por favor selecciona un vendedor",
        selectAnBuyer: "Por favor selecciona un comprador",
        selectAnProduct: "Por favor selecciona un producto",
        selectAnMembership: "Por favor selecciona un plan",
        selectAnPaymethod: "Por favor selecciona un medio de pago",
        selectAnId: "Por favor ingresa un número de RUT",
        selectAnAmount: "Por favor ingresa un monto a pagar",
        selectAnExpiry: "Por favor ingresa un tipo de vencimiento",
        selectAnExpiryMeasurement: "Por favor selecciona un periodo de vencimiento",
        validPrice: "Por favor debes ingresar un precio mayor a $1",
        validPosAmount: "La cantidad a pagar con Pos no debe superar el monto total",
        payAndRegister: "Pagar y registrar",
        pay: "Pagar"
      },
      tablebillPayment: {
        download: "Descargar reporte",
        name: "Nombre",
        type: "Tipo",
        listprice: "Precio Lista",
        price: "Precio",
        discount: "Descuento",
        total: "Total",
        date: "Fecha",
        sesions: "Sesiones"
      },
      quotations: {
        title: "Presupuestos",
        emailTitle: "Enviar presupuesto",
        emailDesc: "Se enviará el presupuesto #",
        tabActive: "Vigentes",
        tabExpired: "Vencidos",
        tabSold: "Vendidos",
        notFoundActive: "presupuestos vigentes",
        notFoundExpired: "presupuestos vencidos",
        notFoundSold: "presupuestos vendidos",
        cantUpdateSoldQuotations: "No puedes editar un presupuesto vendido."
      },
      downpayIndex: {
        downpayments: "Abonos",
        unfinishedPayments: "Pagos Pendientes",
        downloadIncPays: "Descargar",
        client: "Cliente",
        downpayNumber: "Número de abono",
        addDownPayment: "Agregar abono",
        locations: "Locales",
        payMethods: "Métodos de pago",
        recepitTypes: "Tipo de recibo",
        totalPending: "Total pendiente",
        totalPayed: "Total abonado",
        dateRange: "Desde / Hasta",
        incomplete: "Abonos incompletos",
        pendings: "Reservas sin pago"
      },
      modalNewDownpayment: {
        billId: "Id",
        local: "Local",
        services: "servicios",
        client: "Cliente",
        detail: "Detalle",
        amount: "Monto",
        percentage: "% Abonado",
        debt: "Deuda",
        billNumber: "Boleta N°"
      },
      productsTable: {
        sku: "Sku",
        category: "Categoría",
        brand: "Marca",
        name: "Nombre",
        unity: "Unidad",
        price: "Precio",
        quantity: "Cantidad",
        seller: "Vendedor"
      },
      bookingsTable: {
        date: "Fecha",
        service: "Servicio",
        provider: "Prestador",
        price: "Precio"
      },
      salesReport: {
        title: "Reporte de comisiones",
        range: "Desde / Hasta",
        providers: "Prestadores",
        client: "Clientes",
        collectionTotal: "Recaudación total",
        collectionServices: "Recaudación por servicios",
        collectionProducts: "Recaudación por productos",
        commissions: "Comisiones",
        intSalesPayment: "Cobros por ventas internas"
      },
      salesRepTableheads: {
        provider: "Prestador",
        recaudation: "Recaudaciones",
        commissions: "Comisiones",
        intSales: "Ventas internas"
      },
      followingCollection: "Seguimiento por recaudación",
      recCommissions: "Recaudaciones por comisiones",
      commissionsRainking: "Ranking de comisiones",
      collectionRainking: "Ranking de recaudaciones",
      "memberships-reports": {
        title: "Planes",
        searchbyType: "Tipo",
        searchbyUser: "Buscar por usuario",
        active: "Activas",
        inactive: "Inactivas",
        toExpire: "Por vencer",
        activationDate: "Fecha de activación",
        dueDate: "Fecha de vencimiento",
        all: "Todas",
        id: "Id",
        name: "Plan",
        clientName: "Cliente",
        rut: "RUT",
        startDate: "Fecha de inicio",
        endDate: "Fecha de vencimiento",
        recepitNumber: "Número de comprobante",
        payedAmount: "Monto cancelado",
        amount: "Monto",
        provider: "Prestador"
      },
      ripsSection: {
        title: "RIPS",
        generated: "RIPS generados",
        generateReport: "Generar reporte",
        generatePeriodReport: "Generar reporte del periodo"
      },
      salesCash: {
        newPay: "+ Nuevo pago",
        billedSales: "Flujo de ventas facturadas",
        title: "Caja de ventas",
        actualCash: "Efectivo en caja",
        descSalesRec: "Al rectificar el efectivo que hay en caja, no se registra como un ingreso o un egreso, si no como el monto correcto de efectivo en la caja. Esta rectificación sobreescribe cualquier monto que había registrado en caja y todos los movimientos anteriores sólo quedan como historia.",
        descTransfers: "Hacer un traspaso representa la transformación de efectivo en caja a la caja de ventas (por ejemplo, un depósito en efectivo a una cuenta de banco) o, vice versa, agregar al efectivo en caja desde la caja de ventas (por ejemplo, un giro en efectivo que se agrega a la caja en efectivo).",
        internalSales: "Ventas internas",
        otherIncomes: "Otros ingresos",
        incomes: "Ingresos",
        outcomes: "Egresos",
        transfers: "Traspasos",
        results: "Resultado de Flujos del Periodo",
        recCash: "Rectificar Efectivo",
        addMethod: "agregar método"
      },
      paymentGiftcards: {
        title: "Gift Cards",
        statsTotalSold: "MONTO TOTAL GIFT CARD VENDIDAS",
        statsTotalRedeemed: "MONTO TOTAL CANJEADO",
        statsTotalNotRedeemed: "SALDO TOTAL SIN CANJEAR",
        statsActive: "GIFTCARD ACTIVAS",
        statsInactive: "GIFTCARD VENCIDAS"
      },
      configuration: {
        companyPolicyTitle: "Políticas de Reserva y Privacidad",
        companyPolicyDescription: "Ingresa la dirección web de las políticas de tu empresa, las cuales el cliente deberá aceptarlas para finalizar la reserva del servicio.",
        companyPolicyDescriptionSoloplan: "Ingresa la dirección web de las políticas de tu negocio, las cuales el cliente deberá aceptarlas para finalizar la reserva del servicio.",
        companyPolicyPlaceholder: "Escribe una URL para tus políticas de privacidad.",
        companyHead: "Configuraciones de empresa",
        companyTitle: "Empresa",
        companyTitleSoloplan: "Mi Negocio",
        companyDefaultTitle: "Negocio",
        companyDesc: "Configura el nombre de tu empresa, descripción, url de tu mini-sitio logo y política de cancelación.",
        companyDescSoloplan: "Configura el nombre de tu negocio, descripción, url de tu mini-sitio logo y política de cancelación.",
        economicSector: "Sector económico",
        companyDescPlaceholder: "Descripcion de la empresa",
        companyDescPlaceholderSoloplan: "Descripcion del negocio",
        economicSectorDesc: "Selecciona el sector económico al que pertenece tu empresa",
        economicSectorDescSoloplan: "Selecciona el sector económico al que pertenece tu negocio",
        companyName: "Nombre de la empresa",
        companyNameSoloplan: "Nombre del negocio",
        webAddress: "Dirección sitio AgendaPro",
        bookingHead: "Configuraciones de reservas",
        booking: "reservas",
        onlineBooking: "Reservas en línea",
        onlineBookingDesc: "Habilita esta opción para que tus clientes puedan reservar por internet en tu Mini-Sitio.",
        onlineSearch: "Aparecer en buscador",
        onlineSearchDesc: "Habilita esta opción para que tus clientes encuentren tu negocio en el buscador de AgendaPro",
        hourSearch: "Búsqueda por horas",
        hourSearchDesc: "Con esta configuración se determina cada cuanto se ofrecen las horas en tu mini-sitio.",
        hoursBlock: "Ofrecer horas cada",
        hoursBlockDesc: "Esta opción determina cada cuánto hay una hora disponible para reservar si es que no se permite optimización.",
        takeHours: "Ofrecer horas cada",
        takeHoursDesc: "Esta opción determina cada cuánto hay una hora disponible para reservar si es que no se permite optimización.",
        useId: "Usar documento de identidad en reserva",
        useIdDesc: "Al activar esta opción, se exigirá el documento de identidad a los clientes que reserven en línea.",
        onlyClients: "Exclusivo para clientes",
        onlyClientsDesc: "Habilita esta opción para que sólo puedan reservar clientes ingresados en la sección Clientes, se solicitará su documento de identidad.",
        allowClientnotes: "Permitir notas del cliente",
        allowClientnotesDesc: "Habilita esta opción para que tus clientes puedan incluir un comentario de texto libre al reservar a través de la página.",
        defaultNotes: "Notas predefinidas",
        defaultNotesDesc: "Aquí puedes configurar la nota predefinida que se enviará por email al cliente al momento de generar una nueva reserva. (max. 1000 caracteres)",
        defaultNotesError: "El texto sobrepasa el largo máximo, al guardar solo tomaremos los primeros 1000 caracteres.",
        clientExclusive: "Reservas exclusivas para clientes ingresados en AgendaPro",
        clientExclusiveDesc: "Habilita esta opción para que sólo puedan reservar clientes ingresados en la sección Clientes",
        providerPrefenrence: "Preferencia prestador",
        providerPreferenceDesc: "Al activar esta opción, se exigirá que el cliente o paciente esté previamente creado en la base de Clientes de AgendaPro para que puedan reservar. Si lo activas, no se podrán crear nuevos clientes desde las reservas y siempre deberás crearlos desde la sección Clientes / Nuevo cliente.",
        reminders: "Recordatorio",
        remindersDesc: "En esta opción defines cuántos días antes de la reserva se envía el recordatorio al cliente.",
        minBooking: "Tiempo minimo de reserva",
        minBookingDesc: "Horas mínimas requeridas para que un cliente reserve. No se podrá reservar con menos anticipación.",
        maxFutureTime: "Tiempo máximo futuro",
        maxFutureTimeDesc: "Tiempo máximo que una persona puede reservar a futuro. No se permiten reservas para más de 13 meses a futuro.",
        editableBooking: "Reservas editables",
        editableBookingDesc: "Habilita esta opción para que tu cliente pueda modificar las reservas que realiza.",
        cancelBookings: "Reservas cancelables",
        cancelBookingsDesc: "Habilita esta opción para que tu cliente pueda cancelar las reservas que realiza.",
        bookingPolicy: "Política de edición de reservas",
        bookingPolicyDesc: "Horas mínimas requeridas para que un cliente edite o cancele su reserva. No se podrá editar o cancelar reservas con menos anticipación.",
        editMax: "Ediciones máximas",
        editMaxDesc: "Cantidad de veces que un cliente puede editar su reserva.",
        providerPreferences: "Preferencias de prestadores",
        providerPreferencesDesc: "Aquí configuras si el cliente puede o debe elegir el prestador con el que se atenderá. Si no se elige, se seleccionará automáticamente al prestador con menos ocupación ese día.",
        editableBookings: "Reservas editables",
        editableBookingsDesc: "Habilita esta opción para que tu cliente pueda modificar las reservas que realiza.",
        cancelableBookings: "Reservas cancelables",
        cancelableBookingsDesc: "Habilita esta opción para que tu cliente pueda cancelar las reservas que realiza.",
        accordingServiceDuration: "Según duración del servicio",
        accordingServiceBlocks: "Según bloques predefinidos",
        canChooseProvider: "Cliente puede elegir prestador",
        mustChooseProvider: "Cliente debe elegir prestador",
        cantChooseProvider: "Cliente no puede elegir prestador",
        sameDay: "El mismo día",
        oneEarlier: "1 día antes",
        twoEarlier: "2 días antes",
        threeEarlier: "3 días antes",
        byServices: "Servicios",
        byProvider: "Prestadores",
        searchPreferencesMessage: "Con esta configuración se determina cual es la opción “Buscar por” que visualizarán primero tus clientes en el mini-sitio.",
        searchPreferencesTitle: "Desplegar servicios por",
        calendarHead: "Configuraciones de calendario",
        calendarTitle: "Calendario",
        calendarBlock: "Bloque Calendario",
        calendarBlockDesc: "Esta opción determina el largo de cada bloque en la sección Calendario.",
        calendarAnothersTitle: "Comportamiento de Reservas",
        calendarAnothersDesc: "Aquí puedes configurar el comportamiento de las Reservas en Calendario",
        allowBookingsSuperinposed: "Reservas sobrepuestas",
        allowBookingsSuperinposedDesc: "Si habilitas esta opción, los prestadores pueden tener dos reservas en un mismo horario. Esto es sólo válido para reservas ingresadas internamente, tus clientes que reservan desde el buscador y Mini-Sitio no podrán reservar ellos mismos donde ya haya una reserva.",
        allowResourcesOverload: "Sobrecarga de recursos",
        allowResourcesOverloadDesc: "Al habilitar esta opción, podrás hacer reservas incluso cuando los recursos estén siendo utilizados o no disponibles. Esto es sólo válido para reservas ingresadas internamente, tus clientes que reservan desde el buscador y Mini-Sitio no podrán reservar ellos mismos donde los recursos no estén disponibles.",
        allowOutscheduleBookings: "Reservas fuera de horario",
        allowOutscheduleBookingsDesc: "Esta opción te permite poder tomar reservas fuera del horario del prestador o del recurso con horario, para reservas ingresadas internamente. Si habilitas esta opción podrás hacer reservas en todo el horario visible en la sección Calendario, puedes extender este habilitando la próxima opción.",
        allowBlockedHoursBookings: "Reservas en bloqueo de horario",
        allowBlockedHoursBookingsDesc: "Esta opción te permite poder tomar reservas en bloqueos de horario en el calendario, para reservas ingresadas internamente. Si habilitas esta opción podrás hacer reservas en todo el horario visible en la sección Calendario",
        requireClientData: "Requerir datos de contacto",
        requireClientDataDesc: "Si habilitas esta opción al generar una nueva reserva, desde el calendario, el cliente debe tener asociado, como mínimo, email o teléfono.",
        modificationHistorial: "Historial de modificaciones de reservas",
        modificationHistorialDesc: "Si activas esta opción, se guardará un historial de modificaciones para cada reserva. Este historial es exclusivamente visible por el Administrador General y el Administrador de Local, para las reservas de el(los) local(es) al que este asociado.",
        extendCalendar: "Extender calendario",
        extendCalendarDesc: "Habilita esta opción para extender el horario en la sección Calendario, y así poder generar reservas internas fuera del horario de apertura de tus locales.",
        scheduleExtendedCalendar: "Horario de calendario extendido",
        requireAuthCode: "Requerir código de autorización",
        requireAuthCodeDesc: "Si activas esta opción, se guardará un historial de modificaciones para cada reserva. Este historial es exclusivamente visible por el Administrador General y el Administrador de Local, para las reservas de el(los) local(es) al que este asociado.",
        requiredSheet: "Ficha requerida",
        requiredSheetDesc: "Habilita esta opción solo si es necesario completar al menos una ficha de cliente para la reserva desde el calendario cuando esta se marca como Asiste.",
        calendarTableTitle: "Configuración de campos adicionales",
        calendarTableDesc: "Aquí puedes habilitar o deshabilitar los campos que se solicitarán al crear una reserva en Calendario.",
        clientData: "datos del cliente",
        useInCalendar: "usar en calendario",
        requiredInCalendar: "Obligatorio en calendario",
        integrations: {
          webIntDescription: "para integrar tu Mini-Sitio de reservas AgendaPro en tu sitio web, debes editar tu página y pegar el siguiente código(iframo)"
        },
        newUrl: "nueva url",
        editUrl: "editar url",
        emailsConfigHead: "Configuraciones de e-mails",
        emailsConfig: "Configuraciones de emails",
        "emailConfig-desc": "Configura la dirección desde donde se envian los correos masivos (remitentes)",
        "emailModal-config-desc": "Ingresa el email",
        addEmail: "Agregar correo",
        emailsSignature: "Firma emails",
        signatureEmailsDesc: "Configura aquí la firma que se enviará en los emails a todos tus clientes.",
        birthdayEmails: "Email de cumpleaños",
        birthdayEmailDesc: "Este email se enviará a todos los clientes cuando sea su fecha de cumpleaños.",
        activateBithdays: "Activar cumpleaños",
        emailContactLink: "Enlace web del botón 'ir a ...' ",
        emailContactLinkDesc: "Si dejas este campo vacio, el botón 'ir a ...' no se mostrará.",
        emailConfirmed: "El email fue confirmado exitosamente. Ahora puedes mandar campañas de email marketing desde tu cuenta.",
        cashSystemHead: "Configuraciones de sistemas de caja",
        cashSystem: "Sistema de Caja",
        "cashSystem-desc": "Configura el sistema de caja y medios de pagos que acepta tu empresa.",
        "cashSystem-intro": "Aquí puedes configurar los medios de pago que aceptas y qué campos son obligatorios al registrar el pago de una o varias reservas. El código se refiere a algún registro del medio de pago como código de autorización de tarjetas o número de cheque. Puedes ingresar otro medios de pago, y se podrán elegir siempre y cuando la opción 'Otro' esté activa.",
        useLocalInfo: "Usar información de facturación distinta por sucursal",
        "useLocalInfo-desc": "Con esta opci\xF3n se deber\xE1 definir la informaci\xF3n de facturaci\xF3n para cada sucursal en Administraci\xF3n -> Locales -> Editar.",
        configPayNumber: "Configurar número de comprobantes de pago por sucursal",
        "configPayNumber-desc": "Con esta opci\xF3n se deber\xE1 definir el correlativo de comprobante de pago para cada sucursal en Administraci\xF3n -> Locales -> Editar.",
        enableCash: "Habilitar caja de ventas",
        "enableCash-desc": "Habilita esta opción para que puedas llevar un balance completo de tus flujos, incluyendo ingresos y egresos por pagos de servicios y productos, y movimientos varios.",
        cashFollowing: "Hacer seguimiento del efectivo en caja",
        "cashFollowing-desc": "Esta opción sólo es válida cuando la caja de ventas está activa. Con esta opción se lleva un recuento de los flujos en efectivo, y se pueden registrar traspasos entre la caja general y el efectivo en caja, además de rectificar cuánto efectivo hay dejando un registro de esto. Es importante notar que al activar esta opción, aunque haya estado activa alguna vez antes, el efectivo en caja iniciará en $0, y es recomendable rectificar esto en Caja de Ventas",
        requireClientInPay: "Requerir cliente en pago",
        "requireClientInPay-desc": "Habilita esta opción para que al registrar un pago sea obligatorio ingresar un cliente existente o nuevo.",
        requireBillNumber: "Requerir número de comprobante de pago",
        "requireBillNumber-desc": "Habilita esta opción para que al registrar un pago sea obligatorio ingresar el número de comprobante de pago (número de boleta, factura, etc.).",
        allowPriceEdit: "Permitir edición de precios en pago y reservas",
        "allowPriceEdit-desc": "Habilita esta opción para que al registrar una reserva o un pago los precios de los productos y servicios sean editables, excepto para los perfiles de Administrador General y Administrador de Local, que siempre podrán editar precios de reservas y pagos.",
        diferenceIvaCash: "Diferenciar IVA de productos en comprobante de caja",
        "diferenceIvaCash-desc": "Habilita esta opción para que al ver o imprimir un comprobante de caja, el total del precio de cada producto se separa en IVA y neto sin impuestos.",
        requireInfoPay: "Requerir información de servicios en pagos",
        "requireInfoPay-desc": "Habilita esta opción para que al pagar un servicio sin reserva, sea obligatorio seleccionar el Prestador de servicios.",
        requireCashCode: "Requerir código de cajero para acciones de cajas",
        "requireCashCode-desc": "Habilita esta opción para que al ingresar un pago o venta interna, o manipular las cajas, se exija un código de cajero válido.",
        billSize: "Tamaño de boleta",
        selectDefaultReceipt: "Selecciona un comprobante por defecto",
        "billSize-desc": "Configura esta opción con el tamaño de hoja correcto para tu impresora fiscal.",
        payMethod: "Métodos de pago",
        "payMethod-desc": "Crea, selecciona y habilita métodos de pago",
        invoiceConfig: "Configuración de comprobante de pago",
        "invoiceConfig-desc": "Aquí podras configurar los campos que se muestran en el comprobante de pago",
        commissionsConfig: "Configuración de comisiones",
        commissionsBookingsTooltip: "Para Comisiones se consideran reservas en estado Asiste, que adicionalmente cuenten con pago. Reservas asistidas sin pago no son consideradas.",
        "commissionsConfig-desc": "Aquí podras configurar como se pagan las comisiones",
        otherPaymethods: "Listado de medios de pago (otros)",
        healthReport: "RIPS",
        "healthReport-activate": "Habilitar el registro individual de prestaciones de salud.",
        activatePaymethod: "Activar medio de pago",
        requireUniqueNumber: "Exigir número único al agregar pago",
        confirmDelete: "¿Esta seguro de querer eliminar este método de pago?",
        dtemiteTitleCheck: "Utilizar DTEmite como medio de facturacion",
        dtemiteDescCheck: "Habilita esta opción para que al realizar un pago se genere una factura de forma automaticamente en DTEmite, esta opción puede ser modificada al momento de pagar.",
        alegraTitleCheck: "Utilizar Alegra como medio de facturacion",
        alegraDescCheck: "Habilita esta opción para que al realizar un pago se genere una factura de forma automaticamente en Alegra, esta opción puede ser modificada al momento de pagar.",
        dataicoTitleCheck: "Utilizar Dataico como medio de facturacion",
        dataicoDescCheck: "Habilita esta opción para que al realizar un pago se genere una factura de forma automaticamente en Dataico, esta opción puede ser modificada al momento de pagar",
        dtemiteInvoiceCredentials: "Credenciales de dtemite",
        dtemiteInvoiceName: "Nombre sistema DTEmite",
        dtemiteInvoiceRut: "Rut de la cuenta DTEmite",
        dtemiteInvoiceEmail: "Usuario cuenta DTEmite",
        dtemiteInvoiceToken: "Clave cuenta DTEmite",
        alegraInvoiceCredentials: "Credenciales de alegra",
        alegraInvoiceEmail: "Email cuenta Alegra",
        alegraInvoiceToken: "Token cuenta Alegra",
        dataicoInvoiceCredentials: "Credenciales de dataico",
        dataicoInvoiceEmail: "AccountId cuenta Dataico",
        dataicoInvoiceToken: "Token cuenta Dataico",
        enableVideocalls: "Se activará la opción de videoconferencias. Recuerda que ",
        enableVideocallsBold: "deberás activar en cada Servicio, en la pestaña Opciones Avanzadas, que el servicio se realiza por videoconferencia.",
        disableVideocalls: "Al desactivar esta opción, todos los servicios que tengan activado videoconferencia serán desactivados. Si necesitas reactivarlos después, deberás seleccionar cada servicio en particular. Recuerda que ",
        disableVideocallsBold: "todas las citas previamente agendadas con videoconferencia mantendrán esta opción.",
        dataicoTaxLevelTitle: "Obligación",
        dataicoTaxLevelSubtitle: "Elige la opción por defecto con la que facturas a tus clientes",
        dataicoTaxResponsible: "Responsable de IVA",
        dataicoTaxNotResponsible: "No responsable de IVA",
        hasDecimals: "Visualizar montos totales con decimales",
        "hasDecimals-desc": "Habilita esta opción para visualizar los precios totales en comprobantes, pdf y mini-sitio, con 2 decimales."
      },
      notificationsSettings: {
        head: "Configuraciones de notificaciones",
        title: "Notificaciones",
        titleDesc: "Selecciona los eventos a notificar en tu email",
        summary: "Resumen diario",
        "new": "Nueva reserva manual",
        modified: "Reserva manual modificada",
        confirmed: "Reserva manual confirmada",
        canceled: "Reserva manual cancelada",
        newWeb: "Nueva reserva online",
        createNotification: "Crear notificación",
        editNotification: "Editar notificación",
        typeNotification: "Tipo de notificación",
        whenNotifications: "Cuando recibir notificaciones",
        modifiedWeb: "Reserva online modificada",
        confirmedWeb: "Reserva online confirmada",
        canceledWeb: "Reserva online cancelada",
        deleteConfig: "¿Esta seguro de querer eliminar el usuario de las configuraciones?",
        company: "Compañía",
        local: "Local",
        serviceProvider: "Prestador de servicios",
        notificationEmail: "E-mail de notificación",
        notificationAddress: "¿En que dirección deseea recibir la notificación?"
      },
      surveysConfig: {
        head: "Configuraciones de encuestas",
        title: "Encuestas",
        desc: "Configuración básica para tus encuestas",
        activateSurveys: "Activar encuestas",
        activateDesc: "Habilita esta opción para que tus clientes reciban encuestas de tu negocio.",
        surveyTime: "Tiempo para envio de Encuesta",
        survtimeDesc: "Indique cuantas horas después de terminar un servicio se debe enviar la encuesta al cliente.",
        instructionsL1: "Para configurar cuánto tiempo después de finalizado el servicio deseas enviar la encuesta, selecciona una opción en el campo Tiempo para envío de Encuesta",
        instructionsL2: "Para que la encuesta sea enviada:",
        instructionsL3: "Se deben marcar como Asiste todas las reservas del cliente de un mismo día y sucursal.",
        instructionsL4: "El plazo máximo para marcar la asistencia de cada reserva es de 72 horas posterior al término de cada servicio.",
        instructionsL5: "De no marcar todas las reservas de un determinado cliente como 'Asiste', pasadas las 72 horas, se enviará la encuesta correspondiente, ignorando las que posean otro estatus."
      },
      authcodesSettings: {
        title: "Códigos de autorización",
        head: "Configuraciones de códigos de autorización",
        desc: "Configura códigos y permisos para tu equipo.",
        descTxt: "Aquí puedes configurar los códigos para tu equipo, definiendo permisos para ingresar y modificar reservas, y para hacer uso del sistema de caja e ingresar y modificar sus componentes.",
        requireCodeBookings: "Requerir código de cajero para acciones de reservas",
        requireCodeCash: "Requerir código de cajero para acciones de caja",
        requireCodeDownloads: "Requerir código de cajero para descargar archivos y reportes",
        codeList: "Listado de códigos",
        codeListDesc: "Descripcion pendiente",
        newCode: "Nuevo código",
        addCode: "Agregar código",
        editCode: "Editando: ",
        activateCode: "Activar código",
        giveBookingsPermissions: "Dar permisos de reservas",
        giveCashPermissions: "Dar permisos de caja",
        giveDownloadPermissions: "Dar permisos de descarga de archivos"
      },
      companySetting: {
        billing: "Información de la empresa",
        receiptClientName: "Nombre cliente",
        receiptClientPhone: "Teléfono cliente",
        receiptClientEmail: "Email cliente",
        receiptIdentificationNumberClient: "Rut cliente",
        receiptCashier: "Cajero",
        receiptActivity: "Giro",
        assistForCommission: "Reservas asistidas",
        mockbookingCommission: "Servicios sin reserva",
        payedForCommission: "Pagos completos"
      },
      clientsSettings: {
        head: "Configuraciones de clientes",
        title: "Clientes",
        autoClientsTitle: "Número de Cliente Automático",
        autoClientsDesc: "Habilita esta opción para que AgendaPro maneje un número de cliente automático.",
        titleDesc: "Aquí puedes configurar campos y filtros personalizados para tu base de clientes.",
        addCat: "Agregar categoría",
        addField: "Agregar campo",
        filterList: "Listado de filtros",
        catName: "Nombre de la categoría",
        addFilter: "Agregar filtro",
        clientObligatory: "Obligatorio al ingresar/editar cliente",
        showOnCalendar: "Pedir en reserva por calendario",
        mandatoryOnCalendar: "Obligatorio en reserva por calendario",
        showOnWorkflow: "Pedir en reserva en línea",
        mandatoryOnWorkflow: "Obligatorio en reserva en línea",
        creatingCat: "Agregar categoría",
        creatingFilter: "Agregar filtro",
        creatingField: "Agregar campo",
        editingCat: "Edición de categoría",
        editingFilter: "Edición de filtro",
        editingField: "Edición de campo",
        editingCategoric: "Edición de campo categórico",
        configDeleteMsg: "¿Estás seguro de eliminar el campo seleccionado?"
      },
      chartsConfig: {
        head: "Configuraciones de fichas",
        title: "Formato de la ficha",
        descTitle: "Aquí puedes configurar la hoja que contiene la Ficha a exportar/imprimir.",
        selectChart: "Selecciona una ficha",
        pageSize: "Tamaño de la página",
        pageSizeDesc: "Selecciona el tamaño de la hoja que utilizas.",
        chartFormat: "Formato de la ficha",
        chartFormatDesc: "Elige el formato de información que será presentada en la hoja.",
        chartConfig: "Configuración de la ficha",
        chartConfigDesc: "crea fichas historicas para llevar un seguimiento de tus pacientes.",
        addChart: "agregar ficha",
        addCat: "agregar categoría",
        requiredCreateField: "Obligatorio al ingresar/editar ficha",
        addField: "Agregar campo",
        chartAddName: "Nombre de la ficha",
        noCats: "No hay campos agregados",
        creatingCat: "Agregar categoría",
        creatingChart: "Agregar ficha",
        creatingField: "Agregar campo",
        editingCat: "Edición de categoría",
        editingChart: "Edición de ficha",
        editingField: "Edición de campo",
        confirmDelete: "¿Estás seguro de eliminar el campo seleccionado?",
        currentFields: "Campos actuales",
        currentCharts: "Categorías actuales",
        allowSignature: "Requerir firma"
      },
      integrations: {
        head: "Configuraciones de integraciones",
        webIntDescription: "Para integrar tu Mini-Sitio de reservas AgendaPro en tu sitio web, debes editar tu página y pegar el siguiente código (iframe)",
        fbDesc: "Añade un botón de reservas en tu página de facebook.",
        igDesc: "Añade tu enlace de agendamiento en instagram.",
        fbImgDesc: "Pasos a seguir en facebook",
        igImgDesc: "Pasos a seguir en instagram",
        website: "Sitio web",
        webDesc: "Integración de agenda pro en tu página web",
        newUrl: "Nueva url",
        editUrl: "Editar url",
        webhookCreate: "Crear webhook",
        apiDesc: "Credenciales para api pública, usados tanto para obtener información de la API pública como para recibir información de los webhooks configurados.",
        addApiDesc: "Puedes agregar un botón a tu sitio web que redireccione al Mini-Sitio de reservas de AgendaPro",
        bannerTitle: "Banner sitio web",
        publicApi: "API publica",
        publicApiDesc: "Configuración basica de API y webhooks",
        noUse: "Sin uso o con errores",
        instrIndx: "Para el correcto funcionamiento de esto, tenemos las siguientes recomendaciones:",
        instrOne: "El ancho del iframe debe ser de por lo menos 800px, y en caso de dispositivos más reducidos (tablet vertical y celulares), que use el 100% del ancho de la vista (sin bordes).",
        instrTwo: "En vistas de escritorio, el alto del iframe debe ser automático ('height:auto'), pero para dispositivos móviles (tablet vertical y celulares), el alto se debe definir como el 100% del viewport menos la altura en pixeles (XXX) de los elementos fijos de la página, comúnmente barras de navegación ",
        instrThree: "En lo posible y para asegurar máxima usabilidad y compatibilidad, que no existan elementos no fijos en la misma página que el iframe de reservas, como por ejemplo contenido y footer, para mejorar la experiencia de esta vista."
      },
      onlinePayment: {
        bankRequired: "La institución bancaria no puede estar vacía",
        accountNameRequired: "El nombre del titular no puede estar vacío",
        companyRutRequired: "El RUT del titular no puede estar vac\xEDo. Debes rellenarlo en la secci\xF3n <strong>Cuenta y Facturaci\xF3n</strong> > <strong>Datos de Facturaci\xF3n</strong>",
        accountNumberRequired: "El número de cuenta no puede estar vacío",
        accountTypeRequired: "El tipo de cuenta no puede estar vacío",
        title: "pagos en línea",
        titleDesc: "En esta sección podrás configurar todo lo relacionado con el pago en línea.",
        onlinepayDesc: "Quiero permitir que mis clientes puedan pagar en línea.",
        canCancel: "Editar estado de las reservas",
        cancelDesc: "Elige si quieres permitir que el cliente modifique la reserva en línea (solo puede modificarla,",
        noCancel: "no cancelarla",
        cancelActive: "activar cancelaciones",
        identificationNameDesc: "El RUT de la cuenta bancaria debe coincidir con el RUT del titular de AgendaPro.",
        modActive: "Activar modificaciones",
        modActiveDesc: "Permite que tus clientes puedan modificar sus reservas pagadas en línea.",
        maxTimeCancel: "Tiempo máximo para cancelar",
        minTimeMod: "Tiempo mínimo para modificar",
        minTimeModDesc: "",
        minutes: "Minutos",
        hours: "Horas",
        weeks: "Semanas",
        months: "Meses",
        ctaVta: "Cuenta Vista",
        ctaArr: "Cuenta de ahorro",
        ctaCte: "Cuenta Corriente",
        placeholderTitularName: "Nombre del titular",
        placeholderTitularId: "Identificación del titular",
        defaultReceipt: "Cambiar comprobante por defecto",
        receiptDesc: "Define cuál será el comprobante por defecto con el que quedarán registrados los pagos realizados en línea por tus clientes.",
        receipt: "Comprobante",
        enableDte: "Habilitar comprobante tributario",
        enableDteDesc: "Habilita esta opción para generar comprobantes electrónicos tributarios de manera automática al recibir un pago en línea. Algunos de los documentos tributarios electrónicos necesitan del número de identidad del cliente para que sean válidos. Si ese es tu caso, te recomendamos habilitar “Usar documento de identidad en reserva”",
        here: "acá",
        serviceUseInfo: "Para usar este servicio debes contratarlo al momento de pagar tu plan."
      },
      shifts: {
        title: "Turnos",
        "new": "+ nuevo turno"
      },
      modalShifts: {
        creating: "creando un turno",
        openClose: "Apertura - Cierre"
      },
      billingInfo: {
        title: "Datos de facturacion",
        desc: "Aquí puedes modificar los datos de facturación de tu empresa",
        idType: "Tipo de identificación",
        company: "Empresa",
        person: "Persona natural",
        section1: "Información básica",
        contact: "Nombre",
        id: "Rut",
        idSecond: "DNI",
        legalName: "Razón social",
        boucher: "Giro (Sector económico)",
        section2: "Dirección de facturación",
        address: "Dirección",
        city: "Ciudad",
        state: "Comuna (Distrito)",
        phone: "Teléfono",
        zipCode: "Código Postal",
        section3: "Datos de contacto",
        email: "Email",
        emailDesc: "Ingresa los emails a los que quieras enviar la factura, separados por una coma: email1@agendapro.com, email2@agendapro.com",
        additionalInfo: "Información adicional",
        additionalInfoDesc: "Acá puedes agregar tu resolución de facturación o cualquier nota adicional necesaria para tu factura"
      },
      collectionHistory: {
        title: "Historial de pagos",
        desc: "A continuación encontrarás los comprobantes de pagos que has realizado y podrás descargar los que necesites.",
        selectOption: "selecciona una opcion",
        year: "año",
        dateEmitted: "fecha de emision",
        documentNumber: "número de documento",
        instructions: "¿Cómo leer mi comprobante de pago?"
      },
      selectPlan: {
        specialConditions: "Tu plan tiene condiciones especiales, por favor contáctanos si quieres hacer algún cambio",
        choosePlanType: "Selecciona una opción",
        monthly: "Mensual",
        yearly: "Anual",
        choosePlan: "Selecciona uno de nuestros planes vigentes",
        planDoubts: "¿Tienes dudas?",
        planDoubtsLink: "ver detalles acá",
        locationDoubts: "¿Necesitas más locales?",
        locationDoubtsLink: "contáctanos",
        locationIntercomMsg: "Hola! Me interesa contratar más locales",
        providerDoubts: "¿Necesitas más agendas?",
        providerDoubtsLink: "contáctanos",
        providerIntercomMsg: "Hola! Me interesa contratar más prestadores",
        locationsTitle: "Selecciona la cantidad de locales que necesitas",
        locationsSubtitle: "Necesitas un local por cada dirección física en donde atiendes",
        providersTitle: "Selecciona la cantidad de profesionales adicionales que requieren agendamiento",
        providersSubtitle: "Cada plan incluye una cantidad de profesionales por local. Si necesitas más, puedes agregarlas acá",
        locationsMax: "Locales",
        providersMax: "agendas",
        addonsQuantity: "Cantidad",
        addonsTotal: "Total",
        addonsTitle: "Agrega adicionales a tu Plan",
        addonsSubtitle: "Personaliza tu plan con herramientas adicionales y saca más provecho a tu gestión",
        addonsTitle1: "Confirmación",
        addonsWhatsapp: "WhatsApp",
        addonsWhatsappDesc: "Confirmaciones por WhatsApp (paquete)",
        addonsSms: "SMS",
        addonsSmsDesc: "Confirmaciones por SMS (paquete)",
        addonsTitle2: "Citas por video",
        addonsVideo: "Videoconferencia",
        addonsVideoDesc: "Integra videoconferencias directamente en tus citas",
        addonsTitle3: "Marketing inteligente",
        addonsCharly: "Charly",
        addonsCharlyDesc: "Charly se preocupa de crear campañas inteligentes para tu base de clientes de acuerdo al comportamiento de cada uno.",
        addonsCharlyDescLink: "Ver más información acá",
        addonsTitle4: "Facturación",
        addonsBilling: "Facturación electrónica",
        addonsBillingDesc: "Emitir documentos fiscales electrónicos directamente en AgendaPro con alguno de nuestros partners.",
        updateCurrentPayment1: "Se generará una venta por",
        updateCurrentPayment2: "de inmediato",
        updateNextPayment1: "El siguiente cobro será por",
        updateNextPayment2: "el",
        updateCurrentPlan: "Plan actual",
        updatePlan: "Plan",
        updateAddons: "Adicionales",
        updateChanges: "Plan nuevo",
        updateSelectMethod: "Método de pago",
        changeCard: "Cambiar Tarjeta",
        planDetail: "Detalle del plan",
        estimateMonthly: "/mes",
        estimateYearly: "/año",
        estimateChangePlan: "Si deseas cambiar tu plan actual",
        estimateChangePlanLink: "Cambiar Plan",
        adminUpgradeAccept: "Mejorar mi plan",
        adminUpgradeTitle: "Has llegado al límite de tu plan actual",
        adminUpgradeDescUnlock: "Mejora tu plan para agregar un nuevo local / prestador",
        adminUpgradeDescLock: "Por favor solicita al adminstrador general de la cuenta que mejore tu plan",
        billingInfoAlertTitle: "Hola",
        billingInfoAlertSubtitle1: "Antes de poder pagar y configurar el plan para tu negocio, ",
        billingInfoAlertSubtitle2: "por favor completa los datos de facturación de cuenta.",
        billingInfoAlertDesc: "De esta forma, podremos enviar y emitir de manera correcta los comprobantes de pago.",
        billingInfoAlertAccept: "Completar mis datos de facturación",
        contactLocationsTitle: "¡AGREGA MÁS LOCALES A TU NEGOCIO!",
        contactLocationsDesc: "Tu negocio creció, ¡felicitaciones! Agrega tus nuevas sedes a AgendaPro.",
        contactLocationsMsg: "Hola, me gustaría más información acerca de 'Locales'",
        contactProvidersTitle: "¡AGREGA AGENDAS  A TU NEGOCIO!",
        contactProvidersDesc: "Tu negocio creció, ¡felicitaciones! Agrega al resto de tu equipo a AgendaPro.",
        contactProvidersMsg: "Hola, me gustaría más información acerca de 'Agendas'",
        contactWspTitle: "¡CONFIRMACIONES CON WHATSAPP BUSINESS!",
        contactWspDesc: "Envía recordatorios de tus citas por medio de WhatsApp y AgendaPro.",
        contactWspMsg: "Hola, me gustaría más información acerca de 'WhatsApp'",
        contactSmsTitle: "¡SMS PARA CONFIRMACIONES!",
        contactSmsDesc: "Recuerda las citas de tus clientes por medio de SMS",
        contactSmsMsg: "Hola, me gustaría más información acerca de 'SMS'",
        contactVideoTitle: "¡AGREGA VIDEO- CONFERENCIA A TU NEGOCIO!",
        contactVideoDesc: "Atiende a tus cliente de forma remota con nuestra solución de video. No necesitas ninguna app adicional.",
        contactVideoMsg: "Hola, me gustaría más información acerca de 'Video-conferencias'",
        contactBillingTitle: "¡FACTURACIÓN ELECTRÓNICA EN AGENDAPRO!",
        contactBillingDesc: "Adáptate a las nuevas normativas facturando electrónicamente con alguno de nuestros partners.",
        contactBillingMsg: "Hola, me gustaría más información acerca de 'Facturación Electrónica'",
        contactCharlyTitle: "¡AGREGA CHARLY A TU NEGOCIO!",
        contactCharlyDesc: "Charly se preocupará de ejecutar campañas de",
        contactCharlyDescBold: "marketing inteligente de forma automática.",
        contactCharlyMsg: "Hola, me gustaría más información acerca de 'Charly'",
        contactUs: "CONTÁCTANOS",
        contactAddonsTitle: "Funcionalidades adicionales a tu Plan:",
        landingSummaryTitle: "Resumen de tu plan actual",
        landingSummaryFirstParagraph: "¡Hola! Espero que estés sacando el máximo provecho a todas las funcionalidades que te entregamos.",
        landingSummarySecondParagraph: "Si deseas seguir potenciando tu centro con nuevas funcionalidades comunicate con nosotros en el chat o escríbenos directamente a cuentas@agendapro.com",
        stepTitle11: "Hola",
        stepTitle12: ", elige tu plan AgendaPro",
        stepTitle2: "¿Cómo quieres que te facturemos AgendaPro?",
        stepTitle3: "Elige la forma de pago",
        stepTracker1: "Paso",
        stepTracker2: "de",
        stepTrackerPrevious: "Atrás",
        stepTrackerNext: "Siguiente",
        stepTrackerPay: "Pagar Plan",
        creditCardTitle: "Suscripción automática con tarjeta de crédito",
        creditCardLi1: "Al ingresar acá tu tarjeta de crédito, aceptas que AgendaPro cargue el monto total del valor de tu plan, con impuestos y descuentos incluidos.",
        creditCardLi2: "AgendaPro es un servicio que se paga por adelantado, como cualquier arriendo.",
        creditCardLi3: "En caso de que tu tarjeta presente algún inconveniente, te notificaremos para que puedas cambiarla o hablar con el banco emisor.",
        creditCardLi4: "Las fluctuaciones monetarias, impuestos específicos y comisiones bancarias pueden afectar el monto total que se te cobrará y no son responsabilidad de AgendaPro. Revisa con tu banco emisor las condiciones en caso de dudas.",
        creditCardLi5: "Podrás dar de baja tu suscripción en cualquier momento del mes pero no se reversan casos en caso de arrepentimiento de compra.",
        kushkiDebitCardTitle: "Suscripción automática con tarjeta de débito",
        kushkiDebitCardLi1: "Al ingresar acá tu tarjeta de débito, aceptas que AgendaPro cargue el monto total del valor de tu plan, con impuestos y descuentos incluidos.",
        onlineTitle: "Pago en línea (no automático)",
        onlineLi1: "estás pagando tu suscripción al Plan",
        onlineLi21: "Se te cobrará",
        onlineLi22: "al momento de aprobar la transacción y tu cuenta quedará activa hasta el ",
        onlineLi3: "Las fluctuaciones monetarias, impuestos específicos y comisiones bancarias pueden afectar el monto total que se cobra en la plataforma de tu elección. Revisa con tu banco emisor las condiciones en caso de dudas.",
        onlineLi4: "El pre-pago no podrá ser reversado en caso de arrepentimiento de compra.",
        summaryTitle: "Resumen del pago",
        locationSingular: "Local",
        locationPlural: "Locales",
        providerSingular: "Agenda",
        providerPlural: "Agendas",
        extraProviderSingular: "agenda adicional",
        extraProviderPlural: "agendas adicionales",
        wspSingular: "paquete de WhatsApp",
        wspPlural: "paquetes de WhatsApp",
        smsSingular: "paquete de SMS",
        smsPlural: "paquetes de SMS",
        videocallSingular: "paquete de minutos",
        videocallPlural: "paquetes de minutos",
        summaryTaxes: "Impuestos",
        summaryDiscount: "Descuentos",
        summaryCredits: "Saldo a favor",
        summaryTotal: "Total a pagar:",
        summaryNextPayment: "Siguiente renovación del plan:",
        cardFormTitle: "Datos de la tarjeta",
        cardNumberLabel: "Número de la tarjeta",
        cardNameLabel: "Nombre del titular de la tarjeta",
        cardDateLabel: "Fecha de vencimiento",
        cardCvvLabel: "Código de seguridad",
        iframeNextPayment: "La renovación del plan será de",
        accountStatusHistoryTitle: "Notas de cobro",
        accountStatusHistoryH1: "ID",
        accountStatusHistoryH2: "Periodo del plan",
        accountStatusHistoryH3: "Monto",
        accountStatusHistoryH4: "Fecha de pago",
        accountStatusStatusSummary: "Resumen actual",
        accountStatusSummary1: "Estado de cuenta",
        accountStatusSummary1Active: "Cuenta al día",
        accountStatusSummary1Inactive: "Cuenta inactiva",
        accountStatusSummary1Pending: "Pendiente de pago",
        accountStatusSummary1Processing: "Validando pago",
        accountStatusSummary1Trial: "Periodo de prueba",
        accountStatusSummary2: "Deuda actual",
        accountStatusSummary3: "Pagar antes de",
        accountStatusCardCommon: "Tu cuenta esta",
        accountStatusCardActive: "al día",
        accountStatusCardPending: "pendiente de pago",
        accountStatusCardProcessing: "validando pago",
        accountStatusCardInactive: "inactiva",
        accountStatusCardTrial: "en periodo de prueba",
        accountStatusCardPayHere: "Paga tu plan acá",
        accountStatusCardNextBillingDate: "Próxima fecha de facturación:",
        accountStatusCardEndTrialDate: "Paga tu plan acá antes del ",
        accountStatusCreditCardTitle: "Tienes una suscripción activa",
        accountStatusCreditCardDelete: "Eliminar tarjeta",
        accountStatusCreditCardChange: "Cambiar tarjeta",
        accountStatusChangeBillingInfo: "Modificar datos de facturación",
        changeCreditCard: "Cambiar tarjeta",
        publicPageSuccess: "Tu pago fue procesado correctamente",
        publicPageSuccessLink: "Ir a mi cuenta",
        publicPageFailure: "Tu pago fue rechazado, intentalo nuevamente",
        publicPageFailureLink: "Reintentar pago",
        publicPageNoBackup: "Hola @user, ingresa a tu cuenta para elegir el plan",
        paymentDenied: "¡Algo salio mal con el pago! por favor intentalo de nuevo",
        creditCardFormTitle: "Ingresa los datos de tu tarjeta",
        creditCardError: "Intenta inscribir otra tarjeta",
        stripeSectionTitle: "Tienes una suscripción activa por medio de",
        stripeSectionDesc: "Para modificarla, por favor comunícate con nosotros por el chat de soporte o por el mail contacto@agendapro.com"
      },
      usersSection: {
        title: "Usuarios",
        desc: "Listado actual de usuarios registrados",
        usersRole: "Roles de usuarios",
        roleDesc: "Descripción de cada rol y sus permisos",
        addUser: "Nuevo usuario",
        newUser: "Creando nuevo usuario",
        editUser: "Editando nuevo usuario",
        tableTitleChart: "Permisos sobre fichas",
        tableTitleFields: "Permisos sobre campos personalizados",
        tableTitleCalendar: "Permisos en Calendario",
        tableTitleSales: "Acceso a sección de Ventas",
        emailNotAvailable: "El correo ya está en uso",
        emailAvailable: "El correo está disponible",
        searchBar: "Barra de búsqueda",
        allowSearch: "mostrar barra de búsqueda",
        emailTemplates: {
          tmpPassGenerated: "¡Se ha generado una contraseña temporal!",
          tmpLoginData: "Para ingresar a AgendaPro utiliza los siguientes datos: "
        },
        editProfile: {
          incorrectPass: "Contraseña incorrecta."
        }
      },
      faqs: {
        title: "Preguntas frecuentes",
        questionOne: "¿Cuáles son los medios de pago disponibles en AgendaPro?",
        answerOne: "<p>Tenemos m\xFAltiples medios de pagos disponibles en AgendaPro. <br> <strong>El que recomendamos es la suscripci\xF3n con tarjeta de cr\xE9dito, para que nunca se te olvide el pago a tiempo y no haya ning\xFAn problema con tu cuenta. </strong> <br> El detalle para suscribirte lo puedes encontrar a continuaci\xF3n: </p><ul><li>Seleccionar la opci\xF3n Suscripci\xF3n con tarjeta de cr\xE9dito</li><li>Selecciona el tipo de plan que prefieres contratar: mensual o anual. <br> En caso de que selecciones anual, tendr\xE1s un descuento en el monto del plan, pero tu plan tendr\xE1 una duraci\xF3n m\xEDnima de 12 meses. </li><li>Haz clic en el bot\xF3n Suscribir Tarjeta y luego completa los datos solicitados en el procesador de pago.</li> </ul><p>Si no tienes la opci\xF3n de suscribirte, puedes usar los otros medios de pago presentados en la pantalla. </p>",
        questionTwo: "¿Cómo pagar mi cuenta sin suscribir mi tarjeta de crédito?",
        answerTwo: "<p>Si prefieres no suscribir tu cuenta y pagar mes a mes, simplemente debes elegir la opci\xF3n Pago Online. <br> Luego, elegir la cantidad de meses que quieres abonar y finalmente haz clic en el bot\xF3n Pagar ahora. <br> Finalmente, debes completar los datos solicitados por nuestro procesador de pagos.</p>",
        questionThree: "¿Dónde puedo encontrar mis comprobantes de pago?",
        answerThree: "<p>Podr\xE1s encontrar todos los comprobantes de pago de tu cuenta en la opci\xF3n 'Historial de pagos' del men\xFA de la izquierda en Cuenta y Facturaci\xF3n.</p>",
        questionFour: "¿Cuáles son los medios de pago que acepta AgendaPro?",
        answerFour: "<p>Los medios de pagos dependen tu pa\xEDs y la opci\xF3n que selecciones, ya sea suscripci\xF3n tarjeta de cr\xE9dito, pago online o transferencia electr\xF3nica.</p>",
        questionFive: "¿Cómo puedo cambiar los datos de facturación de mi cuenta?",
        answerFive: "<p>Para actualizar tus datos debes ingresar en Cuenta y facturaci\xF3n, y seleccionar la opci\xF3n 'Datos de Facturaci\xF3n' del men\xFA de la izquierda.</p>"
      },
      customization: {
        title: "Personalización",
        description: "Personaliza el color que usarán tus emails y tu mini-sitio de reservas.",
        activateColors: "Activar colores personalizados",
        activateColorsDesc: "Habilita esta opción para personalizar los colores de tu mini-sitio",
        primaryColorTitle: "Color Primario",
        primaryColorDesc: "* Personaliza el color principal del workflow y botón de confirmar",
        modifyColorTitle: "Color Modificar",
        modifyColorDesc: "* Personaliza el color del botón de modificar perteneciente a los emails",
        cancelColorTitle: "Color Cancelar",
        cancelColorDesc: "* Personaliza el color del botón de cancelar perteneciente a los emails",
        emailsSectionTitle: "Titulo para esta seccion",
        emailsSectionDesc: "Descripcion para esta seccion...",
        confirmServices: "Por favor confirma tus reservas"
      },
      videocall: {
        waitingRoom: "Sala de Espera",
        finishedRoom: "Finalizado",
        notReady: "La videoconferencia no ha comenzado",
        alreadyFinished: "La videoconferencia ha finalizado",
        willBeRedirected: "Serás redirigido automáticamente cuando esta inicie.",
        notFooter: ""
      },
      dashboard: {
        title: "Resumen",
        detail: "Detalle",
        totalBookings: "TOTAL DE RESERVAS",
        bookingsRevenue: "INGRESOS ESTIMADOS",
        occupationFactor: "FACTOR DE OCUPACIÓN",
        todaySchedule: "Horario de hoy",
        newClients: "NUEVOS CLIENTES",
        footCard: "Con respecto a la semana anterior",
        totalBookingsToolText: "Texto para el Tooltip de reservas totales",
        occupationFactorToolText: "Ocupación estimada de la agenda de los prestadores.",
        newClientsToolText: "Corresponde a los nuevos clientes del periodo consultado.",
        bookingsRevenueToolText: "La suma de los precios de todas las reservas y sesiones agendadas. No considera pagos ingresados o no ingresados.",
        weeklyOccupationFactorToolText: "Texto para el Tooltip de ocupacion semanal",
        bookingsOriginToolText: "Texto para el Tooltip de reservas originales",
        weeklyOccupationFactor: "Factor de ocupación",
        bookingsOrigin: "Fuentes de reservas",
        sales: "Ventas facturadas",
        emailConfirmations: "Confirmaciones por email",
        whatsappConfirmations: "Confirmaciones por WhatsApp",
        bookingsConfirmed: "Reservas confirmadas",
        conversations: "Conversaciones",
        whatasappSent: "WhatsApp enviados",
        whatasappConfirmed: "WhatsApp confirmados",
        messagesSent: "Mensajes enviados",
        emailCampaign: "Métricas campañas email",
        currentBirthdays: "Cumpleaños de hoy",
        onlineSales: "Pagos en línea",
        service: "Servicio",
        product: "Producto",
        plan: "Planes",
        reserveTotals: "Reservas totales",
        notCofirmedTotals: "Reservas no confirmadas",
        messagesNotSent: "Mensajes no enviados",
        confirmationsSent: "Confirmaciones por email",
        confirmationsNotSent: "Confirmaciones no enviadas",
        emailsSended: "Emails enviados",
        whatsappMsjsSeneded: "WhatsApp enviados",
        whatsappMsjsNotSeneded: "WhatsApp no enviados",
        whatsappMsjsConfirmed: "WhatsApp confirmados",
        whatsappMsjsNotConfirmed: "WhatsApp no confirmados",
        onlineReservesPayed: "Reservas pagadas por internet",
        percentageTotal: "% Respecto al total de reservas",
        totalAmount: "Monto total pago",
        emailCampaigns: "Metricas campañas email",
        emailsSend: "enviados",
        emailsOpen: "abiertos",
        emailsTotal: "Emails entregados",
        addUser: "Registra tu primer cliente",
        addCampaign: "Crea tu primera campaña",
        activateWhatsapp: "Actívalo aquí",
        activateWhatsappMsg: "Hola, me interesa activar WhatsApp",
        activateOnlinepay: "Actívalo aquí",
        activateOnlinepayMsg: "Hola, me interesa activar pagos online",
        addSales: "Ingresa tu primera venta",
        addPayment: "Ver pagos en línea",
        addBooking: "Crea tu primera reserva",
        noPermissions: "Sin permisos disponibles",
        all: "Todos",
        serviceProviders: "Prestador(es)",
        locations: "Local(es)",
        timeFrame: "Periodo de tiempo",
        thisWeek: "Esta semana",
        lastWeek: "La semana pasada"
      },
      consents: {
        title: "Consentimientos",
        editConsent: "editar consentimiento",
        newConsent: "crear consentimiento",
        selectFile: "Seleccionar archivo",
        fileNamePlaceholder: "nombre del consentimiento",
        fileWarning: "El archivo debe tener un tamaño no mayor a 5 mb",
        signConsent: {
          mailBody: "<strong>%{name} %{lastName}</strong>,  <br/>Has recibido un consentimiento de parte de %{company} el cual debes firmar para recibir el tratamiento/atenci\xF3n agendado."
        }
      },
      addons: {
        title: "Adicionales",
        "new": "nuevo adicional",
        description: "Crea adicionales que luego se añadirán a los servicios",
        create: "creando nuevo adicional",
        selectCategory: "selecciona una categoría",
        noAddons: "categoría sin adicionales",
        activated: "addon activado",
        saved: "adicional guardado",
        error: "Ha ocurrido un error"
      },
      bookingEmails: {
        videoconferenceParagraph: "Para una óptima experiencia te recomendamos:",
        videoconferenceExplanation1: "Acceder 5 minutos antes de la hora pautada",
        videoconferenceExplanation2: "Tener cámara y audífonos (no es excluyente, solo si hay ruido ambiente)",
        videoconferenceExplanation3: "Conexión a una red wifi o red móvil: 1 Mbps o superior / 3G o superior"
      },
      workflow: {
        toDecide: "Por determinar",
        showMore: "...Ver más",
        showLess: "Ver menos",
        morningHours: "Mañana",
        afternoonHours: "Tarde",
        nightHours: "Noche",
        emptyHours: "*No hay horas disponibles",
        reserve: "RESERVAR",
        book: "Agendar",
        servicesLabel: "Servicios",
        noResults: "Sin resultados",
        totalService: "servicio",
        totalDuration: "Duración total",
        servicesTitle: "Haz clic en una categoría para ver sus servicios",
        notHourSelected: "Sin hora seleccionada",
        providersTitle: "Haz clic en un profesional para ver los servicios que realiza",
        policyTermsCustomPart1: "Acepto las",
        policyTermsCustomPart2: "Políticas de Reserva y Privacidad de %{companyName},",
        policyTermsCustomPart3: "y recibir e-mails enviados por medio de AgendaPro.",
        provider: "Profesional",
        classesTitle: "Haz clic en una categoría para ver sus Clases",
        noDescription: "Bienvenid@s al sistema de reserva de %{companyName}",
        searchByService: "Buscar por servicios",
        searchByProvider: "Buscar por Profesionales",
        changeSucursal: "Cambiar de sucursal",
        mySelection: "Mi selección",
        chooseSchedule: "Finalizar Reserva",
        noService: "* Debes seleccionar al menos un servicio para poder continuar.",
        step1: "1. Selecciona el profesional",
        step2: "2. Selecciona el día",
        step3: "3. Selecciona la hora",
        step4: "4. Datos de la reserva",
        step5: "5. Políticas de reservas pagadas en línea",
        step5Title1: "Por favor revisas con atención la siguiente información",
        step5Title2: "La reserva se puede modificar",
        step5Description1: "Hasta",
        step5Description2: "horas antes del servicio contratado.",
        step5Description3: "Hasta",
        step5Description4: "desde la fecha en que se efectuó el pago.",
        step5Description5: "Si no cumple con alguna de las dos restricciones anteriores, no podrá modificar su reserva.",
        step5Description6: "Además, la empresa permite modificar la reserva un máximo de",
        step5Description7: "veces.",
        step5Description8: "NO se permite cancelar reservas pagadas en línea.",
        step5Description9: "Tu pago será procesado en una nueva pestaña por nuestro partner",
        step5Description10: "En caso de que tu pago no sea completado o rechazado, cancelaremos la reserva.",
        step5Description11: "Tu pago será procesado por nuestro partner",
        noSessionsSelected: "No se ha seleccionado una hora para las sesiones, puede seleccionar hasta",
        noServiceSelected: "Sin servicios seleccionados",
        oneServiceSelected: "Servicio seleccionado",
        pluralServiceSelected: "Servicios seleccionados",
        sessionLabel: "Sesión",
        totalSessionsLabel: "Sesiones",
        totalPriceLabel: "Total a pagar",
        totalPriceOnlineLabel: "Total a pagar pagando en línea",
        firstAvailableLabel: "Primero Disponible",
        providerSelectLabel: "Seleccionar profesional",
        totalDurationLabel: "Duración total",
        anotherServiceLabel: "Otro servicio",
        nameLabel: "Nombre",
        lastnameLabel: "Apellido",
        emailLabel: "Email",
        phoneLabel: "Teléfono",
        modifyLabel: "Modificar",
        infoLocation: "información y ubicación",
        resumeLabel: "Resumen",
        sessionPriceMessage: "* El precio del servicio %{serviceName} va a ser confirmado el día de la sesión",
        emailsTermsLabel: "Al reservar, estás aceptando recibir e-mails de %{companyName}, enviados por medio de AgendaPro.",
        membershipTermsLabel: "*Si tienes Membresías con %{companyName}, por favor ingresa tu RUT en el campo para poder validarla.",
        deliveryAddressLabel: "Dirección donde recibirá el servicio a domicilio",
        selectOptionLabel: "Seleccione una opción",
        errorAlertDni: "Ingrese un RUT en el siguiente campo de texto para validar si es correcto o no.",
        modalTitle: "Mi reserva",
        comeBackLabel: "Volver",
        payAndBook: "Pagar y Reservar",
        nextButtonLabel: "Siguiente",
        bookLabel: "Reservar",
        totalOfflinepay: "Total sin pago en línea",
        localInfo: "Información y Ubicación",
        about: "Acerca de %{companyName}",
        noLocation: "Debes seleccionar un local",
        viewMap: "Ver mapa",
        searchProvider: "¿Qué profesional buscas?",
        searchServicies: "¿Qué servicio buscas?",
        noOperation: "Lo sentimos, la reserva no se pudo ",
        modifiUpercase: "modificar",
        createUpercase: "crear",
        newBookClick: "Si deseas agendar nuevamente, haz click ",
        here: "aquí",
        yourBook: "Tu reserva fue ",
        successBook: "creada exitosamente.",
        modifiBook: " actualizada exitosamente.",
        resume: "Resumen de tu Reserva",
        whatDidBook: "¿Qué reservaste?",
        where: "¿Dónde?",
        withWho: "¿Con Quién?",
        when: "¿Cuándo?",
        notes: "Notas",
        yourData: "Tus Datos",
        scheduleAgain: "Agendar nuevamente",
        stateNewBook: "Creando nueva reserva",
        stateModifiBook: "Modificando la reserva",
        companyLocalError: "Lo sentimos, el local ingresado no es parte de su compañía."
      },
      superadmin: {
        buttons: {
          deactivateUser: "Desactivar usuario"
        },
        message: {
          successCompanyEdit: "Companía editada correctamente.",
          errorOnCompanyEdit: "Ocurrió un error al editar la compañía."
        },
        resetPassAlert: "Está seguro que desea restablecer la contraseña? (Este proceso es irreversible)",
        resetPassFor: "Restablecer contraseña para ",
        deactivateUser: "Se desactivo el usuario %{user}",
        resetPassSubject: "Contraseña temporal AgendaPro",
        emailSentTo: "Se ha enviado un correo con la nueva contraseña a ",
        sendError: "No fue posible realizar la accion, intentelo nuevamente.",
        removeEmailFrom: "Seleccione de que lista desea remover:",
        transactionalEmails: "Correos transaccionales",
        marketingEmails: "Correos de marketing",
        mustChooseOption: "Debe seleccionar una opción",
        emailRemovedFrom: "Se ha quitado el correo de suprimidos en:\n",
        emailNotOnBlacklists: "El correo ingresado no se encuentra en ninguna lista de suprimidos para esta compañía",
        noActionCommited: "No se ha realizado ninguna acción",
        userByEmailNotFound: "No se ha encontrado ningún usuario con ése correo.",
        userBelongsTo: "Usuario perteneciente a compañía ID:",
        theEmail: "El correo:",
        hasBeenUpdatedTo: "ha sido actualizado a:",
        userMustBeLocalAdmin: "Operación no permitida para éste tipo de usuario.",
        cantUpdateEmail: "No se pudo actualizar el correo.",
        theUser: "El usuario",
        hasBeenUpgradedGeneralAdmin: "ha sido modificado a Administrador General",
        userWithNoCompany: "El usuario no pertenece a ninguna compañía, Rol:",
        successfulQuery: "Consulta exitosa",
        timeoutQuery: "No se pudo realizar la consulta, mostrando los últimos 50 registros",
        noPermissionToPerform: "No tienes permiso para realizar esta acción",
        requestBackupWarning: "Esta acción podría traer consecuencias en la compañía, recuerde contar con respaldo de la solicitud por escrito",
        process: {
          processes: "Procesos",
          bookingStatusReminder: {
            sendReminders: "Envío de recordatorios",
            bookingFinalReminder: "Recordatorio de la reserva cliente final",
            totalRemindersSameDay: "Total de recordatorios same day que deben ser enviados",
            sendRemindersSameDay: "Total de recordatorios same day enviados",
            totalRemindersDays: "Total de recordatorios de reservas +%{days} días que deben ser enviados",
            sendRemindersDays: "Total de recordatorios de reservas +%{days} días enviados",
            totalRemindersToSend: "Total recordatorios a enviar",
            sentReminders: "% Recordatorios enviados"
          }
        }
      },
      productHistory: {
        dateRange: "Rango de fecha",
        order: "Orden",
        state: "Estado",
        locations: "Locales",
        category: "Categoría",
        products: "Productos",
        productHistory: "Historial de productos",
        downloadButton: "Descargar Historial",
        newer: "Mas reciente",
        older: "Menos reciente",
        productNewer: "Por Productos (mas reciente)",
        productOlder: "Por Productos (mas antiguo)",
        salesTotal: "PRODUCTOS VENDIDOS",
        internalSalesTotal: "PRODUCTOS POR VENTA INTERNA",
        externalSalesTotal: "PRODUCTOS POR VENTA EXTERNA (CLIENTES)",
        tableDateLabel: "Fecha",
        tableProductLabel: "Producto",
        tableLocationLabel: "Local",
        tableChangeLabel: "Ajuste",
        tableCauseLabel: "Causa",
        tableClientLabel: "Cliente",
        tableStaffLabel: "Staff",
        tableNotesLabel: "Comentario",
        noApply: "No aplica",
        noSeller: "Sin identificar"
      },
      userRole: {
        superAdmin: "Super Admin",
        generalAdmin: "Administrador General",
        localAdmin: "Administrador Local",
        staff: "Staff",
        staffWithoutEdition: "Staff (sin edición)",
        user: "Usuario Registrado",
        frontdesk: "Recepcionista",
        warehouseKeeper: "Bodeguero",
        frontdeskWithoutEdition: "Recepcionista (sin edición)",
        sales: "Ventas"
      },
      salesHistory: {
        withoutInformation: "N/A",
        product: "Producto",
        seller: "Vendedor",
        totalSellings: "RECAUDACIÓN TOTAL",
        unitsSold: "UNIDADES VENDIDAS",
        mostEarning: "Mayor ingreso",
        lessEarning: "Menor ingreso",
        units: "unidades",
        forProduct: "Por producto",
        forCollection: "Por recaudación",
        selectedPeriod: "Del periodo de tiempo seleccionado",
        labelProduct1: "Producto",
        labelProduct2: "Unidades",
        labelProduct3: "Recaudación",
        labelCollection1: "Vendedor",
        labelCollection2: "Usuario",
        labelCollection3: "Unidades",
        labelCollection4: "Recaudación",
        salesTitle: "Ventas",
        summaryTitleModal: "Resumen de ventas de",
        modalSubtitle: "Entre",
        downloadReport: "Descargar reporte",
        date: "Fecha",
        totalAmount: "Monto Total",
        unitaryPrice: "Precio unitario",
        quantity: "Cantidad"
      },
      mailers: {
        booking: {
          receivedBooking: "tu reserva fue <b>recibida</b> exitosamente.",
          confirmYourBooking: "por favor confirma tu reserva",
          bookingSuccessClient: "tus servicios fueron reservados exitosamente",
          confirmAllServicesButton: "Confirmar todos los Servicios",
          bookingSuccessProvider: "fue reservado multiples servicios contigo",
          payDetail: "Detalle de servicios realizados y monto pendiente a pagar",
          payWelcome: "Hola %{clientName}, acá te detallamos los servicios que tienes pendientes por pagar",
          updatedBooking: "tu reserva fue <b>actualizada</b> exitosamente.",
          cancelledBooking: "tu reserva fue <b>cancelada</b> exitosamente",
          payButton: "Paga Online",
          saveTime: "¡Ahorra tiempo y evita filas!",
          withVideoconferenceReminder: "Uno de los servicios es por <b>Video llamada</b> y el enlace lo encontrar\xE1s abajo.",
          serviceBookedWithYou: "fue reservado un servicio contigo",
          multipleServicesBooked: "tus servicios fueron <b>reservados</b> exitosamente",
          bookingDetails: "Datos de la reserva",
          service: "SERVICIO",
          when: "¿CUÁNDO?",
          whatDidTheyReserved: "¿Qué reservaron?",
          whenCapitalized: "¿Cuándo?",
          where: "¿DÓNDE?",
          withWho: "¿CON QUIÉN?",
          who: "¿Quién?",
          videocall: "Videoconferencia",
          notes: "NOTAS",
          homeService: "Servicio a domicilio",
          editBooking: "Modificar Reserva",
          cancelBooking: "Cancelar Reserva",
          confirmBooking: "Confirmar Reserva",
          modificationTerms: "La reserva se puede modificar:",
          retrieveContact: "Si tienes dudas con el cobro, contáctanos al: ",
          upTo: "Hasta",
          hoursBeforeService: "horas antes de la reserva",
          companyMaxEdit: "Un máximo de",
          editRestrictionReminder: "Si no cumples con alguna de las restricciones anteriores, no podrás modificar tu reserva.",
          times: "veces.",
          constraintCondition: "Lo anterior solo aplica si es que",
          allowModification: "permite la modificación de reservas.",
          allRightsReserved: "Todos los derechos reservados",
          goToVideocall: "Ir a la Video llamada",
          goToBooking: "Ir a Reservar",
          videocallBestExpRecomendations: "Para una óptima experiencia te recomendamos:",
          unsuscribeMessage: "No recibir más estos mensajes",
          videocallService: "Servicio por Video llamada",
          onLocationService: "Servicio presencial",
          cancel: "Cancelar",
          edit: "Modificar",
          cancelledBookingDetails: "Detalles de la reserva",
          payYourBookHere: "Paga tu reserva aquí",
          payHere: "Paga aquí",
          aReservationWasConfirmedWithYou: "fue confirmada una reserva contigo.",
          rememberIsAVideocall: "Recuerda que es por videoconferencia y el enlace lo encontrarás abajo."
        },
        payments: {
          agendaproTeam: "Equipo de AgendaPro",
          adminTeam: "Equipo administración",
          to: "al",
          weeklySummaryAttached: "Adjuntamos el resumen de los pagos en línea de nuestros cliente de Chile del periodo de",
          registeredOnAgendapro: "registrados en AgendaPro.",
          reportErrorInfo: "No se pudo generar el reporte de pago en línea de forma automática, contactar al equipo de soporte.",
          emptyPayments: "No existen pagos pendientes"
        },
        clients: {
          activity: "Actividad",
          bookings: "Reservas",
          history: "Historial",
          summary: "Resumen",
          files: "Archivos",
          comments: "Comentarios",
          payments: "Pagos",
          comunication: "Comunicaciones",
          messages: "Mensajería",
          survey: "Encuestas",
          consents: "Consentimientos",
          charts: "Fichas",
          deleted: "Cliente eliminado"
        },
        postPayment: {
          subjectMail: "Hola %{client}, estos son tus servicios pendientes por pagar en %{company}"
        }
      },
      postPayment: {
        switchOptionTitle: "Activar sistema de cobro post atención",
        switchOptionDescription: "Al activar esta opción, se creará un link de post-pago para cada reserva no pagada. Podrás enviar un email de cobro al cliente de la cita o copiar un link de pago único para enviar por cualquier otro medio. Esto lo encuentras en la pestaña calendario dentro de la reserva."
      },
      bookingPrint: {
        bookingOf: "Reserva de:",
        booking: {
          serviceInfo: "Datos de la reserva",
          service: "Servicio",
          schedule: "Horario",
          place: "Lugar",
          provider: "Prestador",
          sessionPrice: "Precio sesión",
          price: "Precio",
          notes: "Notas"
        },
        client: {
          clientInfo: "Datos del cliente",
          name: "Nombre",
          email: "E-mail",
          phone: "Teléfono"
        }
      },
      onlinePayments: {
        helmet: "Reservas pagadas en línea",
        tab1: "Transacciones",
        tab2: "Transferencias realizadas",
        filterLabelDate: "Desde/Hasta",
        filterLabelLocations: "Locales",
        filterLabelTransfer: "Transferencia",
        filterLabelStatus: "Estado de pago",
        statusCompleted: "Completado",
        statusDeclined: "Incompleto",
        statusPending: "Pendiente",
        transferDone: "Realizadas",
        transferNotDone: "No realizadas",
        cardsTotal: "Monto total",
        cardsCommission: "Comisión",
        cardsNeto: "Total Neto",
        cardsSummaryTitle: "Monto Bruto",
        cardsCommissionTitle: "Comisión",
        cardsNetoTitle: "Total Neto",
        cardsCompleted: "Transferencias Completadas",
        cardsPending: "Pendientes por Transferir",
        tableHeadId: "ID",
        tableHeadDate: "Fecha",
        tableHeadPeriod: "Período",
        tableHeadCollectedAmount: "Monto recaudado",
        tableHeadCommission: "Comisión",
        tableHeadTotal: "Total Transferencia",
        tableHeadStatus: "Estado de pago",
        tableHeadActions: "Acciones",
        tableHeadLocation: "Local",
        tableHeadClient: "Cliente",
        tableHeadAmount: "Monto",
        tableHeadService: "Servicio",
        tableHeadTransferDate: "Transferencia",
        tableTransferPending: "Pendiente",
        tableTransferInProcess: "En Proceso",
        tableTransferPayed: "Pagado",
        tableTransferPeriod: "del %{date1} al %{date2}",
        modalTitle: "Transferencia del",
        modalTitleNoDate: "Transferencia pendiente",
        payments: {
          agendaproTeam: "Equipo de AgendaPro",
          adminTeam: "Equipo administración",
          to: "al",
          weeklySummaryAttached: "Adjuntamos el resumen de los pagos en línea de nuestros cliente de Chile del periodo de",
          registeredOnAgendapro: "registrados en AgendaPro.",
          reportErrorInfo: "No se pudo generar el reporte de pago en línea de forma automática, contactar al equipo de soporte.",
          emptyPayments: "No existen pagos pendientes"
        }
      },
      serviceConsumption: {
        sessionsCount: "Grupos de sesiones totales: %{sessionsCount}"
      },
      sendInvoices: {
        mailBody: "Hola <b>%{firstName} %{lastName}</b>, Adjuntamos ",
        invoicesType: {
          boleta: "la boleta electrónica",
          factura: "la factura electrónica",
          "boleta de servicios": "la boleta de servicios electrónica",
          "factura exenta": "la factura exenta electrónica",
          otro: "Otro"
        },
        invoicesTypeSubject: {
          boleta: "Boleta electrónica",
          factura: "Factura electrónica",
          "boleta de servicios": "Boleta de servicios electrónica",
          "factura exenta": "Factura exenta electrónica",
          otro: "Otro"
        },
        mailBodyEnd: "de tu compra: </br>",
        errorSend: "El pago no tiene documentos electrónicos generados.",
        noEmails: "Debe proporcionar un correo electrónico.",
        services: "Servicio(s) y/o Producto(s):",
        date: "Fecha:",
        greetings: "Saludos cordiales,"
      },
      barNotification: {
        issued: "Tu cuenta se encuentra emitida. Por favor <a href='%{link}'><b>realiza tu pago aqu\xED</b></a> antes del %{date} o de lo contrario no podr\xE1s utilizar tu cuenta. Recuerda que tambi\xE9n puedes suscribir tu tarjeta de cr\xE9dito <a href='%{link}'><b>aqu\xED</b></a>.",
        paymentCardRetryAcount: "Tu suscripci\xF3n a AgendaPro lleva %{count} intentos fallidos. <a href='%{link}'><b>Actualiza la informaci\xF3n de pago</b></a> antes del %{date} o de lo contrario no podr\xE1s utilizar tu cuenta.",
        subscriptionFailed: "Tu suscripci\xF3n a AgendaPro ha fallado. Renueva <a href='%{link}'><b>tus datos de suscripci\xF3n</b></a> y realiza el pago antes del %{date} o de lo contrario no podr\xE1s utilizar tu cuenta",
        greetings: "Saludos cordiales,"
      },
      signup: {
        title: "¡Simplifica tu vida con AgendaPro!",
        description: "Prueba nuestra plataforma gratis por 7 días",
        fullname: "Nombre Completo",
        email: "Email",
        phone: "Teléfono",
        economicSector: "¿Qué tipo de negocio tienes?",
        providersNumber: "Profesionales que requieren agendamiento",
        password: "Contraseña",
        accept: "Acepto",
        terms: "términos y condiciones",
        logIn: "Inicia sesión aquí",
        haveAccount: "¿Ya tienes una cuenta? ",
        createAccount: "Crear cuenta",
        passwordPlaceholder: "Debe contener mínimo 8 caracteres",
        creatingAccount: "Creando cuenta",
        foot: "© AgendaPro I Gunei Investment SpA I Todos los derechos reservados",
        errMsg: "No se pudo guardar la empresa, verifique todos los campos e intente de nuevo o contacte con soporte",
        companyExistErr: "Ya existe una compañía asociada a este correo eletrónico",
        invalidEmail: "Ingresa un email válido",
        invalidPhone: "Ingresa un teléfono válido"
      },
      companyPaymentMethods: {
        deactive: "Desactivado",
        active: "Activado"
      },
      serviceProviderActive: {
        deactive: "Desactivado",
        active: "Activado"
      },
      searchbarPlaceholder: "Búsqueda rápida",
      searchbarClientsPlaceholder: "Búsqueda de clientes",
      pushNotifications: {
        bookingNew: {
          title: "Nueva reserva",
          body: {
            oneLocation: "%{name} reservó %{service} para %{date}",
            multipleLocations: "%{name} reservó %{service} para %{date} en %{location}"
          }
        },
        bookingCancel: {
          title: "Reserva cancelada",
          body: {
            oneLocation: "%{name} canceló %{service} para %{date}",
            multipleLocations: "%{name} canceló %{service} para %{date} en %{location}"
          }
        },
        bookingUpdate: {
          title: "Reserva modificada",
          body: {
            oneLocation: "%{name} modificó %{service} para %{date}",
            multipleLocations: "%{name} modificó %{service} para %{date} en %{location}"
          }
        },
        bookingConfirm: {
          title: "Reserva confirmada",
          body: {
            oneLocation: "%{name} confirmó %{service} para %{date}",
            multipleLocations: "%{name} confirmó %{service} para %{date} en %{location}"
          }
        }
      },
      propay: {
        notYetBooked: "Por agendar",
        videoCall: "Videoconferencia",
        homeService: "Servicio a domicilio",
        messages: {
          rejectedDefault: "Su banco rechazó la transacción, comuníquese con su banco.",
          rejectedMax: "Máximo de intentos superado.",
          rejectedBlocked: "Su banco bloqueó la transacción o la tarjeta, comuníquese con su banco.",
          rejectedDuplicated: "Su banco rechazó la transacción por cargo duplicado.",
          rejectedDisabled: "Tarjeta expirada o deshabilitada.",
          rejectedInsufficientBalance: "Saldo insuficiente en su tarjeta.",
          rejectedInvalid: "Número de tarjeta o código de seguridad inválido.",
          rejectedRequestingThreeDs: "Error, por favor reintente en unos minutos.",
          rejectedGeneric: "Error, por favor reintente en unos minutos.",
          invalidGatewayUniqueIdentifier: "El TRXID del Booking no es idéntico al identificador del Gateway",
          doesNotHaveAnAssigned: "No tiene un %{model} asignado",
          emptyBookingsOnWhere: "No hay registros de Bookings asociados al TRXID",
          payedBookingAssociationRequired: "Debe tener un payedBooking asociado.",
          recordNotExists: "No existe un registro para el modelo %{model}."
        },
        dlocal: {
          messages: {
            undefinedEnvironmentVariable: "La variable de entorno %{env} aún no ha sido definida."
          }
        },
        webPay: {
          title: "Pago en línea"
        },
        gatewayNotification: {
          success: "Solicitud procesada con éxito",
          requiredParams: "No se han recibido parámetros en la solicitud.",
          documentId: "El parámetro documento de identidad es inválido"
        }
      },
      incentiveOnlinePayments: {
        modalSuccessTitle: "¡Pago en línea activado de forma exitosa!",
        modalSuccessSubtitle1: "OJO: Hemos habilitado todo en tu cuenta para que tus",
        modalSuccessSubtitleServices: "servicios",
        modalSuccessDesc: "Si quieres modificar esta opci\xF3n, y que sea obligatorio el pago en l\xEDnea, o que solo se pueda pagar de forma presencial, debes ir al servicio en espec\xEDfico > Editar > Opciones avanzadas",
        modalSuccessSubtitleBold1: "puedan",
        modalSuccessSubtitle2: "recibir",
        modalSuccessSubtitleBold2: "reservas",
        modalSuccessSubtitle3: "y",
        modalSuccessSubtitleBold3: "pagos",
        modalSuccessSubtitle4: "en línea.",
        modalSuccessDesc1: "Si quieres modificar esta opción, y que sea",
        modalSuccessDescBold1: "obligatorio",
        modalSuccessDesc2: " el pago en línea, que solo se pueda pagar de forma",
        modalSuccessDescBold2: "presencial",
        modalSuccessDesc3: ", o",
        modalSuccessDescBold3: "no permitir reservas en línea",
        modalSuccessDesc4: ", debes ir al servicio en espec\xEDfico > Editar > Opciones avanzadas",
        allowOnlinePaymentsInasistences: "¡Permite que tus clientes paguen en línea y disminuye las inasistencias!",
        transferencesBankMoney: "Todos los miércoles te transferimos a tu cuenta bancaria lo recaudado los 7 días anteriores.",
        payLowComission: "Pagarás una comisión muy baja por estas operaciones: ",
        howDoesItWork: "¿Cómo funciona?",
        paymentOptions: "Tus clientes pagan directamente al momento de reservar, o si prefieres pueden pagar después a través de un link de cobro a su email o Whatsapp.",
        clabeTitle: "CLABE interbancaria",
        clabeLink: "¿Cómo saber la CLABE?",
        clabeInvalid: "Clabe invalida"
      },
      deletePosPayment: "No puedes eliminar pagos realizados a través de AgendaPro",
      prepayedAssociatePayment: "Sí (pago asociado)",
      prepayedPendingPayment: "Sí (pago pendiente de aprobación)",
      prepayedAssociatePartialPayment: "Sí (Abono parcial)",
      prepayedYes: "Sí",
      prepayedNot: "No",
      parameterRequired: "Parametros companyId o locationId o clientId faltantes",
      rest: {
        error: {
          companySettingsProviderPosInvalid: "Configuración -Proveedor de pago POS- incorrecta.",
          featureNotEnabledForCountry: "Esta característica no está disponible en tu país."
        }
      },
      paymentPeriod: "del %{startDate} al %{endDate}",
      menu: {
        summary: "Resumen",
        calendar: "Calendario",
        sales: "Ventas",
        products: "Productos",
        clients: "Clientes",
        reports: "Reportes",
        administration: "Administración",
        invoicedSales: "Ventas Facturadas",
        payment: "Pagos",
        downPayments: "Abonos",
        budget: "Presupuestos",
        plans: "Planes",
        commissionReport: "Reporte de Comisiones",
        giftCards: "Gift Cards",
        saleBoxes: "Caja de Ventas",
        rips: "RIPS",
        onlinePayments: "Pagos en Línea",
        inventory: "Inventario",
        history: "Historial",
        clientsBase: "Base de Clientes",
        emailMarketing: "Reporte de Campañas",
        locations: "Locales",
        serviceProviders: "Prestadores de Servicios",
        services: "Servicios",
        commissions: "Comisiones",
        resources: "Recursos",
        survey: "Encuestas",
        customApp: "App Personalizada",
        shifts: "Turnos",
        consents: "Consentimientos",
        companyPanel: "Panel Empresa",
        editProfile: "Editar Perfil",
        academy: "Academia AgendaPro",
        goToBookingSite: "Ver Sitio",
        payMyPlan: "Pagar",
        logout: "Cerrar Sesión",
        configurations: "Configuraciones",
        users: "Usuarios",
        accountAndBilling: "Cuenta y Facturación",
        customization: "Personalización",
        profile: "Perfil",
        surveyAnswers: "Reporte de Encuestas",
        marketingBlacklist: "Lista de E-mails suprimidos",
        managementControl: "Control de Gestión",
        general: "General",
        roles: "Roles",
        paymentsStatus: "Estado de Pagos",
        bookingStatuses: "Estados de Reserva",
        plansManagement: "Gestión de Planes",
        numericParameters: "Parámetros Numéricos",
        transferencesOnline: "Transferencias (pago en línea)",
        transferencesPay: "Transferencias (pago plan)",
        banks: "Bancos",
        promotions: "Promociones",
        receipts: "Recibos de Pago",
        paymentMethods: "Medios de Pago",
        paymentMethodsTypes: "Tipos de Medio de Pago",
        places: "Lugares",
        countries: "Países",
        regions: "Regiones",
        cities: "Ciudades",
        districts: "Comunas",
        searchEngine: "Buscador",
        economicSector: "Sector Económico",
        marketplaceCategories: "Categorías Marketplace",
        tags: "Tags",
        myAgenda: "Mi Agenda",
        referralLink: "Invita y gana",
        mobileReports: "Reporte de mensajería móvil",
        reservationReports: "Reporte de reservas",
        activateHere: "Activar aquí"
      },
      messages: {
        whatsapp: "WhatsApp",
        sentMessages: "MENSAJES ENVIADOS",
        confirmedMessages: "MENSAJES CONFIRMADOS",
        sent: "Enviados",
        confirmations: "Confirmaciones",
        inRespectOfPreviousPeriod: "Con respecto al periodo anterior",
        totalReservationsWithoutConfirmation: "Total de reservas sin confirmación",
        reservationsWithoutConfirmation: "Reservas sin confirmación",
        mobileConfirmedMessages: "Mensajes confirmados por mensajería móvil",
        history: {
          clientName: "Nombre Cliente",
          location: "Local",
          reservationDate: "Fecha de reserva",
          type: "Tipo",
          messageDate: "Fecha de Mensaje",
          messageStatus: "Estado de mensaje",
          noInfo: "Sin Info"
        }
      },
      simpleForm: {
        yes: "Sí",
        no: "No",
        required: {
          text: "Requerido",
          mark: "*"
        },
        errorNotification: {
          defaultMessage: "Por favor revisa los errores a continuación:"
        }
      },
      servicePriceDefault: {
        price: 1000
      },
      serviceDefault: {
        Barbería: {
          name: "Corte de Cabello",
          duration: 30
        },
        "Centro de Estética": {
          name: "Tratamiento Facial",
          duration: 30
        },
        "Centro Deportivo": {
          name: "Clases de Tenis",
          duration: 30
        },
        "Centro Médico": {
          name: "Consulta Médica",
          duration: 30
        },
        Clases: {
          name: "Clases de 30 minutos",
          duration: 30
        },
        Clínica: {
          name: "Consulta Médica",
          duration: 30
        },
        "Clínica Odontológica": {
          name: "Diagnóstico",
          duration: 30
        },
        "Consulta Médica": {
          name: "Consulta Médica",
          duration: 30
        },
        "Consulta Médica Particular": {
          name: "Consulta Particular",
          duration: 30
        },
        Consultorio: {
          name: "Consulta Médica",
          duration: 30
        },
        Crossfit: {
          name: "Clase de Crossfit",
          duration: 30
        },
        "Danza / Baile": {
          name: "Clase de baile",
          duration: 30
        },
        Electroestimulación: {
          name: "Sesión de 30 minutos",
          duration: 30
        },
        "Entrenamiento Funcional": {
          name: "Clase Grupal",
          duration: 30
        },
        "Estilista Independiente": {
          name: "Corte de Cabello",
          duration: 30
        },
        Gimnasio: {
          name: "Entrenamiento Funcional",
          duration: 30
        },
        "Kinesiólogo / Fisioterapeuta": {
          name: "Consulta diagnóstico",
          duration: 30
        },
        Maquillaje: {
          name: "Maquillaje profesional",
          duration: 30
        },
        "Medicina Alternativa": {
          name: "Sesión de 30 minutos",
          duration: 30
        },
        Peluquería: {
          name: "Corte de Cabello",
          duration: 30
        },
        "Personal Trainer": {
          name: "Sesión de 30 minutos",
          duration: 30
        },
        Pilates: {
          name: "Clase de Pilates",
          duration: 30
        },
        Psicólogo: {
          name: "Sesión de 30 minutos",
          duration: 30
        },
        "Salón de Belleza": {
          name: "Corte de Cabello",
          duration: 30
        },
        "Salón de Manicure y Pedicure": {
          name: "Manicure Permanente",
          duration: 30
        },
        Spa: {
          name: "Masaje de Relajación",
          duration: 30
        },
        Veterinaria: {
          name: "Peluquería Para Perritos",
          duration: 30
        },
        "Yoga / Meditación": {
          name: "Meditación Guiada",
          duration: 30
        },
        Otro: {
          name: "Cita de 30 minutos",
          duration: 30
        }
      },
      attributes: {
        name: "El nombre de la compañía",
        serviceCategory: "La categoria del servicio",
        webAddress: "Sitio de reservas",
        startTime: "Hora de inicio"
      },
      districtMessages: {
        created: "Comuna creada exitosamente",
        updated: "Comuna actualizada exitosamente",
        withResidence: "Comuna de residencia",
        "new": "Nueva comuna",
        select: "Selecciona tu comuna",
        serviceAddressExclusive: "Si el servicio no pertenece a una sucursal exclusivamente a domicilio, recomendamos ingresar las comunas que se atienden en la descripción."
      },
      city: "Ciudad",
      cities: "Ciudades",
      identificationNumber: "RUT",
      taxesPrint: "I.V.A.",
      taxName: "IVA",
      taxNameReceipt: "IVA",
      region: "Region",
      timeZoneDefault: {
        timezone: "America/Santiago"
      },
      companyIndentificationNameBilling: "DNI o RFC",
      companyIndentificationClientNameBilling: "DNI o RFC",
      regions: "Estados"
    },
    defaultSeparator: ",",
    defaultDelimiter: ".",
    defaultUnit: "$",
    defaultPrecision: 0,
    locale: "esCL",
    validQuickAdd: true,
    redirectUrl: "/",
    notice: "",
    roles: [{
      id: 5,
      name: "Usuario Registrado",
      description: "Usuario con cuenta registrada y accesible",
      createdAt: "2014-03-19T14:27:33.200Z",
      updatedAt: "2014-03-19T14:27:33.200Z",
      internalName: null
    }, {
      id: 6,
      name: "Usuario No Registrado",
      description: "Usuario con cuenta no registrada",
      createdAt: "2014-03-19T14:27:33.203Z",
      updatedAt: "2014-03-19T14:27:33.203Z",
      internalName: null
    }, {
      id: 2,
      name: "Administrador General",
      description: "Administrador de empresa inscrita en AgendaPro",
      createdAt: "2014-03-19T14:27:33.193Z",
      updatedAt: "2020-03-16T18:49:02.118Z",
      internalName: "generalAdmin"
    }, {
      id: 3,
      name: "Administrador Local",
      description: "Administrador de local",
      createdAt: "2014-03-19T14:27:33.195Z",
      updatedAt: "2020-03-16T18:49:02.139Z",
      internalName: "localAdmin"
    }, {
      id: 11,
      name: "Bodeguero",
      description: "Rol que puede ver y editar inventario",
      createdAt: "2018-06-01T13:04:08.420Z",
      updatedAt: "2020-03-16T18:49:02.148Z",
      internalName: "warehouseKeeper"
    }, {
      id: 7,
      name: "Recepcionista",
      description: "Usuario frontdesk de una empresa",
      createdAt: "2014-03-19T14:27:33.206Z",
      updatedAt: "2020-03-16T18:49:02.160Z",
      internalName: "frontdesk"
    }, {
      id: 10,
      name: "Recepcionista (sin edición)",
      description: "Rol que puede ver y editar fichas de usuario pero no agendar.",
      createdAt: "2016-09-01T05:31:35.397Z",
      updatedAt: "2020-03-16T18:49:02.170Z",
      internalName: "frontdeskWithoutEdition"
    }, {
      id: 4,
      name: "Staff",
      description: "Usuario con atribuciones de atención en su local",
      createdAt: "2014-03-19T14:27:33.197Z",
      updatedAt: "2020-03-16T18:49:02.179Z",
      internalName: "staff"
    }, {
      id: 8,
      name: "Staff (sin edición)",
      description: "Usuario que no puede editar reservas.",
      createdAt: "2014-11-17T20:12:35.279Z",
      updatedAt: "2020-03-16T18:49:02.190Z",
      internalName: "staffWithoutEdition"
    }, {
      id: 1,
      name: "Super Admin",
      description: "Administrador de la aplicaión AgendaPro",
      createdAt: "2014-03-19T14:27:33.188Z",
      updatedAt: "2020-05-16T00:22:14.479Z",
      internalName: "superAdmin"
    }, {
      id: 9,
      name: "Ventas",
      description: "Rol Ejecutivo Comercial AgendaPro",
      createdAt: "2015-10-05T21:00:27.676Z",
      updatedAt: "2020-05-21T18:27:15.193Z",
      internalName: "sales"
    }],
    countryCode: "cl",
    userHash: "69a72031c1a10d17b3138585653c84b31e3d25d463a0d3dfb3b9f9d99934d59b",
    user: {
      id: 2087,
      firstName: "Team",
      lastName: "Arquitectura",
      phone: "56982897145",
      roleId: 2,
      companyId: 3,
      createdAt: "2022-02-16T13:16:28.506Z",
      updatedAt: "2022-05-02T02:15:49.602Z",
      email: "nicolas+taag@agendapro.com",
      provider: null,
      uid: null,
      receivesOffers: true,
      mobileToken: null,
      apiToken: "xSc1u0i67+BLBvjkcnDan0On+Fm8iaSVJpmdwAqeb5M=",
      authenticationToken: null,
      refreshToken: null,
      passwordResetToken: null,
      passwordResetSentAt: null,
      franchiseAdmin: false,
      verifiedAccount: false,
      identificationNumber: "",
      hubspotToken: null,
      pushConfigCompleted: null,
      providerCode: "nicolas+taag@agendapro.com",
      signImage: "",
      pinCode: "123",
      pinCodeActive: true,
      active: true,
      referralCode: null,
      customFields: {}
    },
    isCustomerSuccessActive: true,
    dateIso8601: "2022-02-16T13:16:26Z",
    country: {
      id: 1,
      name: "Chile",
      createdAt: "2014-03-19T14:27:33.029Z",
      updatedAt: "2022-04-12T13:59:12.605Z",
      locale: "esCL",
      flagPhoto: {
        url: "https://d11c964iapbjc0.cloudfront.net/uploads/countries/countryE2676a17139ec7ba.png"
      },
      currencyCode: "CLP",
      latitude: -33.4052419,
      longitude: -70.597557,
      formattedAddress: "Santiago, Región Metropolitana, Chile",
      domain: ".cl",
      salesTax: 0.19,
      timezoneName: "CLT",
      timezoneOffset: -4.0,
      paymentSystem: "puntoPagos",
      paymentSystemCurrencyCode: "CLP",
      paymentSystemUser: "558490",
      paymentSystemAccount: "560923",
      paymentSystemApiKey: "lcYvfI1vUATdee2D70HJLbh8Xp",
      publicSalesTax: 0.19,
      countryCode: "cl",
      currencyEquivalence: 1.0,
      providerSubscriptionMethod: "kushki",
      providerPaymentMethod: "pagoFacil",
      minOnlineDownPaymentAmount: 5000.0
    },
    paymentStatus: {
      id: 1,
      name: "Activo",
      description: "La empresa tiene todos los pagos al día",
      createdAt: "2014-03-19T14:27:32.931Z",
      updatedAt: "2014-08-01T20:54:30.029Z"
    },
    plan: {
      id: 3,
      name: "Normal",
      locations: 2,
      serviceProviders: 60,
      custom: true,
      createdAt: "2014-03-19T14:27:33.165Z",
      updatedAt: "2017-01-23T20:15:42.187Z",
      special: false,
      monthlyMails: 10000,
      internalName: "pro"
    },
    statsCompany: {
      id: 1448,
      companyId: 3,
      companyName: "Negocio de Team Arquitectura",
      companyStart: "2022-02-16T13:16:26.379Z",
      lastBooking: "2022-04-12T18:53:50.942Z",
      weekBookings: 0,
      pastWeekBookings: 0,
      webBookings: 0.0,
      createdAt: "2022-02-16T13:16:26.680Z",
      updatedAt: "2022-04-27T08:00:24.266Z",
      lastPayment: null,
      lastPaymentMethod: "0 ",
      companyPaymentStatusId: 1,
      companySalesUserId: null,
      weekWebBookings: 0,
      pastWeekWebBookings: 0,
      weekProviders: 0,
      pastWeekProviders: 0,
      weekPayments: 0,
      pastWeekPayments: 0,
      totalBookingsCount: 73,
      totalWebBookingsCount: 0,
      totalPaymentsCount: 16,
      totalPaymentMembershipsCount: 1,
      totalProductsCount: 2,
      totalProvidersCount: 3,
      totalServicesCount: 5,
      totalLocationsCount: 2,
      totalClientsCount: 9,
      twoWeekOccupation: 0.0,
      twoWeekFutureOccupation: 0.0,
      firstTwentyDaysBookingsCount: 28,
      firstTwentyDaysProvidersCount: 1,
      firstTwentyDaysPaymentsCount: 2,
      sellerEmail: "",
      weekNewClients: 0,
      pastWeekNewClients: 0,
      monthlySpend: 159800.0,
      businessType: "Otro",
      businessCategory: "Salud",
      monthlySpendEquivalence: 0.0,
      endDate: null,
      addonWhatsapp: true,
      addonSms: true,
      addonOnlinePayment: false,
      addonAgendaboost: false,
      userLoginsAtFirstSevenDays: null,
      isTimeEditAtFirstSevenDays: false,
      logoLoadAt: null,
      bookingCountFirstThreedays: 0,
      bookingCountFirstSevendays: 0,
      webBookingCountFirstThreedays: 0,
      webBookingCountFirstSevendays: 0,
      serviceCountFirstSevenDays: 1,
      changeLocation: true,
      daysToFirstBooking: 14
    },
    role: {
      id: 2,
      name: "Administrador General",
      description: "Administrador de empresa inscrita en AgendaPro",
      createdAt: "2014-03-19T14:27:33.193Z",
      updatedAt: "2020-03-16T18:49:02.118Z",
      internalName: "generalAdmin"
    },
    trueUser: {
      id: 2087,
      firstName: "Team",
      lastName: "Arquitectura",
      phone: "56982897145",
      roleId: 2,
      companyId: 3,
      createdAt: "2022-02-16T13:16:28.506Z",
      updatedAt: "2022-05-02T02:15:49.602Z",
      email: "nicolas+taag@agendapro.com",
      provider: null,
      uid: null,
      receivesOffers: true,
      mobileToken: null,
      apiToken: "xSc1u0i67+BLBvjkcnDan0On+Fm8iaSVJpmdwAqeb5M=",
      authenticationToken: null,
      refreshToken: null,
      passwordResetToken: null,
      passwordResetSentAt: null,
      franchiseAdmin: false,
      verifiedAccount: false,
      identificationNumber: "",
      hubspotToken: null,
      pushConfigCompleted: null,
      providerCode: "nicolas+taag@agendapro.com",
      signImage: "",
      pinCode: "",
      pinCodeActive: false,
      active: true,
      referralCode: null,
      customFields: {}
    },
    rips: false,
    invoiceActive: false,
    invoiceUser: null,
    invoiceToken: null,
    invoiceRut: null,
    invoiceName: null,
    invoiceDefaultTaxLevelCode: null,
    canEditRole: true,
    canEditPrice: true,
    typeOfPrint: 0,
    urlIframe: "https://agendaprodev.com/iframe/overview/eHo0SXhXRFRsZVV0bGYwQXYwdm5JZz09LS04dzRJa2xHajRrTXYxaWJ5cGJ0U2x3PT0=--d9093e86018d22764b1de951d0b8377db63d340f",
    urlMinisite: "https://negociodeteamarquitectura.agendaprodev.com/cl",
    agendaproCode: "8mdmec",
    apiUser: "t4ptr76",
    apiPassword: "42ya53mprlfzgva5u677rpc98rynwqwh6wgmwhni8hwa",
    intervalTimeSurvey: [["Inmediatamente", 0], ["1 hora después", 1], ["2 horas después", 2], ["3 horas después", 3], ["4 horas después", 4], ["5 horas después", 5]],
    datatypes: [["Numérico", "integer"], ["Decimal", "float"], ["Texto", "text"], ["Área de texto", "textarea"], ["Binario (Sí/No)", "boolean"], ["Fecha", "date"], ["Fecha y hora", "datetime"], ["Categórico", "categoric"], ["Archivo", "file"], ["Selección Múltiple", "multiple"]],
    rangeTypes: [["equals", "Igual a"], ["greater", "Mayor que"], ["greaterEqual", "Mayor o igual que"], ["lower", "Menor que"], ["lowerEqual", "Menor o igual que"], ["between", "Entre"], ["out", "Fuera de"]],
    chartPrintSize: [["Carta", "letter"], ["Media Carta", "halfletter"]],
    chartPrintType: [["Completo", "complete"], ["Simplificado", "simple"]],
    colorLight: "fd6767",
    colorMedium: "fd9610",
    colorNormal: null,
    activateCustomColor: false,
    clientsModulesAvailable: true,
    extraClientsModulesAvailable: false,
    publicApiAvailable: false,
    companyPlanSetting: {
      id: 1513,
      companyId: 3,
      basePrice: 79900.0,
      locationsMultiplier: 1.0,
      createdAt: "2022-02-16T13:16:26.574Z",
      updatedAt: "2022-03-02T18:54:27.052Z",
      discount: 0.0,
      discountType: 0,
      listBasePrice: 79900.0
    },
    addonsAllowed: true,
    giftcardModuleAllowed: false,
    pendoData: {
      visitor: {
        id: "2087",
        email: "nicolas+taag@agendapro.com",
        fullName: "Team Arquitectura",
        role: "Administrador General",
        firstName: "Team",
        lastName: "Arquitectura"
      },
      account: {
        id: "3",
        name: "Negocio de Team Arquitectura",
        employeeNumber: "6-15",
        businessType: "Otro",
        businessCategory: "Salud",
        country: "Chile"
      }
    },
    permissions: [{
      action: ["createCompleteSubscriptionQvoPublic"],
      subject: ["Company"],
      conditions: {
        companyId: {
          id: 3,
          name: "Negocio de Team Arquitectura",
          webAddress: "negociodeteamarquitectura",
          logo: {
            url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png",
            email: {
              url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png"
            },
            thumb: {
              url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png"
            },
            page: {
              url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png"
            }
          },
          monthsActiveLeft: 0.0,
          planId: 3,
          paymentStatusId: 1,
          createdAt: "2022-02-16T13:16:26.379Z",
          updatedAt: "2022-04-07T03:27:37.315Z",
          description: "",
          cancellationPolicy: "",
          dueAmount: 0.0,
          dueDate: null,
          owned: true,
          showInHome: false,
          countryId: 1,
          activateI18n: false,
          salesUserId: null,
          trialMonthsLeft: 0,
          defaultPlanId: 9,
          secretKey: "42ya53mprlfzgva5u677rpc98rynwqwh6wgmwhni8hwa",
          endTrial: true,
          endDate: "2022-04-07",
          generateBilling: true,
          billingPlatformId: "",
          billingDay: 23,
          currentBillingDate: "2022-02-23",
          currentBillingValue: 0.0,
          currentBillingLocation: 1,
          employeeNumber: "6-15",
          initDate: "2022-02-16T13:16:35.021Z",
          creationDeviceType: "desktop"
        }
      }
    }, {
      action: ["cardInscriptionPublicReturn"],
      subject: ["Company"],
      conditions: {
        companyId: {
          id: 3,
          name: "Negocio de Team Arquitectura",
          webAddress: "negociodeteamarquitectura",
          logo: {
            url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png",
            email: {
              url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png"
            },
            thumb: {
              url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png"
            },
            page: {
              url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png"
            }
          },
          monthsActiveLeft: 0.0,
          planId: 3,
          paymentStatusId: 1,
          createdAt: "2022-02-16T13:16:26.379Z",
          updatedAt: "2022-04-07T03:27:37.315Z",
          description: "",
          cancellationPolicy: "",
          dueAmount: 0.0,
          dueDate: null,
          owned: true,
          showInHome: false,
          countryId: 1,
          activateI18n: false,
          salesUserId: null,
          trialMonthsLeft: 0,
          defaultPlanId: 9,
          secretKey: "42ya53mprlfzgva5u677rpc98rynwqwh6wgmwhni8hwa",
          endTrial: true,
          endDate: "2022-04-07",
          generateBilling: true,
          billingPlatformId: "",
          billingDay: 23,
          currentBillingDate: "2022-02-23",
          currentBillingValue: 0.0,
          currentBillingLocation: 1,
          employeeNumber: "6-15",
          initDate: "2022-02-16T13:16:35.021Z",
          creationDeviceType: "desktop"
        }
      }
    }, {
      action: ["new"],
      subject: ["all"]
    }, {
      action: ["read"],
      subject: ["User"],
      conditions: {
        id: 2087
      }
    }, {
      action: ["update"],
      subject: ["User"],
      conditions: {
        id: 2087
      }
    }, {
      action: ["destroy"],
      subject: ["User"],
      conditions: {
        id: 2087
      }
    }, {
      action: ["signOutReact"],
      subject: ["User"]
    }, {
      action: ["scheduleLocal"],
      subject: ["LocationTime"]
    }, {
      action: ["viewPlans"],
      subject: ["Plan"]
    }, {
      action: ["payPlan"],
      subject: ["all"]
    }, {
      action: ["publicBillingInfo"],
      subject: ["all"]
    }, {
      action: ["registrationData"],
      subject: ["all"]
    }, {
      action: ["translationsData"],
      subject: ["all"]
    }, {
      action: ["pagoFacilDetail"],
      subject: ["Payment"]
    }, {
      action: ["epaycoDetail"],
      subject: ["Payment"]
    }, {
      action: ["payDlocal"],
      subject: ["Payment"]
    }, {
      action: ["dlocalPaymentDetail"],
      subject: ["Payment"]
    }, {
      action: ["dlocalDetail"],
      subject: ["Payment"]
    }, {
      action: ["overview"],
      subject: ["Company"]
    }, {
      action: ["intercomData"],
      subject: ["Booking"]
    }, {
      action: ["workflow"],
      subject: ["Company"]
    }, {
      action: ["postPayIframe"],
      subject: ["Company"]
    }, {
      action: ["locationData"],
      subject: ["Location"]
    }, {
      action: ["locationDistricts"],
      subject: ["Location"]
    }, {
      action: ["serviceData"],
      subject: ["Service"]
    }, {
      action: ["servicesData"],
      subject: ["Service"]
    }, {
      action: ["getProviders"],
      subject: ["Service"]
    }, {
      action: ["providerBooking"],
      subject: ["Booking"]
    }, {
      action: ["bookService"],
      subject: ["Booking"]
    }, {
      action: ["locationServices"],
      subject: ["Service"]
    }, {
      action: ["locationCategories"],
      subject: ["ServiceCategory"]
    }, {
      action: ["categoryServices"],
      subject: ["ServiceCategory"]
    }, {
      action: ["locationCategorizedServices"],
      subject: ["Service"]
    }, {
      action: ["locationProviders"],
      subject: ["ServiceProvider"]
    }, {
      action: ["providerTime"],
      subject: ["ServiceProvider"]
    }, {
      action: ["locationTime"],
      subject: ["Location"]
    }, {
      action: ["getAvailableTime"],
      subject: ["Location"]
    }, {
      action: ["companyServiceCategories"],
      subject: ["ServiceCategory"]
    }, {
      action: ["checkUserCrossBookings"],
      subject: ["Booking"]
    }, {
      action: ["selectHour"],
      subject: ["Company"]
    }, {
      action: ["selectPromoHour"],
      subject: ["Company"]
    }, {
      action: ["selectSessionHour"],
      subject: ["Company"]
    }, {
      action: ["userData"],
      subject: ["Company"]
    }, {
      action: ["mobileHours"],
      subject: ["Company"]
    }, {
      action: ["clientLoader"],
      subject: ["Client"]
    }, {
      action: ["getChartFields"],
      subject: ["Client"]
    }, {
      action: ["availableHoursWeekHtml"],
      subject: ["ServiceProvider"]
    }, {
      action: ["editBooking"],
      subject: ["Booking"]
    }, {
      action: ["editBookingPost"],
      subject: ["Booking"]
    }, {
      action: ["cancelBooking"],
      subject: ["Booking"]
    }, {
      action: ["confirmBooking"],
      subject: ["Booking"]
    }, {
      action: ["confirmAllBookings"],
      subject: ["Booking"]
    }, {
      action: ["confirmError"],
      subject: ["Booking"]
    }, {
      action: ["confirmSuccess"],
      subject: ["Booking"]
    }, {
      action: ["getDistricts"],
      subject: ["District"]
    }, {
      action: ["getInputDistricts"],
      subject: ["District"]
    }, {
      action: ["getDistrict"],
      subject: ["District"]
    }, {
      action: ["getDistrictByName"],
      subject: ["District"]
    }, {
      action: ["getDirection"],
      subject: ["District"]
    }, {
      action: ["agenda"],
      subject: ["User"],
      conditions: {
        id: 2087
      }
    }, {
      action: ["getSessionBookings"],
      subject: ["User"]
    }, {
      action: ["getSessionSummary"],
      subject: ["User"]
    }, {
      action: ["validateSessionBooking"],
      subject: ["Booking"]
    }, {
      action: ["validateSessionForm"],
      subject: ["Booking"]
    }, {
      action: ["sessionBookingDetail"],
      subject: ["Booking"]
    }, {
      action: ["bookSessionForm"],
      subject: ["Booking"]
    }, {
      action: ["updateBookSession"],
      subject: ["Booking"]
    }, {
      action: ["sessionsCalendar"],
      subject: ["Booking"]
    }, {
      action: ["pdf"],
      subject: ["ServiceProvider"]
    }, {
      action: ["defaultTime"],
      subject: ["ServiceProvider"]
    }, {
      action: ["checkUserEmail"],
      subject: ["User"]
    }, {
      action: ["registrationData"],
      subject: ["User"]
    }, {
      action: ["getUser"],
      subject: ["User"]
    }, {
      action: ["checkCompanyWebAddress"],
      subject: ["Company"]
    }, {
      action: ["getPromotionsPopover"],
      subject: ["Service"]
    }, {
      action: ["promotionHours"],
      subject: ["Booking"]
    }, {
      action: ["availableHours"],
      subject: ["Booking"]
    }, {
      action: ["showTimePromo"],
      subject: ["Service"]
    }, {
      action: ["showLastMinutePromo"],
      subject: ["Service"]
    }, {
      action: ["lastMinuteHours"],
      subject: ["Service"]
    }, {
      action: ["showTreatmentPromo"],
      subject: ["Service"]
    }, {
      action: ["treatmentPromoHours"],
      subject: ["Service"]
    }, {
      action: ["getTreatmentPrice"],
      subject: ["Booking"]
    }, {
      action: ["isOpen"],
      subject: ["Location"]
    }, {
      action: ["isOpen"],
      subject: ["ServiceProvider"]
    }, {
      action: ["getServiceTimes"],
      subject: ["Booking"]
    }, {
      action: ["getIsVideo"],
      subject: ["Service"]
    }, {
      action: ["savePublicPageBillingWireTransfer"],
      subject: ["Plan"]
    }, {
      action: ["stopImpersonating"],
      subject: ["User"]
    }, {
      action: ["deleteCompleteSubscription"],
      subject: ["Company"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["userOptions"],
      subject: ["User"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["modulesPerRole"],
      subject: ["User"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["index"],
      subject: ["User"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["create"],
      subject: ["User"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["show"],
      subject: ["User"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["destroy"],
      subject: ["User"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["update"],
      subject: ["User"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["commission"],
      subject: ["Product"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["importPlans"],
      subject: ["Company"],
      conditions: {
        companyId: {
          id: 3,
          name: "Negocio de Team Arquitectura",
          webAddress: "negociodeteamarquitectura",
          logo: {
            url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png",
            email: {
              url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png"
            },
            thumb: {
              url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png"
            },
            page: {
              url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png"
            }
          },
          monthsActiveLeft: 0.0,
          planId: 3,
          paymentStatusId: 1,
          createdAt: "2022-02-16T13:16:26.379Z",
          updatedAt: "2022-04-07T03:27:37.315Z",
          description: "",
          cancellationPolicy: "",
          dueAmount: 0.0,
          dueDate: null,
          owned: true,
          showInHome: false,
          countryId: 1,
          activateI18n: false,
          salesUserId: null,
          trialMonthsLeft: 0,
          defaultPlanId: 9,
          secretKey: "42ya53mprlfzgva5u677rpc98rynwqwh6wgmwhni8hwa",
          endTrial: true,
          endDate: "2022-04-07",
          generateBilling: true,
          billingPlatformId: "",
          billingDay: 23,
          currentBillingDate: "2022-02-23",
          currentBillingValue: 0.0,
          currentBillingLocation: 1,
          employeeNumber: "6-15",
          initDate: "2022-02-16T13:16:35.021Z",
          creationDeviceType: "desktop"
        }
      }
    }, {
      action: ["registerSuscriptionQvo"],
      subject: ["Company"],
      conditions: {
        companyId: {
          id: 3,
          name: "Negocio de Team Arquitectura",
          webAddress: "negociodeteamarquitectura",
          logo: {
            url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png",
            email: {
              url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png"
            },
            thumb: {
              url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png"
            },
            page: {
              url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png"
            }
          },
          monthsActiveLeft: 0.0,
          planId: 3,
          paymentStatusId: 1,
          createdAt: "2022-02-16T13:16:26.379Z",
          updatedAt: "2022-04-07T03:27:37.315Z",
          description: "",
          cancellationPolicy: "",
          dueAmount: 0.0,
          dueDate: null,
          owned: true,
          showInHome: false,
          countryId: 1,
          activateI18n: false,
          salesUserId: null,
          trialMonthsLeft: 0,
          defaultPlanId: 9,
          secretKey: "42ya53mprlfzgva5u677rpc98rynwqwh6wgmwhni8hwa",
          endTrial: true,
          endDate: "2022-04-07",
          generateBilling: true,
          billingPlatformId: "",
          billingDay: 23,
          currentBillingDate: "2022-02-23",
          currentBillingValue: 0.0,
          currentBillingLocation: 1,
          employeeNumber: "6-15",
          initDate: "2022-02-16T13:16:35.021Z",
          creationDeviceType: "desktop"
        }
      }
    }, {
      action: ["subscribeCustomerToPlan"],
      subject: ["Company"],
      conditions: {
        companyId: {
          id: 3,
          name: "Negocio de Team Arquitectura",
          webAddress: "negociodeteamarquitectura",
          logo: {
            url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png",
            email: {
              url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png"
            },
            thumb: {
              url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png"
            },
            page: {
              url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png"
            }
          },
          monthsActiveLeft: 0.0,
          planId: 3,
          paymentStatusId: 1,
          createdAt: "2022-02-16T13:16:26.379Z",
          updatedAt: "2022-04-07T03:27:37.315Z",
          description: "",
          cancellationPolicy: "",
          dueAmount: 0.0,
          dueDate: null,
          owned: true,
          showInHome: false,
          countryId: 1,
          activateI18n: false,
          salesUserId: null,
          trialMonthsLeft: 0,
          defaultPlanId: 9,
          secretKey: "42ya53mprlfzgva5u677rpc98rynwqwh6wgmwhni8hwa",
          endTrial: true,
          endDate: "2022-04-07",
          generateBilling: true,
          billingPlatformId: "",
          billingDay: 23,
          currentBillingDate: "2022-02-23",
          currentBillingValue: 0.0,
          currentBillingLocation: 1,
          employeeNumber: "6-15",
          initDate: "2022-02-16T13:16:35.021Z",
          creationDeviceType: "desktop"
        }
      }
    }, {
      action: ["getQvoClient"],
      subject: ["Company"],
      conditions: {
        companyId: {
          id: 3,
          name: "Negocio de Team Arquitectura",
          webAddress: "negociodeteamarquitectura",
          logo: {
            url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png",
            email: {
              url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png"
            },
            thumb: {
              url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png"
            },
            page: {
              url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png"
            }
          },
          monthsActiveLeft: 0.0,
          planId: 3,
          paymentStatusId: 1,
          createdAt: "2022-02-16T13:16:26.379Z",
          updatedAt: "2022-04-07T03:27:37.315Z",
          description: "",
          cancellationPolicy: "",
          dueAmount: 0.0,
          dueDate: null,
          owned: true,
          showInHome: false,
          countryId: 1,
          activateI18n: false,
          salesUserId: null,
          trialMonthsLeft: 0,
          defaultPlanId: 9,
          secretKey: "42ya53mprlfzgva5u677rpc98rynwqwh6wgmwhni8hwa",
          endTrial: true,
          endDate: "2022-04-07",
          generateBilling: true,
          billingPlatformId: "",
          billingDay: 23,
          currentBillingDate: "2022-02-23",
          currentBillingValue: 0.0,
          currentBillingLocation: 1,
          employeeNumber: "6-15",
          initDate: "2022-02-16T13:16:35.021Z",
          creationDeviceType: "desktop"
        }
      }
    }, {
      action: ["cardInscriptionReturn"],
      subject: ["Company"],
      conditions: {
        companyId: {
          id: 3,
          name: "Negocio de Team Arquitectura",
          webAddress: "negociodeteamarquitectura",
          logo: {
            url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png",
            email: {
              url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png"
            },
            thumb: {
              url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png"
            },
            page: {
              url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png"
            }
          },
          monthsActiveLeft: 0.0,
          planId: 3,
          paymentStatusId: 1,
          createdAt: "2022-02-16T13:16:26.379Z",
          updatedAt: "2022-04-07T03:27:37.315Z",
          description: "",
          cancellationPolicy: "",
          dueAmount: 0.0,
          dueDate: null,
          owned: true,
          showInHome: false,
          countryId: 1,
          activateI18n: false,
          salesUserId: null,
          trialMonthsLeft: 0,
          defaultPlanId: 9,
          secretKey: "42ya53mprlfzgva5u677rpc98rynwqwh6wgmwhni8hwa",
          endTrial: true,
          endDate: "2022-04-07",
          generateBilling: true,
          billingPlatformId: "",
          billingDay: 23,
          currentBillingDate: "2022-02-23",
          currentBillingValue: 0.0,
          currentBillingLocation: 1,
          employeeNumber: "6-15",
          initDate: "2022-02-16T13:16:35.021Z",
          creationDeviceType: "desktop"
        }
      }
    }, {
      action: ["checkCardInscription"],
      subject: ["Company"],
      conditions: {
        companyId: {
          id: 3,
          name: "Negocio de Team Arquitectura",
          webAddress: "negociodeteamarquitectura",
          logo: {
            url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png",
            email: {
              url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png"
            },
            thumb: {
              url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png"
            },
            page: {
              url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png"
            }
          },
          monthsActiveLeft: 0.0,
          planId: 3,
          paymentStatusId: 1,
          createdAt: "2022-02-16T13:16:26.379Z",
          updatedAt: "2022-04-07T03:27:37.315Z",
          description: "",
          cancellationPolicy: "",
          dueAmount: 0.0,
          dueDate: null,
          owned: true,
          showInHome: false,
          countryId: 1,
          activateI18n: false,
          salesUserId: null,
          trialMonthsLeft: 0,
          defaultPlanId: 9,
          secretKey: "42ya53mprlfzgva5u677rpc98rynwqwh6wgmwhni8hwa",
          endTrial: true,
          endDate: "2022-04-07",
          generateBilling: true,
          billingPlatformId: "",
          billingDay: 23,
          currentBillingDate: "2022-02-23",
          currentBillingValue: 0.0,
          currentBillingLocation: 1,
          employeeNumber: "6-15",
          initDate: "2022-02-16T13:16:35.021Z",
          creationDeviceType: "desktop"
        }
      }
    }, {
      action: ["createCustomer"],
      subject: ["Company"],
      conditions: {
        companyId: {
          id: 3,
          name: "Negocio de Team Arquitectura",
          webAddress: "negociodeteamarquitectura",
          logo: {
            url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png",
            email: {
              url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png"
            },
            thumb: {
              url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png"
            },
            page: {
              url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png"
            }
          },
          monthsActiveLeft: 0.0,
          planId: 3,
          paymentStatusId: 1,
          createdAt: "2022-02-16T13:16:26.379Z",
          updatedAt: "2022-04-07T03:27:37.315Z",
          description: "",
          cancellationPolicy: "",
          dueAmount: 0.0,
          dueDate: null,
          owned: true,
          showInHome: false,
          countryId: 1,
          activateI18n: false,
          salesUserId: null,
          trialMonthsLeft: 0,
          defaultPlanId: 9,
          secretKey: "42ya53mprlfzgva5u677rpc98rynwqwh6wgmwhni8hwa",
          endTrial: true,
          endDate: "2022-04-07",
          generateBilling: true,
          billingPlatformId: "",
          billingDay: 23,
          currentBillingDate: "2022-02-23",
          currentBillingValue: 0.0,
          currentBillingLocation: 1,
          employeeNumber: "6-15",
          initDate: "2022-02-16T13:16:35.021Z",
          creationDeviceType: "desktop"
        }
      }
    }, {
      action: ["createPlan"],
      subject: ["Company"],
      conditions: {
        companyId: {
          id: 3,
          name: "Negocio de Team Arquitectura",
          webAddress: "negociodeteamarquitectura",
          logo: {
            url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png",
            email: {
              url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png"
            },
            thumb: {
              url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png"
            },
            page: {
              url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png"
            }
          },
          monthsActiveLeft: 0.0,
          planId: 3,
          paymentStatusId: 1,
          createdAt: "2022-02-16T13:16:26.379Z",
          updatedAt: "2022-04-07T03:27:37.315Z",
          description: "",
          cancellationPolicy: "",
          dueAmount: 0.0,
          dueDate: null,
          owned: true,
          showInHome: false,
          countryId: 1,
          activateI18n: false,
          salesUserId: null,
          trialMonthsLeft: 0,
          defaultPlanId: 9,
          secretKey: "42ya53mprlfzgva5u677rpc98rynwqwh6wgmwhni8hwa",
          endTrial: true,
          endDate: "2022-04-07",
          generateBilling: true,
          billingPlatformId: "",
          billingDay: 23,
          currentBillingDate: "2022-02-23",
          currentBillingValue: 0.0,
          currentBillingLocation: 1,
          employeeNumber: "6-15",
          initDate: "2022-02-16T13:16:35.021Z",
          creationDeviceType: "desktop"
        }
      }
    }, {
      action: ["initCardInscription"],
      subject: ["Company"],
      conditions: {
        companyId: {
          id: 3,
          name: "Negocio de Team Arquitectura",
          webAddress: "negociodeteamarquitectura",
          logo: {
            url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png",
            email: {
              url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png"
            },
            thumb: {
              url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png"
            },
            page: {
              url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png"
            }
          },
          monthsActiveLeft: 0.0,
          planId: 3,
          paymentStatusId: 1,
          createdAt: "2022-02-16T13:16:26.379Z",
          updatedAt: "2022-04-07T03:27:37.315Z",
          description: "",
          cancellationPolicy: "",
          dueAmount: 0.0,
          dueDate: null,
          owned: true,
          showInHome: false,
          countryId: 1,
          activateI18n: false,
          salesUserId: null,
          trialMonthsLeft: 0,
          defaultPlanId: 9,
          secretKey: "42ya53mprlfzgva5u677rpc98rynwqwh6wgmwhni8hwa",
          endTrial: true,
          endDate: "2022-04-07",
          generateBilling: true,
          billingPlatformId: "",
          billingDay: 23,
          currentBillingDate: "2022-02-23",
          currentBillingValue: 0.0,
          currentBillingLocation: 1,
          employeeNumber: "6-15",
          initDate: "2022-02-16T13:16:35.021Z",
          creationDeviceType: "desktop"
        }
      }
    }, {
      action: ["editSubscription"],
      subject: ["Company"],
      conditions: {
        companyId: {
          id: 3,
          name: "Negocio de Team Arquitectura",
          webAddress: "negociodeteamarquitectura",
          logo: {
            url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png",
            email: {
              url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png"
            },
            thumb: {
              url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png"
            },
            page: {
              url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png"
            }
          },
          monthsActiveLeft: 0.0,
          planId: 3,
          paymentStatusId: 1,
          createdAt: "2022-02-16T13:16:26.379Z",
          updatedAt: "2022-04-07T03:27:37.315Z",
          description: "",
          cancellationPolicy: "",
          dueAmount: 0.0,
          dueDate: null,
          owned: true,
          showInHome: false,
          countryId: 1,
          activateI18n: false,
          salesUserId: null,
          trialMonthsLeft: 0,
          defaultPlanId: 9,
          secretKey: "42ya53mprlfzgva5u677rpc98rynwqwh6wgmwhni8hwa",
          endTrial: true,
          endDate: "2022-04-07",
          generateBilling: true,
          billingPlatformId: "",
          billingDay: 23,
          currentBillingDate: "2022-02-23",
          currentBillingValue: 0.0,
          currentBillingLocation: 1,
          employeeNumber: "6-15",
          initDate: "2022-02-16T13:16:35.021Z",
          creationDeviceType: "desktop"
        }
      }
    }, {
      action: ["registerSuscriptionPayu"],
      subject: ["Company"],
      conditions: {
        companyId: {
          id: 3,
          name: "Negocio de Team Arquitectura",
          webAddress: "negociodeteamarquitectura",
          logo: {
            url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png",
            email: {
              url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png"
            },
            thumb: {
              url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png"
            },
            page: {
              url: "https://d11c964iapbjc0.cloudfront.net/assets/logoVacioNew-6aa8dfd190ad63ab2acc8062432b7efb2fa748701447dd87c9fae9ade8f8744d.png"
            }
          },
          monthsActiveLeft: 0.0,
          planId: 3,
          paymentStatusId: 1,
          createdAt: "2022-02-16T13:16:26.379Z",
          updatedAt: "2022-04-07T03:27:37.315Z",
          description: "",
          cancellationPolicy: "",
          dueAmount: 0.0,
          dueDate: null,
          owned: true,
          showInHome: false,
          countryId: 1,
          activateI18n: false,
          salesUserId: null,
          trialMonthsLeft: 0,
          defaultPlanId: 9,
          secretKey: "42ya53mprlfzgva5u677rpc98rynwqwh6wgmwhni8hwa",
          endTrial: true,
          endDate: "2022-04-07",
          generateBilling: true,
          billingPlatformId: "",
          billingDay: 23,
          currentBillingDate: "2022-02-23",
          currentBillingValue: 0.0,
          currentBillingLocation: 1,
          employeeNumber: "6-15",
          initDate: "2022-02-16T13:16:35.021Z",
          creationDeviceType: "desktop"
        }
      }
    }, {
      action: ["activate"],
      subject: ["Product"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["deactivate"],
      subject: ["Product"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["createOpenDay"],
      subject: ["Location"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["updateOpenDay"],
      subject: ["Location"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["deleteOpenDay"],
      subject: ["Location"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["createOpenDay"],
      subject: ["ServiceProvider"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["updateOpenDay"],
      subject: ["ServiceProvider"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["deleteOpenDay"],
      subject: ["ServiceProvider"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["showOpenDay"],
      subject: ["ServiceProvider"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["showOpenDay"],
      subject: ["Location"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["classServices"],
      subject: ["Service"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["newClassService"],
      subject: ["Service"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["loadClassService"],
      subject: ["Service"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["editClassService"],
      subject: ["Service"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["inactiveClassServices"],
      subject: ["Service"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["newTimeResource"],
      subject: ["ServiceProvider"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["editTimeResource"],
      subject: ["ServiceProvider"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["updateTimeResource"],
      subject: ["ServiceProvider"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["availabilityProvider"],
      subject: ["ServiceProvider"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["timeResourcesDeactivate"],
      subject: ["ServiceProvider"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["inactiveResourceIndex"],
      subject: ["ServiceProvider"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["activateTimeResource"],
      subject: ["ServiceProvider"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["newMembership"],
      subject: ["Membership"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["editMembership"],
      subject: ["Membership"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["updateMembership"],
      subject: ["Membership"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["summary"],
      subject: ["Booking"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["chart"],
      subject: ["Booking"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["print"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["print"],
      subject: ["Chart"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["signChart"],
      subject: ["Chart"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["bookings"],
      subject: ["Chart"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["summary"],
      subject: ["Chart"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["read"],
      subject: ["Chart"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["destroy"],
      subject: ["Chart"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["create"],
      subject: ["Chart"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["update"],
      subject: ["Chart"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["editForm"],
      subject: ["Chart"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["merge"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["getCustomAttributes"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["payments"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["getPaymentsInfo"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["getDownPaymentInfo"],
      subject: ["DownPayment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["paymentsContent"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["summary"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["sendSurvey"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["surveys"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["surveysContent"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["emails"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["emailsContent"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["lastPayments"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["charts"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["chartsContent"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["chartsDownload"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["chartsEvolutionExcel"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["chartsEvolutionPdf"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["chartMasiveDownload"],
      subject: ["Chart"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["analyticsActivity"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["analyticsReport"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["generateClientsListDownloadLink"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["stockChange"],
      subject: ["Product"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["updateStock"],
      subject: ["Product"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["deleteTreatment"],
      subject: ["Booking"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["deleteClientTreatment"],
      subject: ["Booking"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["getEmailLogs"],
      subject: ["Booking"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["newFilterForm"],
      subject: ["CustomFilter"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["editFilterForm"],
      subject: ["CustomFilter"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["clientBasePdf"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["generateClientsChartsDownloadFile"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["selectDefaultPlan"],
      subject: ["Company"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["rearrange"],
      subject: ["CustomAttribute"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["rearrange"],
      subject: ["AttributeGroup"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["rearrange"],
      subject: ["ChartField"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["rearrange"],
      subject: ["ChartGroup"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["rearrange"],
      subject: ["ChartMasterGroup"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["selectPlan"],
      subject: ["Plan"]
    }, {
      action: ["upgradePlan"],
      subject: ["Plan"]
    }, {
      action: ["useEmailTemplates"],
      subject: ["Client"]
    }, {
      action: ["mailEditor"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["uploadContent"],
      subject: ["Client"]
    }, {
      action: ["saveContent"],
      subject: ["Client"]
    }, {
      action: ["sendContent"],
      subject: ["Client"]
    }, {
      action: ["getUniqueIdentificationNumber"],
      subject: ["Client"]
    }, {
      action: ["addCompany"],
      subject: ["Company"]
    }, {
      action: ["locationUsers"],
      subject: ["User"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["getUsers"],
      subject: ["User"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["myProfile"],
      subject: ["User"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["validatePin"],
      subject: ["User"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["getBooking"],
      subject: ["Booking"],
      conditions: {
        serviceProvider: {
          companyId: 3
        }
      }
    }, {
      action: ["getBookingInfo"],
      subject: ["Booking"],
      conditions: {
        serviceProvider: {
          companyId: 3
        }
      }
    }, {
      action: ["getBookingForPayment"],
      subject: ["Booking"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["getSessionBookingForPayment"],
      subject: ["Booking"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["getBundleBookingForPayment"],
      subject: ["Booking"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["availableProviders"],
      subject: ["ServiceProvider"]
    }, {
      action: ["read"],
      subject: ["ProviderBreak"]
    }, {
      action: ["create"],
      subject: ["ProviderBreak"]
    }, {
      action: ["update"],
      subject: ["ProviderBreak"]
    }, {
      action: ["destroy"],
      subject: ["ProviderBreak"]
    }, {
      action: ["read"],
      subject: ["Company"],
      conditions: {
        id: 3
      }
    }, {
      action: ["destroy"],
      subject: ["Company"],
      conditions: {
        id: 3
      }
    }, {
      action: ["create"],
      subject: ["Company"],
      conditions: {
        id: 3
      }
    }, {
      action: ["update"],
      subject: ["Company"],
      conditions: {
        id: 3
      }
    }, {
      action: ["show"],
      subject: ["ChartMasterGroup"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["create"],
      subject: ["ChartMasterGroup"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["update"],
      subject: ["ChartMasterGroup"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["destroy"],
      subject: ["ChartMasterGroup"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["editForm"],
      subject: ["ChartMasterGroup"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["locationsStatsExcel"],
      subject: ["Product"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["logsHistoryExcel"],
      subject: ["Product"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["logsHistory"],
      subject: ["Product"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["products"],
      subject: ["ProductCategory"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["history"],
      subject: ["Product"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["sellerHistory"],
      subject: ["Product"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["productHistory"],
      subject: ["Product"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["stats"],
      subject: ["Product"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["locationsStats"],
      subject: ["Product"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["locationProducts"],
      subject: ["Location"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["getStaffByCode"],
      subject: ["StaffCode"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["createNewPayment"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["alarmForm"],
      subject: ["Product"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["inventory"],
      subject: ["Location"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["setAlarm"],
      subject: ["Product"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["inventory"],
      subject: ["Company"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["stockAlarmForm"],
      subject: ["Company"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["stockAlarmForm"],
      subject: ["Location"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["saveStockAlarm"],
      subject: ["Location"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["sellers"],
      subject: ["Location"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["getByCode"],
      subject: ["Cashier"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["getByCode"],
      subject: ["EmployeeCode"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["checkStaffCode"],
      subject: ["EmployeeCode"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["show"],
      subject: ["Receipt"],
      conditions: {
        payment: {
          companyId: 3
        }
      }
    }, {
      action: ["show"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["show"],
      subject: ["DownPayment"],
      conditions: {
        payment: {
          companyId: 3
        }
      }
    }, {
      action: ["show"],
      subject: ["InternalSale"],
      conditions: {
        location: {
          companyId: 3
        }
      }
    }, {
      action: ["show"],
      subject: ["SalesCashIncome"],
      conditions: {
        location: {
          companyId: 3
        }
      }
    }, {
      action: ["show"],
      subject: ["SalesCashExpense"],
      conditions: {
        location: {
          companyId: 3
        }
      }
    }, {
      action: ["paymentPdf"],
      subject: ["Payment"]
    }, {
      action: ["quotePdf"],
      subject: ["Payment"]
    }, {
      action: ["receiptPdf"],
      subject: ["Payment"]
    }, {
      action: ["downPaymentPdf"],
      subject: ["Payment"]
    }, {
      action: ["internalSalePdf"],
      subject: ["Payment"]
    }, {
      action: ["salesCashIncomePdf"],
      subject: ["Payment"]
    }, {
      action: ["salesCashExpensePdf"],
      subject: ["Payment"]
    }, {
      action: ["sendReceiptsEmail"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["getReceipts"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["getIntroInfo"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["saveIntroInfo"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["updatePayment"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["checkBookingPayment"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["getFormattedBooking"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["deletePayment"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["saveIntroInfo"],
      subject: ["DownPayment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["getIntroInfo"],
      subject: ["DownPayment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["summary"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["internalSaleSummary"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["summary"],
      subject: ["DownPayment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["salesCashRectificationSummary"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["salesCashTransactionSummary"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["salesCashIncomeSummary"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["salesCashExpenseSummary"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["commissions"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["providerCommissions"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["serviceCommissions"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["setCommissions"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["setDefaultCommission"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["setProviderDefaultCommissions"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["commissionsContent"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["pettyCash"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["pettyTransactions"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["pettyTransaction"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["addPettyTransaction"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["openClosePettyCash"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["deletePettyTransaction"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["setPettyCashCloseSchedule"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["salesCash"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["salesCashContent"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["getSalesCash"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["saveSalesCash"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["closeSalesCash"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["getSalesCashRectification"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["saveSalesCashRectification"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["deleteSalesCashRectification"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["getSalesCashTransaction"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["saveSalesCashTransaction"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["deleteSalesCashTransaction"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["getSalesCashIncome"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["saveSalesCashIncome"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["deleteSalesCashIncome"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["getSalesCashExpense"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["saveSalesCashExpense"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["deleteSalesCashExpense"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["paymentsReportFile"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["downPaymentsReportFile"],
      subject: ["DownPayment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["salesCashReportFile"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["pettyCashReport"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["salesReports"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["serviceProvidersReport"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["usersReport"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["cashiersReport"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["serviceProvidersReportFile"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["internalSalesReportFile"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["usersReportFile"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["cashiersReportFile"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["saveInternalSale"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["deleteInternalSale"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["getInternalSale"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["getProductForPaymentOrSale"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["getProductsForPaymentOrSale"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["getProductBrandsForPaymentOrSale"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["getProductCategoriesForPaymentOrSale"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["read"],
      subject: ["SurveyConstruct"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["destroy"],
      subject: ["SurveyConstruct"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["create"],
      subject: ["SurveyConstruct"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["update"],
      subject: ["SurveyConstruct"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["read"],
      subject: ["SurveyAnswer"],
      conditions: {
        booking: {
          client: {
            companyId: 3
          }
        }
      }
    }, {
      action: ["destroy"],
      subject: ["SurveyAnswer"],
      conditions: {
        booking: {
          client: {
            companyId: 3
          }
        }
      }
    }, {
      action: ["update"],
      subject: ["SurveyAnswer"],
      conditions: {
        booking: {
          client: {
            companyId: 3
          }
        }
      }
    }, {
      action: ["statusDetails"],
      subject: ["SurveyAnswer"]
    }, {
      action: ["statusDetailsQuestions"],
      subject: ["SurveyAnswer"]
    }, {
      action: ["read"],
      subject: ["User"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["destroy"],
      subject: ["User"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["create"],
      subject: ["User"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["update"],
      subject: ["User"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["read"],
      subject: ["Location"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["destroy"],
      subject: ["Location"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["create"],
      subject: ["Location"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["update"],
      subject: ["Location"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["read"],
      subject: ["ServiceProvider"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["destroy"],
      subject: ["ServiceProvider"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["create"],
      subject: ["ServiceProvider"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["update"],
      subject: ["ServiceProvider"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["read"],
      subject: ["Service"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["destroy"],
      subject: ["Service"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["create"],
      subject: ["Service"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["update"],
      subject: ["Service"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["read"],
      subject: ["Bundle"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["destroy"],
      subject: ["Bundle"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["create"],
      subject: ["Bundle"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["update"],
      subject: ["Bundle"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["read"],
      subject: ["CompanySetting"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["destroy"],
      subject: ["CompanySetting"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["create"],
      subject: ["CompanySetting"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["update"],
      subject: ["CompanySetting"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["read"],
      subject: ["ServiceCategory"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["destroy"],
      subject: ["ServiceCategory"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["create"],
      subject: ["ServiceCategory"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["update"],
      subject: ["ServiceCategory"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["read"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["destroy"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["create"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["update"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["read"],
      subject: ["BillingInfo"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["destroy"],
      subject: ["BillingInfo"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["create"],
      subject: ["BillingInfo"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["update"],
      subject: ["BillingInfo"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["read"],
      subject: ["ProviderGroup"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["destroy"],
      subject: ["ProviderGroup"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["create"],
      subject: ["ProviderGroup"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["update"],
      subject: ["ProviderGroup"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["customization"],
      subject: ["CompanySetting"]
    }, {
      action: ["updateCustomization"],
      subject: ["CompanySetting"]
    }, {
      action: ["inactiveIndex"],
      subject: ["Location"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["activate"],
      subject: ["Location"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["deactivate"],
      subject: ["Location"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["deactivateNow"],
      subject: ["Location"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["inactiveIndex"],
      subject: ["Service"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["activate"],
      subject: ["Service"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["deactivate"],
      subject: ["Service"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["inactiveIndex"],
      subject: ["ServiceProvider"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["activate"],
      subject: ["ServiceProvider"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["deactivate"],
      subject: ["ServiceProvider"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["read"],
      subject: ["LocationTime"],
      conditions: {
        location: {
          companyId: 3
        }
      }
    }, {
      action: ["destroy"],
      subject: ["LocationTime"],
      conditions: {
        location: {
          companyId: 3
        }
      }
    }, {
      action: ["create"],
      subject: ["LocationTime"],
      conditions: {
        location: {
          companyId: 3
        }
      }
    }, {
      action: ["update"],
      subject: ["LocationTime"],
      conditions: {
        location: {
          companyId: 3
        }
      }
    }, {
      action: ["read"],
      subject: ["ProviderTime"],
      conditions: {
        serviceProvider: {
          companyId: 3
        }
      }
    }, {
      action: ["destroy"],
      subject: ["ProviderTime"],
      conditions: {
        serviceProvider: {
          companyId: 3
        }
      }
    }, {
      action: ["create"],
      subject: ["ProviderTime"],
      conditions: {
        serviceProvider: {
          companyId: 3
        }
      }
    }, {
      action: ["update"],
      subject: ["ProviderTime"],
      conditions: {
        serviceProvider: {
          companyId: 3
        }
      }
    }, {
      action: ["read"],
      subject: ["Booking"],
      conditions: {
        serviceProvider: {
          companyId: 3
        }
      }
    }, {
      action: ["destroy"],
      subject: ["Booking"],
      conditions: {
        serviceProvider: {
          companyId: 3
        }
      }
    }, {
      action: ["create"],
      subject: ["Booking"],
      conditions: {
        serviceProvider: {
          companyId: 3
        }
      }
    }, {
      action: ["update"],
      subject: ["Booking"],
      conditions: {
        serviceProvider: {
          companyId: 3
        }
      }
    }, {
      action: ["read"],
      subject: ["Resource"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["destroy"],
      subject: ["Resource"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["create"],
      subject: ["Resource"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["update"],
      subject: ["Resource"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["read"],
      subject: ["ResourceCategory"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["destroy"],
      subject: ["ResourceCategory"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["create"],
      subject: ["ResourceCategory"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["update"],
      subject: ["ResourceCategory"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["read"],
      subject: ["Product"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["destroy"],
      subject: ["Product"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["create"],
      subject: ["Product"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["update"],
      subject: ["Product"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["edit"],
      subject: ["Product"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["read"],
      subject: ["ProductCategory"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["destroy"],
      subject: ["ProductCategory"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["create"],
      subject: ["ProductCategory"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["update"],
      subject: ["ProductCategory"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["read"],
      subject: ["ProductBrand"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["destroy"],
      subject: ["ProductBrand"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["create"],
      subject: ["ProductBrand"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["update"],
      subject: ["ProductBrand"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["read"],
      subject: ["ProductDisplay"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["destroy"],
      subject: ["ProductDisplay"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["create"],
      subject: ["ProductDisplay"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["update"],
      subject: ["ProductDisplay"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["providerService"],
      subject: ["ServiceProvider"]
    }, {
      action: ["getLink"],
      subject: ["Company"]
    }, {
      action: ["statementPdf"],
      subject: ["Company"]
    }, {
      action: ["history"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["nameSuggestion"],
      subject: ["Client"]
    }, {
      action: ["suggestion"],
      subject: ["Client"]
    }, {
      action: ["rutSuggestion"],
      subject: ["Client"]
    }, {
      action: ["bookingsHistory"],
      subject: ["Client"]
    }, {
      action: ["checkSessions"],
      subject: ["Client"]
    }, {
      action: ["membershipHistory"],
      subject: ["Client"]
    }, {
      action: ["bookingsContent"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["treatmentsContent"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["pastPayments"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["associatePayment"],
      subject: ["Booking"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["associateDownPayment"],
      subject: ["Booking"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["getChartTemplate"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["bookingPayment"],
      subject: ["Payment"]
    }, {
      action: ["loadPayment"],
      subject: ["Payment"]
    }, {
      action: ["pastBookings"],
      subject: ["Payment"]
    }, {
      action: ["pastSessions"],
      subject: ["Payment"]
    }, {
      action: ["clientBookings"],
      subject: ["Payment"]
    }, {
      action: ["clientTreatments"],
      subject: ["Payment"]
    }, {
      action: ["clientSessions"],
      subject: ["Payment"]
    }, {
      action: ["clientDownPayments"],
      subject: ["Payment"]
    }, {
      action: ["getDownPayment"],
      subject: ["Payment"]
    }, {
      action: ["indexContent"],
      subject: ["Payment"]
    }, {
      action: ["getLocationReceiptNumber"],
      subject: ["Payment"]
    }, {
      action: ["read"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["destroy"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["create"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["update"],
      subject: ["Payment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["pagoFacilDetail"],
      subject: ["Payment"]
    }, {
      action: ["epaycoDetail"],
      subject: ["Payment"]
    }, {
      action: ["payDlocal"],
      subject: ["Payment"]
    }, {
      action: ["dlocalPaymentDetail"],
      subject: ["Payment"]
    }, {
      action: ["dlocalDetail"],
      subject: ["Payment"]
    }, {
      action: ["read"],
      subject: ["DownPayment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["destroy"],
      subject: ["DownPayment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["create"],
      subject: ["DownPayment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["update"],
      subject: ["DownPayment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["deleteDownPayment"],
      subject: ["DownPayment"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["indexContent"],
      subject: ["DownPayment"]
    }, {
      action: ["loadDownPayment"],
      subject: ["DownPayment"]
    }, {
      action: ["createComment"],
      subject: ["Client"]
    }, {
      action: ["updateComment"],
      subject: ["Client"]
    }, {
      action: ["destroyComment"],
      subject: ["Client"]
    }, {
      action: ["destroy"],
      subject: ["Client"]
    }, {
      action: ["create"],
      subject: ["Client"]
    }, {
      action: ["merge"],
      subject: ["Client"]
    }, {
      action: ["bookingPaymentInfo"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["composeMail"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["savedTemplates"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["sendMail"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["campaignsReportContent"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["campaignReportDetails"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["clientBookings"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["import"],
      subject: ["Client"]
    }, {
      action: ["download"],
      subject: ["Client"]
    }, {
      action: ["fileGeneration"],
      subject: ["Client"]
    }, {
      action: ["emailReports"],
      subject: ["Client"]
    }, {
      action: ["show"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["import"],
      subject: ["Product"]
    }, {
      action: ["download"],
      subject: ["Product"]
    }, {
      action: ["fileGeneration"],
      subject: ["Product"]
    }, {
      action: ["changeCategoriesOrder"],
      subject: ["ServiceCategory"]
    }, {
      action: ["changeServicesOrder"],
      subject: ["Service"]
    }, {
      action: ["changeLocationOrder"],
      subject: ["Location"]
    }, {
      action: ["changeProvidersOrder"],
      subject: ["ServiceProvider"]
    }, {
      action: ["changeGroupsOrder"],
      subject: ["ProviderGroup"]
    }, {
      action: ["newTimeResourceGroup"],
      subject: ["ProviderGroup"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["indexTimeResourceGroup"],
      subject: ["ProviderGroup"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["editTimeResourceGroup"],
      subject: ["ProviderGroup"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["countryRegions"],
      subject: ["Region"]
    }, {
      action: ["regionCities"],
      subject: ["City"]
    }, {
      action: ["cityDistrics"],
      subject: ["District"]
    }, {
      action: ["deleteFacebookPages"],
      subject: ["CompanySetting"]
    }, {
      action: ["setPromotions"],
      subject: ["Service"]
    }, {
      action: ["setServicePromoTimes"],
      subject: ["Service"]
    }, {
      action: ["read"],
      subject: ["CompanyPaymentMethod"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["create"],
      subject: ["CompanyPaymentMethod"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["update"],
      subject: ["CompanyPaymentMethod"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["destroy"],
      subject: ["CompanyPaymentMethod"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["activate"],
      subject: ["CompanyPaymentMethod"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["deactivate"],
      subject: ["CompanyPaymentMethod"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["show"],
      subject: ["Cashier"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["create"],
      subject: ["Cashier"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["update"],
      subject: ["Cashier"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["destroy"],
      subject: ["Cashier"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["activate"],
      subject: ["Cashier"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["deactivate"],
      subject: ["Cashier"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["show"],
      subject: ["EmployeeCode"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["create"],
      subject: ["EmployeeCode"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["update"],
      subject: ["EmployeeCode"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["destroy"],
      subject: ["EmployeeCode"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["activate"],
      subject: ["EmployeeCode"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["deactivate"],
      subject: ["EmployeeCode"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["show"],
      subject: ["ApiPostUrl"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["create"],
      subject: ["ApiPostUrl"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["update"],
      subject: ["ApiPostUrl"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["destroy"],
      subject: ["ApiPostUrl"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["activate"],
      subject: ["ApiPostUrl"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["deactivate"],
      subject: ["ApiPostUrl"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["show"],
      subject: ["CustomAttribute"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["create"],
      subject: ["CustomAttribute"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["update"],
      subject: ["CustomAttribute"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["destroy"],
      subject: ["CustomAttribute"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["editForm"],
      subject: ["CustomAttribute"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["show"],
      subject: ["AttributeCategory"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["create"],
      subject: ["AttributeCategory"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["update"],
      subject: ["AttributeCategory"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["destroy"],
      subject: ["AttributeCategory"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["show"],
      subject: ["AttributeGroup"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["create"],
      subject: ["AttributeGroup"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["update"],
      subject: ["AttributeGroup"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["destroy"],
      subject: ["AttributeGroup"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["editForm"],
      subject: ["AttributeGroup"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["show"],
      subject: ["ChartField"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["create"],
      subject: ["ChartField"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["update"],
      subject: ["ChartField"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["destroy"],
      subject: ["ChartField"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["editForm"],
      subject: ["ChartField"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["show"],
      subject: ["Membership"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["create"],
      subject: ["Membership"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["update"],
      subject: ["Membership"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["destroy"],
      subject: ["Membership"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["index"],
      subject: ["Membership"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["summary"],
      subject: ["Membership"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["deactivate"],
      subject: ["Membership"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["activate"],
      subject: ["Membership"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["inactiveIndex"],
      subject: ["Membership"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["indexMembership"],
      subject: ["Membership"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["indexContent"],
      subject: ["Membership"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["clientIndexContent"],
      subject: ["Membership"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["getMembershipsForPaymentOrSale"],
      subject: ["Membership"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["sellers"],
      subject: ["Membership"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["getMembershipForPaymentOrSale"],
      subject: ["Membership"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["getRutClient"],
      subject: ["Membership"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["saveRutClient"],
      subject: ["Membership"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["detail"],
      subject: ["Membership"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["membershipsHistory"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["show"],
      subject: ["ChartCategory"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["create"],
      subject: ["ChartCategory"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["update"],
      subject: ["ChartCategory"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["destroy"],
      subject: ["ChartCategory"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["show"],
      subject: ["ChartGroup"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["create"],
      subject: ["ChartGroup"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["update"],
      subject: ["ChartGroup"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["destroy"],
      subject: ["ChartGroup"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["editForm"],
      subject: ["ChartGroup"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["show"],
      subject: ["ClientFile"],
      conditions: {
        client: {
          companyId: 3
        }
      }
    }, {
      action: ["create"],
      subject: ["ClientFile"],
      conditions: {
        client: {
          companyId: 3
        }
      }
    }, {
      action: ["update"],
      subject: ["ClientFile"],
      conditions: {
        client: {
          companyId: 3
        }
      }
    }, {
      action: ["destroy"],
      subject: ["ClientFile"],
      conditions: {
        client: {
          companyId: 3
        }
      }
    }, {
      action: ["show"],
      subject: ["LocationResolution"],
      conditions: {
        location: {
          companyId: 3
        }
      }
    }, {
      action: ["create"],
      subject: ["LocationResolution"],
      conditions: {
        location: {
          companyId: 3
        }
      }
    }, {
      action: ["update"],
      subject: ["LocationResolution"],
      conditions: {
        location: {
          companyId: 3
        }
      }
    }, {
      action: ["destroy"],
      subject: ["LocationResolution"],
      conditions: {
        location: {
          companyId: 3
        }
      }
    }, {
      action: ["show"],
      subject: ["CompanyFile"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["create"],
      subject: ["CompanyFile"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["update"],
      subject: ["CompanyFile"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["destroy"],
      subject: ["CompanyFile"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["getAttributeCategories"],
      subject: ["CustomAttribute"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["getChartCategories"],
      subject: ["ChartField"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["getChartMultiples"],
      subject: ["ChartField"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["updateCustomAttributes"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["files"],
      subject: ["Company"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["uploadFile"],
      subject: ["Company"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["createFolder"],
      subject: ["Company"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["renameFolder"],
      subject: ["Company"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["deleteFolder"],
      subject: ["Company"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["moveFile"],
      subject: ["Company"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["editFile"],
      subject: ["Company"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["files"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["uploadFile"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["uploadPhoto"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["commentsTemplate"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["clientsTracing"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["createFolder"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["renameFolder"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["deleteFolder"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["moveFile"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["editFile"],
      subject: ["Client"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["generateClientsBase"],
      subject: ["Company"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["importServicesExcel"],
      subject: ["Company"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["importAddonServicesExcel"],
      subject: ["Company"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["read"],
      subject: ["Deal"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["create"],
      subject: ["Deal"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["update"],
      subject: ["Deal"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["pendingBillingWireTransfers"],
      subject: ["Company"]
    }, {
      action: ["approvedBillingWireTransfers"],
      subject: ["Company"]
    }, {
      action: ["showBillingWireTransfer"],
      subject: ["Company"]
    }, {
      action: ["approveBillingWireTransfer"],
      subject: ["Company"]
    }, {
      action: ["deleteBillingWireTransfer"],
      subject: ["Company"]
    }, {
      action: ["saveBillingWireTransfer"],
      subject: ["Plan"]
    }, {
      action: ["read"],
      subject: ["AppFeed"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["create"],
      subject: ["AppFeed"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["update"],
      subject: ["AppFeed"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["destroy"],
      subject: ["AppFeed"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["printInvoice"],
      subject: ["Company"]
    }, {
      action: ["emailMarketingBlacklists"],
      subject: ["User"]
    }, {
      action: ["read"],
      subject: ["EmailMarketingBlacklist"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["create"],
      subject: ["EmailMarketingBlacklist"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["update"],
      subject: ["EmailMarketingBlacklist"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["destroy"],
      subject: ["EmailMarketingBlacklist"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["create"],
      subject: ["EmailAudience"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["destroy"],
      subject: ["EmailAudience"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["addClients"],
      subject: ["EmailAudience"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["removeClients"],
      subject: ["EmailAudience"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["show"],
      subject: ["EmailAudience"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["update"],
      subject: ["EmailAudience"],
      conditions: {
        companyId: 3
      }
    }, {
      action: ["create"],
      subject: ["POSPayment"]
    }, {
      action: ["show"],
      subject: ["Clients"]
    }, {
      action: ["create"],
      subject: ["Clients"]
    }],
    notificationBar: false,
    notificationMessage: "",
    searchBarVisible: true,
    isSoloPlan: false,
    employeeNumber: "6-15",
    endTrialDate: "2022-04-07",
    onlinePaymentCommercialCommission: "2,8% + IVA",
    showBannerOnlinePayment: false,
    minisiteV2Active: false,
    urlFrontendWorkflow: "https://negociodeteamarquitectura.site.agendaprodev.com/cl"
  },
  currencyFormat: {
    delimiter: ".",
    separator: ",",
    unit: "$",
    precision: 0
  },
  featureFlag: {
    ripsV2: true,
    whatsappTemplates: true
  }
};

var createZodApiFetcher = function createZodApiFetcher(api) {
  return function (url, schema, params) {
    return /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _yield$api$get, data, result;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return api.get(url, {
              params: params
            });
          case 2:
            _yield$api$get = _context.sent;
            data = _yield$api$get.data;
            _context.next = 6;
            return schema.spa(data);
          case 6:
            result = _context.sent;
            if (!(result.success === false)) {
              _context.next = 10;
              break;
            }
            console.error(result.error.issues, {
              depth: null
            });
            throw new Error("Validation failed for " + url);
          case 10:
            return _context.abrupt("return", result.data);
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
  };
};

var getValidatedEnvs = function getValidatedEnvs(envs, keyStartsWith, schema) {
  var filteredEnvs = Object.entries(envs).reduce(function (result, _ref) {
    var key = _ref[0],
      value = _ref[1];
    if (keyStartsWith.some(function (keyStartWith) {
      return key.startsWith(keyStartWith);
    })) {
      var _extends2;
      return _extends({}, result, (_extends2 = {}, _extends2[key] = value, _extends2));
    }
    return result;
  }, {});
  var validationResult = schema.safeParse(filteredEnvs);
  if (!validationResult.success) {
    console.error('❌ Invalid environment variables:');
    validationResult.error.issues.forEach(function (issue) {
      console.error(issue.path.join('.') + ": " + issue.message);
    });
    throw new Error('Invalid environment configuration');
  }
  return Object.entries(validationResult.data).reduce(function (result, _ref2) {
    var _extends3;
    var key = _ref2[0],
      value = _ref2[1];
    return _extends({}, result, (_extends3 = {}, _extends3[key] = JSON.stringify(value), _extends3));
  }, {});
};

export { apm as APM, cleanDni, createZodApiFetcher, deleteCookie, environments as environment, formatAMPM, formatDni, formatPriceToNumber, getCookie, getEnvs as getEnvValues, getValidatedEnvs, i18n, mockedCompanySettings, queryClient, sentry, setCookie, useFormatPrice, useGetNavbarHeight, validateChileanRut };
//# sourceMappingURL=sapphire.esm.js.map
